export const DEMO_HISTORICAL_DATA = {
    rounds_logged: 365,
    rounds: [
        {
            id: 1853,
            round_date: '2024-11-17T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1853,
            strokes_gained_round: {
                tee: 1.08178,
                sand: 0.0,
                approach: -4.02411,
                putting: -2.54487,
                around_green: 0.80478,
                recovery: 0.0,
                rough_inside_150: -0.61629,
                rough_outside_150: -0.42187,
                fairway_50_to_100: -1.79996,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.19817,
                fairway_outside_200: -0.08049,
                putting_inside_5: -1.10826,
                putting_5_to_10: 0.26062,
                putting_10_to_15: -1.85566,
                putting_15_to_20: -0.65782,
                putting_20_to_30: 0.53671,
                putting_outside_30: 0.27954,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.35051,
                rough_around_green_15: 0.65414,
                rough_around_green_30: 0.50115,
                total: -4.68242,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 3,
                green_in_regulation_percentage: 0.6111,
                total_putts: 34,
                three_putt_percentage: 0.1667,
                average_driving_distance: 320.5,
                eagles: 0,
                birdies: 2,
                pars: 12,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.9,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1852,
            round_date: '2024-11-16T00:00:00-06:00',
            number_of_holes: 9,
            possible_error_holes: 0,
            number_of_holes_complete: 0,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1852,
            strokes_gained_round: {
                tee: 0.0,
                sand: 0.0,
                approach: 0.0,
                putting: 0.0,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.0,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.0,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.0,
                score_to_par: 0,
                green_in_regulation_percentage: 0.0,
                total_putts: 0,
                three_putt_percentage: 0.0,
                average_driving_distance: 0.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 0,
            },
            par: 0,
            strokes_total: 0,
        },
        {
            id: 1851,
            round_date: '2024-11-15T00:00:00-06:00',
            number_of_holes: 9,
            possible_error_holes: 0,
            number_of_holes_complete: 9,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1851,
            strokes_gained_round: {
                tee: -0.06502,
                sand: 0.0,
                approach: 0.23096,
                putting: 2.52295,
                around_green: 0.29343,
                recovery: 0.0,
                rough_inside_150: 1.06454,
                rough_outside_150: 0.10414,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.29509,
                fairway_150_to_200: -0.70836,
                fairway_outside_200: 0.38774,
                putting_inside_5: 1.16425,
                putting_5_to_10: 0.73149,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.62721,
                fairway_around_green_15: -0.02858,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.32201,
                rough_around_green_30: 0.0,
                total: 2.98232,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.8,
                score_to_par: -8,
                green_in_regulation_percentage: 0.8889,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 306.8,
                eagles: 0,
                birdies: 8,
                pars: 10,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 36,
            strokes_total: 32,
        },
        {
            id: 1850,
            round_date: '2024-11-14T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1850,
            strokes_gained_round: {
                tee: 2.83834,
                sand: 0.0,
                approach: -2.32248,
                putting: -1.49451,
                around_green: -0.29919,
                recovery: 0.0,
                rough_inside_150: -0.74584,
                rough_outside_150: -0.46198,
                fairway_50_to_100: -0.99127,
                fairway_100_to_150: 0.41572,
                fairway_150_to_200: -0.16865,
                fairway_outside_200: -0.39487,
                putting_inside_5: 0.90146,
                putting_5_to_10: 0.0467,
                putting_10_to_15: 0.58005,
                putting_15_to_20: -3.22762,
                putting_20_to_30: -0.17276,
                putting_outside_30: 0.37766,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.32496,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.02577,
                total: -1.27784,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 0,
                green_in_regulation_percentage: 0.8333,
                total_putts: 34,
                three_putt_percentage: 0.0556,
                average_driving_distance: 336.57143,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.6,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1849,
            round_date: '2024-11-13T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1849,
            strokes_gained_round: {
                tee: 2.24975,
                sand: 0.0,
                approach: -2.73966,
                putting: 5.66909,
                around_green: 0.79395,
                recovery: 0.0,
                rough_inside_150: 1.09811,
                rough_outside_150: -0.14678,
                fairway_50_to_100: -1.63884,
                fairway_100_to_150: -0.80312,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.17647,
                putting_inside_5: 1.50729,
                putting_5_to_10: 1.12775,
                putting_10_to_15: 1.601,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 1.35989,
                putting_outside_30: 0.44087,
                fairway_around_green_15: -0.28664,
                fairway_around_green_30: -0.06841,
                rough_around_green_15: 0.7843,
                rough_around_green_30: 0.36469,
                total: 5.97313,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7778,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 302.35714,
                eagles: 0,
                birdies: 8,
                pars: 9,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1848,
            round_date: '2024-11-12T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1848,
            strokes_gained_round: {
                tee: 0.34088,
                sand: 0.0,
                approach: 0.7621,
                putting: -1.95753,
                around_green: 0.52972,
                recovery: 0.0,
                rough_inside_150: 1.57261,
                rough_outside_150: -0.03085,
                fairway_50_to_100: -0.2951,
                fairway_100_to_150: 0.35137,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.10074,
                putting_inside_5: -0.45981,
                putting_5_to_10: 0.36598,
                putting_10_to_15: -1.96537,
                putting_15_to_20: 0.30965,
                putting_20_to_30: -0.48464,
                putting_outside_30: 0.27665,
                fairway_around_green_15: -0.37181,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.49437,
                rough_around_green_30: 0.40715,
                total: -0.32483,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 291.5,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1847,
            round_date: '2024-11-11T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1847,
            strokes_gained_round: {
                tee: 3.57077,
                sand: 0.0,
                approach: 0.07294,
                putting: 1.33595,
                around_green: 0.09256,
                recovery: 0.0,
                rough_inside_150: 0.87775,
                rough_outside_150: -0.01614,
                fairway_50_to_100: 0.10478,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.14532,
                putting_inside_5: 1.55237,
                putting_5_to_10: -0.25728,
                putting_10_to_15: -0.29845,
                putting_15_to_20: -0.63274,
                putting_20_to_30: -0.32424,
                putting_outside_30: 1.29629,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.5507,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.64325,
                total: 5.07222,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 328.78571,
                eagles: 0,
                birdies: 6,
                pars: 12,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1846,
            round_date: '2024-11-10T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1846,
            strokes_gained_round: {
                tee: 3.0816,
                sand: 0.0,
                approach: -1.81115,
                putting: 1.12032,
                around_green: -0.16416,
                recovery: 0.0,
                rough_inside_150: 0.08838,
                rough_outside_150: -0.6039,
                fairway_50_to_100: -1.56727,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.19724,
                putting_inside_5: 1.78017,
                putting_5_to_10: -0.16641,
                putting_10_to_15: 0.0385,
                putting_15_to_20: -0.7094,
                putting_20_to_30: -0.39142,
                putting_outside_30: 0.56889,
                fairway_around_green_15: -0.22151,
                fairway_around_green_30: 0.07858,
                rough_around_green_15: -0.1963,
                rough_around_green_30: 0.17507,
                total: 2.22661,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 332.07143,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1845,
            round_date: '2024-11-09T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1845,
            strokes_gained_round: {
                tee: 1.32251,
                sand: 0.0,
                approach: -2.73662,
                putting: -0.86194,
                around_green: 2.12539,
                recovery: 0.0,
                rough_inside_150: 1.64636,
                rough_outside_150: -0.15554,
                fairway_50_to_100: -2.2829,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.288,
                putting_inside_5: -0.25935,
                putting_5_to_10: -0.30336,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.30965,
                putting_20_to_30: -0.34742,
                putting_outside_30: 0.15972,
                fairway_around_green_15: -0.02858,
                fairway_around_green_30: 0.49742,
                rough_around_green_15: 1.58735,
                rough_around_green_30: 0.06919,
                total: -0.15066,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 29,
                three_putt_percentage: 0.1111,
                average_driving_distance: 306.78571,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1844,
            round_date: '2024-11-08T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1844,
            strokes_gained_round: {
                tee: 2.22937,
                sand: 0.0,
                approach: -3.8652,
                putting: 1.20969,
                around_green: -0.5705,
                recovery: 0.0,
                rough_inside_150: 0.69147,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.72506,
                fairway_100_to_150: -1.26358,
                fairway_150_to_200: -0.87181,
                fairway_outside_200: -0.36603,
                putting_inside_5: 1.09824,
                putting_5_to_10: -0.60829,
                putting_10_to_15: 0.48619,
                putting_15_to_20: 1.35473,
                putting_20_to_30: -1.47243,
                putting_outside_30: 0.35125,
                fairway_around_green_15: -0.1635,
                fairway_around_green_30: -1.03331,
                rough_around_green_15: 0.27063,
                rough_around_green_30: 0.35569,
                total: -0.99664,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -1,
                green_in_regulation_percentage: 0.6111,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 315.42857,
                eagles: 0,
                birdies: 6,
                pars: 7,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1843,
            round_date: '2024-11-07T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1843,
            strokes_gained_round: {
                tee: 1.22386,
                sand: 0.0,
                approach: -1.55802,
                putting: 0.4574,
                around_green: -0.73185,
                recovery: 0.0,
                rough_inside_150: -0.96333,
                rough_outside_150: 1.36991,
                fairway_50_to_100: -1.27432,
                fairway_100_to_150: -0.17295,
                fairway_150_to_200: -0.1179,
                fairway_outside_200: 0.0,
                putting_inside_5: -1.08389,
                putting_5_to_10: 0.53431,
                putting_10_to_15: -0.53381,
                putting_15_to_20: 0.70387,
                putting_20_to_30: 0.55848,
                putting_outside_30: 0.27845,
                fairway_around_green_15: -0.86758,
                fairway_around_green_30: 0.02387,
                rough_around_green_15: 0.11186,
                rough_around_green_30: 0.0,
                total: -0.60861,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 32,
                three_putt_percentage: 0.1667,
                average_driving_distance: 308.0,
                eagles: 1,
                birdies: 4,
                pars: 8,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1842,
            round_date: '2024-11-06T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1842,
            strokes_gained_round: {
                tee: 0.15275,
                sand: 0.0,
                approach: -1.11425,
                putting: 1.07964,
                around_green: 0.61069,
                recovery: 0.0,
                rough_inside_150: 2.0211,
                rough_outside_150: 0.48785,
                fairway_50_to_100: -2.12742,
                fairway_100_to_150: -0.63479,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.35816,
                putting_inside_5: 1.57416,
                putting_5_to_10: -0.01484,
                putting_10_to_15: -0.42119,
                putting_15_to_20: -0.68527,
                putting_20_to_30: 0.62858,
                putting_outside_30: -0.0018,
                fairway_around_green_15: -0.13852,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.78629,
                rough_around_green_30: -0.03707,
                total: 0.72883,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6667,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 298.0,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1841,
            round_date: '2024-11-05T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1841,
            strokes_gained_round: {
                tee: 0.73902,
                sand: 0.0,
                approach: -2.63656,
                putting: -3.85002,
                around_green: 0.70443,
                recovery: 0.0,
                rough_inside_150: 0.46499,
                rough_outside_150: -0.03267,
                fairway_50_to_100: 0.51503,
                fairway_100_to_150: -0.99172,
                fairway_150_to_200: -0.57738,
                fairway_outside_200: -0.1495,
                putting_inside_5: 0.49619,
                putting_5_to_10: -0.60923,
                putting_10_to_15: -2.38948,
                putting_15_to_20: -1.29056,
                putting_20_to_30: -0.24232,
                putting_outside_30: 0.18538,
                fairway_around_green_15: -0.37242,
                fairway_around_green_30: 0.14829,
                rough_around_green_15: 0.30802,
                rough_around_green_30: 0.62054,
                total: -5.04313,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 35,
                three_putt_percentage: 0.1667,
                average_driving_distance: 304.57143,
                eagles: 0,
                birdies: 2,
                pars: 12,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 4.0,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1840,
            round_date: '2024-11-04T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1840,
            strokes_gained_round: {
                tee: 0.95535,
                sand: 0.0,
                approach: -2.60795,
                putting: 1.45794,
                around_green: -0.58398,
                recovery: 0.0,
                rough_inside_150: -1.37631,
                rough_outside_150: 1.45124,
                fairway_50_to_100: 0.44351,
                fairway_100_to_150: -1.8288,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.20361,
                putting_inside_5: 1.60776,
                putting_5_to_10: -0.69928,
                putting_10_to_15: -1.59438,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.46858,
                putting_outside_30: 1.67526,
                fairway_around_green_15: -0.16272,
                fairway_around_green_30: -0.42126,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: -0.77864,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 304.78571,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1839,
            round_date: '2024-11-03T02:15:52.26344-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1839,
            strokes_gained_round: {
                tee: 3.82852,
                sand: 0.0,
                approach: -5.28428,
                putting: -0.40803,
                around_green: -0.71695,
                recovery: 0.0,
                rough_inside_150: -2.35107,
                rough_outside_150: -0.46443,
                fairway_50_to_100: -2.10322,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.21788,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.40032,
                putting_5_to_10: -0.68526,
                putting_10_to_15: -0.50495,
                putting_15_to_20: -1.02553,
                putting_20_to_30: -0.24232,
                putting_outside_30: 1.64971,
                fairway_around_green_15: -0.65475,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.56177,
                rough_around_green_30: -0.62397,
                total: -2.58074,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 325.78571,
                eagles: 0,
                birdies: 4,
                pars: 9,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1838,
            round_date: '2024-11-02T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1838,
            strokes_gained_round: {
                tee: 1.12453,
                sand: 0.0,
                approach: 1.10766,
                putting: -0.39453,
                around_green: -0.73442,
                recovery: 0.0,
                rough_inside_150: 1.67731,
                rough_outside_150: 1.32397,
                fairway_50_to_100: -1.38409,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 2.05103,
                putting_5_to_10: -0.80833,
                putting_10_to_15: -1.59202,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 0.12582,
                putting_outside_30: 0.22317,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.79988,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.06545,
                total: 1.10323,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 316.07143,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1837,
            round_date: '2024-11-01T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1837,
            strokes_gained_round: {
                tee: 2.54366,
                sand: 0.0,
                approach: -1.16731,
                putting: -2.24227,
                around_green: 0.29484,
                recovery: 0.0,
                rough_inside_150: 1.37319,
                rough_outside_150: 0.43671,
                fairway_50_to_100: -0.48983,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.00063,
                putting_inside_5: 0.48753,
                putting_5_to_10: 0.32072,
                putting_10_to_15: -1.70548,
                putting_15_to_20: -0.68337,
                putting_20_to_30: -0.71005,
                putting_outside_30: 0.04838,
                fairway_around_green_15: 0.02,
                fairway_around_green_30: -0.57497,
                rough_around_green_15: 0.8498,
                rough_around_green_30: 0.0,
                total: -0.57108,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 325.21429,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1836,
            round_date: '2024-10-31T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1836,
            strokes_gained_round: {
                tee: 1.994,
                sand: 0.0,
                approach: -2.29592,
                putting: 0.23699,
                around_green: -0.04254,
                recovery: 0.0,
                rough_inside_150: 0.43454,
                rough_outside_150: 0.32093,
                fairway_50_to_100: -1.64132,
                fairway_100_to_150: -0.07406,
                fairway_150_to_200: -0.60264,
                fairway_outside_200: -0.02645,
                putting_inside_5: 1.11824,
                putting_5_to_10: 0.20051,
                putting_10_to_15: -1.06763,
                putting_15_to_20: -0.37467,
                putting_20_to_30: 0.07344,
                putting_outside_30: 0.28709,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.71611,
                rough_around_green_15: 0.67356,
                rough_around_green_30: 0.0,
                total: -0.10748,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 311.85714,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1835,
            round_date: '2024-10-30T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1835,
            strokes_gained_round: {
                tee: 2.68571,
                sand: 0.0,
                approach: -0.34017,
                putting: 0.20623,
                around_green: -0.60155,
                recovery: 0.0,
                rough_inside_150: 0.51026,
                rough_outside_150: 0.64401,
                fairway_50_to_100: -1.45168,
                fairway_100_to_150: -0.40618,
                fairway_150_to_200: -0.16258,
                fairway_outside_200: 0.81924,
                putting_inside_5: 0.20497,
                putting_5_to_10: -0.25823,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.38726,
                putting_20_to_30: -1.04882,
                putting_outside_30: 1.34224,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.89478,
                rough_around_green_15: 0.35445,
                rough_around_green_30: -0.06122,
                total: 1.95023,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 319.5,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1834,
            round_date: '2024-10-29T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1834,
            strokes_gained_round: {
                tee: 3.30711,
                sand: 0.0,
                approach: -1.57127,
                putting: 0.5439,
                around_green: -0.53516,
                recovery: 0.0,
                rough_inside_150: 0.17113,
                rough_outside_150: 0.0,
                fairway_50_to_100: -1.64224,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.39218,
                fairway_outside_200: -0.12325,
                putting_inside_5: 1.4544,
                putting_5_to_10: 0.36598,
                putting_10_to_15: -0.34513,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -0.8084,
                putting_outside_30: 0.24476,
                fairway_around_green_15: -0.26304,
                fairway_around_green_30: -0.54246,
                rough_around_green_15: 0.33098,
                rough_around_green_30: -0.06064,
                total: 1.74459,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 317.21429,
                eagles: 1,
                birdies: 3,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1833,
            round_date: '2024-10-28T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1833,
            strokes_gained_round: {
                tee: 1.21165,
                sand: 0.0,
                approach: -2.79227,
                putting: -2.83982,
                around_green: 0.46261,
                recovery: 0.0,
                rough_inside_150: 0.84083,
                rough_outside_150: -0.2826,
                fairway_50_to_100: -2.19342,
                fairway_100_to_150: -0.78506,
                fairway_150_to_200: 0.32097,
                fairway_outside_200: 0.0,
                putting_inside_5: -2.64063,
                putting_5_to_10: -0.76162,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.65229,
                putting_20_to_30: -0.3896,
                putting_outside_30: 0.29974,
                fairway_around_green_15: -0.23037,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.62033,
                rough_around_green_30: 0.07264,
                total: -3.95783,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 3,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 34,
                three_putt_percentage: 0.1111,
                average_driving_distance: 296.85714,
                eagles: 0,
                birdies: 3,
                pars: 10,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.2,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1832,
            round_date: '2024-10-27T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1832,
            strokes_gained_round: {
                tee: 3.00304,
                sand: 0.0,
                approach: -4.03957,
                putting: -0.77532,
                around_green: -0.57352,
                recovery: 0.0,
                rough_inside_150: -0.91343,
                rough_outside_150: 0.32937,
                fairway_50_to_100: -1.48162,
                fairway_100_to_150: -0.73715,
                fairway_150_to_200: -0.45036,
                fairway_outside_200: 0.21188,
                putting_inside_5: 1.6286,
                putting_5_to_10: -0.68526,
                putting_10_to_15: 0.36186,
                putting_15_to_20: 0.72894,
                putting_20_to_30: -2.75545,
                putting_outside_30: -0.05401,
                fairway_around_green_15: -0.37609,
                fairway_around_green_30: -0.4072,
                rough_around_green_15: 0.2434,
                rough_around_green_30: -0.03363,
                total: -2.38538,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 35,
                three_putt_percentage: 0.1111,
                average_driving_distance: 318.35714,
                eagles: 0,
                birdies: 2,
                pars: 13,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.1,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1831,
            round_date: '2024-10-26T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1831,
            strokes_gained_round: {
                tee: 3.98274,
                sand: 0.0,
                approach: -4.63817,
                putting: -0.75109,
                around_green: 1.9576,
                recovery: 0.0,
                rough_inside_150: 0.0417,
                rough_outside_150: -0.26366,
                fairway_50_to_100: -1.20002,
                fairway_100_to_150: -0.62951,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.12086,
                putting_inside_5: 0.39738,
                putting_5_to_10: -0.22841,
                putting_10_to_15: -0.47655,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.79049,
                putting_outside_30: 0.66312,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.9576,
                rough_around_green_30: 0.0,
                total: 0.55108,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 317.78571,
                eagles: 0,
                birdies: 3,
                pars: 14,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.1,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1830,
            round_date: '2024-10-25T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1830,
            strokes_gained_round: {
                tee: 3.11363,
                sand: 0.0,
                approach: -4.61964,
                putting: -2.45221,
                around_green: 0.429,
                recovery: 0.0,
                rough_inside_150: 0.79163,
                rough_outside_150: -0.07591,
                fairway_50_to_100: -0.8367,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.28767,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.54245,
                putting_5_to_10: -1.23391,
                putting_10_to_15: -2.30666,
                putting_15_to_20: 0.43789,
                putting_20_to_30: -0.37919,
                putting_outside_30: 0.48722,
                fairway_around_green_15: -0.36064,
                fairway_around_green_30: -0.41023,
                rough_around_green_15: 0.91602,
                rough_around_green_30: 0.28385,
                total: -3.52921,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 2,
                green_in_regulation_percentage: 0.7778,
                total_putts: 34,
                three_putt_percentage: 0.1667,
                average_driving_distance: 338.42857,
                eagles: 0,
                birdies: 4,
                pars: 9,
                bogeys: 4,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.25,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1829,
            round_date: '2024-10-24T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1829,
            strokes_gained_round: {
                tee: 0.63021,
                sand: 0.0,
                approach: -3.04066,
                putting: 1.04046,
                around_green: 0.53702,
                recovery: 0.0,
                rough_inside_150: 0.96404,
                rough_outside_150: -0.23997,
                fairway_50_to_100: -1.75669,
                fairway_100_to_150: -0.81011,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.06122,
                putting_inside_5: 1.35512,
                putting_5_to_10: -0.22699,
                putting_10_to_15: -0.47655,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.0516,
                putting_outside_30: 0.44049,
                fairway_around_green_15: 0.22401,
                fairway_around_green_30: -0.01789,
                rough_around_green_15: 0.33089,
                rough_around_green_30: 0.0,
                total: -0.83298,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6111,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 297.42857,
                eagles: 0,
                birdies: 2,
                pars: 14,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1828,
            round_date: '2024-10-23T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1828,
            strokes_gained_round: {
                tee: 1.3891,
                sand: 0.0,
                approach: -3.29788,
                putting: 2.86991,
                around_green: 2.43121,
                recovery: 0.0,
                rough_inside_150: 0.56636,
                rough_outside_150: -0.0061,
                fairway_50_to_100: -1.0582,
                fairway_100_to_150: -0.16206,
                fairway_150_to_200: 0.06603,
                fairway_outside_200: -0.02167,
                putting_inside_5: 1.30425,
                putting_5_to_10: -0.62326,
                putting_10_to_15: 0.12226,
                putting_15_to_20: 0.0451,
                putting_20_to_30: 1.58511,
                putting_outside_30: 0.43645,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.40889,
                rough_around_green_30: 1.02232,
                total: 3.39235,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 303.14286,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1827,
            round_date: '2024-10-22T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1827,
            strokes_gained_round: {
                tee: 1.69815,
                sand: 0.0,
                approach: -2.03273,
                putting: 3.66432,
                around_green: 0.95001,
                recovery: 0.0,
                rough_inside_150: 0.54231,
                rough_outside_150: 0.1063,
                fairway_50_to_100: -1.53881,
                fairway_100_to_150: -0.55305,
                fairway_150_to_200: 0.47929,
                fairway_outside_200: -0.15417,
                putting_inside_5: 2.2078,
                putting_5_to_10: 1.03547,
                putting_10_to_15: -0.32732,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.74837,
                fairway_around_green_15: -0.05137,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.58349,
                rough_around_green_30: 0.41789,
                total: 4.27976,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 293.92857,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1826,
            round_date: '2024-10-21T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1826,
            strokes_gained_round: {
                tee: 1.39314,
                sand: 0.0,
                approach: 0.87104,
                putting: 1.72342,
                around_green: 0.61736,
                recovery: 0.0,
                rough_inside_150: 1.7838,
                rough_outside_150: 0.76566,
                fairway_50_to_100: -0.92919,
                fairway_100_to_150: 0.30372,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.3864,
                putting_inside_5: 1.60042,
                putting_5_to_10: -2.72381,
                putting_10_to_15: 1.02963,
                putting_15_to_20: 0.65229,
                putting_20_to_30: 0.80134,
                putting_outside_30: 0.36356,
                fairway_around_green_15: -0.24296,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.35674,
                rough_around_green_30: 0.50359,
                total: 4.60496,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7222,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 304.42857,
                eagles: 0,
                birdies: 8,
                pars: 8,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1825,
            round_date: '2024-10-20T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1825,
            strokes_gained_round: {
                tee: 3.3977,
                sand: 0.0,
                approach: -1.77717,
                putting: 0.96414,
                around_green: 1.82342,
                recovery: 0.0,
                rough_inside_150: 2.52125,
                rough_outside_150: 0.07848,
                fairway_50_to_100: -2.24597,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.7997,
                putting_5_to_10: -0.22652,
                putting_10_to_15: -0.44863,
                putting_15_to_20: -0.68385,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.52344,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.76287,
                rough_around_green_30: 0.06055,
                total: 4.40809,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 334.85714,
                eagles: 0,
                birdies: 5,
                pars: 13,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1824,
            round_date: '2024-10-19T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1824,
            strokes_gained_round: {
                tee: 0.80206,
                sand: 0.0,
                approach: 2.77496,
                putting: 1.79841,
                around_green: 0.31093,
                recovery: 0.0,
                rough_inside_150: 3.89658,
                rough_outside_150: 0.64281,
                fairway_50_to_100: -0.59405,
                fairway_100_to_150: -0.65351,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.09103,
                putting_inside_5: 1.7837,
                putting_5_to_10: -0.94253,
                putting_10_to_15: 0.04718,
                putting_15_to_20: 0.62579,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.28428,
                fairway_around_green_15: -0.16415,
                fairway_around_green_30: -0.13283,
                rough_around_green_15: 0.48009,
                rough_around_green_30: 0.12781,
                total: 5.68636,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7778,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 299.35714,
                eagles: 0,
                birdies: 9,
                pars: 7,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.5,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1823,
            round_date: '2024-10-18T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1823,
            strokes_gained_round: {
                tee: 2.87106,
                sand: 0.0,
                approach: 0.95017,
                putting: -1.59547,
                around_green: 1.05149,
                recovery: 0.0,
                rough_inside_150: 2.52751,
                rough_outside_150: -0.14755,
                fairway_50_to_100: -0.03148,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.06546,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.8152,
                putting_5_to_10: -0.85294,
                putting_10_to_15: -0.92613,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.41508,
                putting_outside_30: 0.12517,
                fairway_around_green_15: -0.03348,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.83189,
                rough_around_green_30: 0.25309,
                total: 3.27726,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 334.78571,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1822,
            round_date: '2024-10-17T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1822,
            strokes_gained_round: {
                tee: 2.43901,
                sand: 0.0,
                approach: 3.05583,
                putting: -2.0245,
                around_green: -0.24114,
                recovery: 0.0,
                rough_inside_150: 3.47374,
                rough_outside_150: -0.04847,
                fairway_50_to_100: -0.44069,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 1.40852,
                putting_inside_5: 0.48706,
                putting_5_to_10: -1.01938,
                putting_10_to_15: -1.45995,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.24232,
                putting_outside_30: 0.21008,
                fairway_around_green_15: -0.26746,
                fairway_around_green_30: -1.31095,
                rough_around_green_15: 1.33727,
                rough_around_green_30: 0.0,
                total: 3.2292,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.1111,
                average_driving_distance: 314.64286,
                eagles: 1,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1821,
            round_date: '2024-10-16T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1821,
            strokes_gained_round: {
                tee: 1.21239,
                sand: 0.0,
                approach: -2.6859,
                putting: -0.51678,
                around_green: -0.62281,
                recovery: 0.0,
                rough_inside_150: 0.50121,
                rough_outside_150: -0.34669,
                fairway_50_to_100: -1.05619,
                fairway_100_to_150: -0.45155,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.0557,
                putting_inside_5: 1.44222,
                putting_5_to_10: -0.35148,
                putting_10_to_15: -1.14433,
                putting_15_to_20: -0.7359,
                putting_20_to_30: -1.00529,
                putting_outside_30: 1.278,
                fairway_around_green_15: -0.53251,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: -0.0903,
                total: -2.6131,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: 1,
                green_in_regulation_percentage: 0.8333,
                total_putts: 35,
                three_putt_percentage: 0.1111,
                average_driving_distance: 307.57143,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1820,
            round_date: '2024-10-15T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1820,
            strokes_gained_round: {
                tee: 4.13389,
                sand: 0.0,
                approach: 0.86398,
                putting: -0.23987,
                around_green: -0.70217,
                recovery: 0.0,
                rough_inside_150: 1.22033,
                rough_outside_150: 2.30381,
                fairway_50_to_100: -0.08366,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.16379,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.20611,
                putting_5_to_10: -0.28851,
                putting_10_to_15: -0.8799,
                putting_15_to_20: 0.33473,
                putting_20_to_30: -0.46192,
                putting_outside_30: 1.26185,
                fairway_around_green_15: -0.70217,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 4.05583,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -6,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 324.42857,
                eagles: 1,
                birdies: 5,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1819,
            round_date: '2024-10-14T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1819,
            strokes_gained_round: {
                tee: 2.31225,
                sand: 0.0,
                approach: -3.06066,
                putting: 1.82568,
                around_green: -0.33994,
                recovery: 0.0,
                rough_inside_150: -0.42626,
                rough_outside_150: -0.33789,
                fairway_50_to_100: -0.80915,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.69439,
                putting_5_to_10: -1.37467,
                putting_10_to_15: 0.57137,
                putting_15_to_20: 0.30965,
                putting_20_to_30: -0.17276,
                putting_outside_30: 0.7977,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.86669,
                rough_around_green_15: 0.59869,
                rough_around_green_30: -0.07194,
                total: 0.73733,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 331.42857,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1818,
            round_date: '2024-10-13T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1818,
            strokes_gained_round: {
                tee: 2.14253,
                sand: 0.0,
                approach: 2.93917,
                putting: 2.00886,
                around_green: 0.34971,
                recovery: 0.0,
                rough_inside_150: 2.37365,
                rough_outside_150: -0.03282,
                fairway_50_to_100: 1.14686,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.22493,
                fairway_outside_200: 0.269,
                putting_inside_5: 2.66372,
                putting_5_to_10: -0.44235,
                putting_10_to_15: 0.66523,
                putting_15_to_20: -0.7359,
                putting_20_to_30: -0.24232,
                putting_outside_30: 0.10046,
                fairway_around_green_15: -0.15036,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.24699,
                rough_around_green_30: 0.25309,
                total: 7.44027,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -8,
                green_in_regulation_percentage: 0.7222,
                total_putts: 25,
                three_putt_percentage: 0.0556,
                average_driving_distance: 337.42857,
                eagles: 0,
                birdies: 9,
                pars: 8,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.3,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1817,
            round_date: '2024-10-12T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1817,
            strokes_gained_round: {
                tee: 1.80319,
                sand: 0.0,
                approach: -0.99399,
                putting: -0.61184,
                around_green: -0.28381,
                recovery: 0.0,
                rough_inside_150: 0.72439,
                rough_outside_150: 0.01364,
                fairway_50_to_100: -0.51745,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.48239,
                fairway_outside_200: 0.22153,
                putting_inside_5: 1.13918,
                putting_5_to_10: -0.39341,
                putting_10_to_15: -0.89774,
                putting_15_to_20: -0.32214,
                putting_20_to_30: -0.39142,
                putting_outside_30: 0.25368,
                fairway_around_green_15: -0.46953,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.1571,
                rough_around_green_30: 0.02862,
                total: -0.08645,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 326.5,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1816,
            round_date: '2024-10-11T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1816,
            strokes_gained_round: {
                tee: 2.17806,
                sand: 0.0,
                approach: -2.51715,
                putting: -0.59942,
                around_green: 0.50468,
                recovery: 0.0,
                rough_inside_150: 1.44627,
                rough_outside_150: 0.02682,
                fairway_50_to_100: -0.30472,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.60544,
                fairway_outside_200: 0.03615,
                putting_inside_5: 1.54198,
                putting_5_to_10: -0.60971,
                putting_10_to_15: -0.49532,
                putting_15_to_20: -1.36911,
                putting_20_to_30: -0.15053,
                putting_outside_30: 0.48327,
                fairway_around_green_15: -0.21735,
                fairway_around_green_30: -0.16907,
                rough_around_green_15: 0.39079,
                rough_around_green_30: 0.50032,
                total: -0.43383,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 321.21429,
                eagles: 0,
                birdies: 4,
                pars: 11,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1815,
            round_date: '2024-10-10T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1815,
            strokes_gained_round: {
                tee: 1.51101,
                sand: 0.0,
                approach: -1.67955,
                putting: 3.7178,
                around_green: -0.07808,
                recovery: 0.0,
                rough_inside_150: 2.24775,
                rough_outside_150: -0.34053,
                fairway_50_to_100: -2.02008,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.47462,
                putting_inside_5: 1.38222,
                putting_5_to_10: 0.76177,
                putting_10_to_15: -0.01876,
                putting_15_to_20: 0.23157,
                putting_20_to_30: -0.17276,
                putting_outside_30: 1.53376,
                fairway_around_green_15: -0.1529,
                fairway_around_green_30: -0.50441,
                rough_around_green_15: 0.43997,
                rough_around_green_30: 0.13925,
                total: 3.47118,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 305.28571,
                eagles: 0,
                birdies: 8,
                pars: 7,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1814,
            round_date: '2024-10-09T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1814,
            strokes_gained_round: {
                tee: 1.2603,
                sand: 0.0,
                approach: -2.94923,
                putting: 1.76718,
                around_green: 0.8368,
                recovery: 0.0,
                rough_inside_150: 0.72263,
                rough_outside_150: -0.15737,
                fairway_50_to_100: -1.45122,
                fairway_100_to_150: -1.15543,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.07106,
                putting_inside_5: 0.31738,
                putting_5_to_10: 1.24985,
                putting_10_to_15: -0.92519,
                putting_15_to_20: 0.33473,
                putting_20_to_30: -0.75108,
                putting_outside_30: 1.54148,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.07037,
                rough_around_green_30: 0.90717,
                total: 0.91504,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6667,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 301.92857,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1813,
            round_date: '2024-10-08T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1813,
            strokes_gained_round: {
                tee: 1.11277,
                sand: 0.0,
                approach: -1.38243,
                putting: 2.70281,
                around_green: 0.65786,
                recovery: 0.0,
                rough_inside_150: 1.45615,
                rough_outside_150: -0.78024,
                fairway_50_to_100: 0.15331,
                fairway_100_to_150: -0.45155,
                fairway_150_to_200: -0.22493,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.09137,
                putting_5_to_10: 1.29417,
                putting_10_to_15: 0.48619,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -0.32424,
                putting_outside_30: 1.52304,
                fairway_around_green_15: 0.24353,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.14302,
                rough_around_green_30: 0.55736,
                total: 3.09102,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0556,
                average_driving_distance: 312.14286,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1812,
            round_date: '2024-10-07T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1812,
            strokes_gained_round: {
                tee: 2.31987,
                sand: 0.0,
                approach: -2.378,
                putting: 2.91766,
                around_green: 0.58008,
                recovery: 0.0,
                rough_inside_150: 0.05362,
                rough_outside_150: -0.21138,
                fairway_50_to_100: -0.94293,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.41552,
                fairway_outside_200: -0.39687,
                putting_inside_5: 1.04416,
                putting_5_to_10: -0.59297,
                putting_10_to_15: 0.60845,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.19412,
                putting_outside_30: 2.05215,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.11516,
                rough_around_green_15: 0.75292,
                rough_around_green_30: -0.288,
                total: 3.4396,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 304.14286,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1811,
            round_date: '2024-10-06T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1811,
            strokes_gained_round: {
                tee: 5.34298,
                sand: 0.0,
                approach: 0.03685,
                putting: 0.80508,
                around_green: -0.14133,
                recovery: 0.0,
                rough_inside_150: 0.74359,
                rough_outside_150: 0.11127,
                fairway_50_to_100: -0.82465,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.07818,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.95896,
                putting_5_to_10: 0.86953,
                putting_10_to_15: -0.23251,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.7909,
                putting_outside_30: 0.0,
                fairway_around_green_15: -0.34934,
                fairway_around_green_30: -0.1636,
                rough_around_green_15: 0.51946,
                rough_around_green_30: -0.14785,
                total: 6.04359,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -8,
                green_in_regulation_percentage: 0.8333,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 333.92857,
                eagles: 0,
                birdies: 10,
                pars: 6,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.4,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1810,
            round_date: '2024-10-05T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1810,
            strokes_gained_round: {
                tee: 2.77953,
                sand: 0.0,
                approach: 1.78089,
                putting: 2.10853,
                around_green: -0.07935,
                recovery: 0.0,
                rough_inside_150: 1.11397,
                rough_outside_150: -0.21035,
                fairway_50_to_100: 0.435,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.4898,
                putting_inside_5: 2.03586,
                putting_5_to_10: -0.11971,
                putting_10_to_15: 0.69363,
                putting_15_to_20: -0.7359,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.23465,
                fairway_around_green_15: -0.01669,
                fairway_around_green_30: -0.20224,
                rough_around_green_15: 0.19493,
                rough_around_green_30: -0.05535,
                total: 6.5896,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -8,
                green_in_regulation_percentage: 0.7778,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 323.92857,
                eagles: 1,
                birdies: 7,
                pars: 9,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.5,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1809,
            round_date: '2024-10-04T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1809,
            strokes_gained_round: {
                tee: 4.5467,
                sand: 0.0,
                approach: -3.63486,
                putting: 3.5606,
                around_green: -0.79254,
                recovery: 0.0,
                rough_inside_150: 0.39171,
                rough_outside_150: 0.0,
                fairway_50_to_100: -3.66578,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.64829,
                fairway_outside_200: -0.40573,
                putting_inside_5: 0.3944,
                putting_5_to_10: 0.73196,
                putting_10_to_15: 0.54345,
                putting_15_to_20: -0.03298,
                putting_20_to_30: 1.42944,
                putting_outside_30: 0.49432,
                fairway_around_green_15: 0.07437,
                fairway_around_green_30: -0.42959,
                rough_around_green_15: -0.29891,
                rough_around_green_30: -0.13841,
                total: 3.6799,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 337.07143,
                eagles: 1,
                birdies: 6,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1808,
            round_date: '2024-10-03T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1808,
            strokes_gained_round: {
                tee: 2.53932,
                sand: 0.0,
                approach: -0.69578,
                putting: 0.1498,
                around_green: 1.1721,
                recovery: 0.0,
                rough_inside_150: 1.1305,
                rough_outside_150: -0.10916,
                fairway_50_to_100: -0.0338,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.04531,
                putting_inside_5: 0.67307,
                putting_5_to_10: -1.21718,
                putting_10_to_15: 1.03011,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.21017,
                putting_outside_30: 0.19011,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.54021,
                rough_around_green_30: 0.6319,
                total: 3.16545,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 336.64286,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1807,
            round_date: '2024-10-02T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1807,
            strokes_gained_round: {
                tee: -0.16705,
                sand: 0.0,
                approach: -3.47546,
                putting: 2.54976,
                around_green: 1.00281,
                recovery: 0.0,
                rough_inside_150: 1.51707,
                rough_outside_150: 0.08072,
                fairway_50_to_100: -1.28722,
                fairway_100_to_150: -0.46476,
                fairway_150_to_200: -1.47184,
                fairway_outside_200: -0.21805,
                putting_inside_5: 1.24828,
                putting_5_to_10: -0.62326,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 1.25763,
                putting_outside_30: 0.66712,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.44407,
                rough_around_green_15: 1.44688,
                rough_around_green_30: 0.0,
                total: -0.08995,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 293.07143,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1806,
            round_date: '2024-10-01T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1806,
            strokes_gained_round: {
                tee: 1.59491,
                sand: 0.0,
                approach: -1.62753,
                putting: 1.44147,
                around_green: 0.14103,
                recovery: 0.0,
                rough_inside_150: 0.99211,
                rough_outside_150: -0.14858,
                fairway_50_to_100: -1.63096,
                fairway_100_to_150: -0.51336,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.1857,
                putting_inside_5: 0.92571,
                putting_5_to_10: 0.10584,
                putting_10_to_15: -0.53381,
                putting_15_to_20: 1.09112,
                putting_20_to_30: -0.52255,
                putting_outside_30: 0.37516,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.20402,
                rough_around_green_30: -0.06299,
                total: 1.54989,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 294.78571,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1805,
            round_date: '2024-09-30T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1805,
            strokes_gained_round: {
                tee: 2.4976,
                sand: 0.0,
                approach: -3.35247,
                putting: 0.78811,
                around_green: -0.26759,
                recovery: 0.0,
                rough_inside_150: 0.79769,
                rough_outside_150: 0.0,
                fairway_50_to_100: -2.41964,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -1.03145,
                fairway_outside_200: 0.03874,
                putting_inside_5: 1.0934,
                putting_5_to_10: -0.25728,
                putting_10_to_15: 0.51505,
                putting_15_to_20: -1.05203,
                putting_20_to_30: -0.39142,
                putting_outside_30: 0.88039,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.64654,
                rough_around_green_15: 0.19423,
                rough_around_green_30: 0.18473,
                total: -0.33435,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8889,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 303.78571,
                eagles: 0,
                birdies: 3,
                pars: 14,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1804,
            round_date: '2024-09-29T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1804,
            strokes_gained_round: {
                tee: 3.37738,
                sand: 0.0,
                approach: -0.34956,
                putting: -2.96035,
                around_green: -1.43234,
                recovery: 0.0,
                rough_inside_150: 0.83954,
                rough_outside_150: -0.91168,
                fairway_50_to_100: -0.49672,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.65207,
                fairway_outside_200: 0.0,
                putting_inside_5: -1.19877,
                putting_5_to_10: -0.57703,
                putting_10_to_15: -0.92613,
                putting_15_to_20: 0.2841,
                putting_20_to_30: -0.57129,
                putting_outside_30: 0.02877,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -1.80501,
                rough_around_green_15: 0.73165,
                rough_around_green_30: -0.35899,
                total: -1.36488,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -1,
                green_in_regulation_percentage: 0.8333,
                total_putts: 33,
                three_putt_percentage: 0.0556,
                average_driving_distance: 339.07143,
                eagles: 0,
                birdies: 4,
                pars: 11,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1803,
            round_date: '2024-09-28T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1803,
            strokes_gained_round: {
                tee: 0.18765,
                sand: 0.0,
                approach: -1.49148,
                putting: -0.94825,
                around_green: 1.05143,
                recovery: 0.0,
                rough_inside_150: 1.92705,
                rough_outside_150: 0.23369,
                fairway_50_to_100: -2.33078,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.26351,
                putting_inside_5: 1.61511,
                putting_5_to_10: -1.33928,
                putting_10_to_15: -0.94347,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.41191,
                putting_outside_30: 0.44744,
                fairway_around_green_15: -0.20027,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.92767,
                rough_around_green_30: 0.32403,
                total: -1.20065,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6111,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 308.64286,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1802,
            round_date: '2024-09-27T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1802,
            strokes_gained_round: {
                tee: 3.57057,
                sand: 0.0,
                approach: -2.39058,
                putting: 4.15555,
                around_green: 0.74354,
                recovery: 0.0,
                rough_inside_150: -0.03702,
                rough_outside_150: -0.12575,
                fairway_50_to_100: -1.1232,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.02575,
                fairway_outside_200: -0.31613,
                putting_inside_5: 0.07184,
                putting_5_to_10: 1.0667,
                putting_10_to_15: 1.20773,
                putting_15_to_20: 0.28457,
                putting_20_to_30: 0.84724,
                putting_outside_30: 0.67746,
                fairway_around_green_15: -0.1237,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.47371,
                rough_around_green_30: 0.39353,
                total: 6.07907,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7778,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 330.5,
                eagles: 0,
                birdies: 7,
                pars: 11,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1801,
            round_date: '2024-09-26T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1801,
            strokes_gained_round: {
                tee: 1.69444,
                sand: 0.0,
                approach: 0.11228,
                putting: 1.51975,
                around_green: 0.94816,
                recovery: 0.0,
                rough_inside_150: 2.16874,
                rough_outside_150: 0.26709,
                fairway_50_to_100: -0.45926,
                fairway_100_to_150: -0.47889,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.38245,
                putting_inside_5: -1.16873,
                putting_5_to_10: 0.70072,
                putting_10_to_15: 0.12226,
                putting_15_to_20: 0.38773,
                putting_20_to_30: 0.31136,
                putting_outside_30: 1.1664,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.0548,
                rough_around_green_15: 0.57343,
                rough_around_green_30: 0.42953,
                total: 4.27462,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2143,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.1111,
                average_driving_distance: 317.64286,
                eagles: 1,
                birdies: 6,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1800,
            round_date: '2024-09-25T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1800,
            strokes_gained_round: {
                tee: 1.48272,
                sand: 0.0,
                approach: -1.446,
                putting: 4.93262,
                around_green: 1.06616,
                recovery: 0.0,
                rough_inside_150: 1.32669,
                rough_outside_150: -0.46594,
                fairway_50_to_100: -0.72194,
                fairway_100_to_150: -1.26268,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.96951,
                putting_inside_5: 1.36127,
                putting_5_to_10: 0.33474,
                putting_10_to_15: 0.54345,
                putting_15_to_20: 1.74388,
                putting_20_to_30: 0.68724,
                putting_outside_30: 0.26203,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.69251,
                rough_around_green_30: 0.37364,
                total: 6.0355,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -7,
                green_in_regulation_percentage: 0.6111,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 318.0,
                eagles: 1,
                birdies: 7,
                pars: 8,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1799,
            round_date: '2024-09-24T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1799,
            strokes_gained_round: {
                tee: 2.84115,
                sand: 0.0,
                approach: -3.97575,
                putting: 2.72859,
                around_green: 0.55159,
                recovery: 0.0,
                rough_inside_150: -0.50644,
                rough_outside_150: -0.25689,
                fairway_50_to_100: -1.66104,
                fairway_100_to_150: -0.22309,
                fairway_150_to_200: -0.64348,
                fairway_outside_200: 0.08335,
                putting_inside_5: 1.17867,
                putting_5_to_10: 1.17336,
                putting_10_to_15: 0.07605,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.30051,
                fairway_around_green_15: -0.09088,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.64248,
                rough_around_green_30: 0.0,
                total: 2.14558,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -4,
                green_in_regulation_percentage: 0.6667,
                total_putts: 26,
                three_putt_percentage: 0.0556,
                average_driving_distance: 320.5,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1798,
            round_date: '2024-09-23T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1798,
            strokes_gained_round: {
                tee: 4.51792,
                sand: 0.0,
                approach: -4.41388,
                putting: 2.65293,
                around_green: 0.38374,
                recovery: 0.0,
                rough_inside_150: -0.24007,
                rough_outside_150: 0.15144,
                fairway_50_to_100: -2.79714,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.23458,
                fairway_outside_200: -0.35678,
                putting_inside_5: 1.76017,
                putting_5_to_10: 0.42703,
                putting_10_to_15: 0.10492,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.15053,
                putting_outside_30: 0.85302,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.55301,
                rough_around_green_15: 1.01989,
                rough_around_green_30: -0.08313,
                total: 3.1407,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 331.14286,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1797,
            round_date: '2024-09-22T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1797,
            strokes_gained_round: {
                tee: 0.32975,
                sand: 0.0,
                approach: -0.41806,
                putting: -0.65555,
                around_green: -0.21901,
                recovery: 0.0,
                rough_inside_150: -0.49151,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.76395,
                fairway_100_to_150: -0.9802,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.61192,
                putting_inside_5: 0.15137,
                putting_5_to_10: -1.01619,
                putting_10_to_15: -0.439,
                putting_15_to_20: -0.60719,
                putting_20_to_30: 0.80506,
                putting_outside_30: 0.4504,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.47134,
                rough_around_green_15: 0.34935,
                rough_around_green_30: -0.09703,
                total: -0.96287,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 290.85714,
                eagles: 1,
                birdies: 3,
                pars: 9,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1796,
            round_date: '2024-09-21T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1796,
            strokes_gained_round: {
                tee: 1.68564,
                sand: 0.0,
                approach: -0.39856,
                putting: 0.61981,
                around_green: 1.01059,
                recovery: 0.0,
                rough_inside_150: 1.72649,
                rough_outside_150: 0.20656,
                fairway_50_to_100: 0.27696,
                fairway_100_to_150: -0.60517,
                fairway_150_to_200: -0.27538,
                fairway_outside_200: -0.36681,
                putting_inside_5: 1.76752,
                putting_5_to_10: -0.80833,
                putting_10_to_15: 0.17763,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.45773,
                putting_outside_30: 0.28241,
                fairway_around_green_15: 0.21696,
                fairway_around_green_30: -0.56756,
                rough_around_green_15: 0.92674,
                rough_around_green_30: 0.43446,
                total: 2.91749,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 322.07143,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1795,
            round_date: '2024-09-20T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1795,
            strokes_gained_round: {
                tee: 2.68057,
                sand: 0.0,
                approach: -0.26692,
                putting: -1.4116,
                around_green: 0.34342,
                recovery: 0.0,
                rough_inside_150: 1.71993,
                rough_outside_150: -0.3329,
                fairway_50_to_100: -0.83996,
                fairway_100_to_150: -0.04077,
                fairway_150_to_200: -0.44523,
                fairway_outside_200: -0.244,
                putting_inside_5: -1.04588,
                putting_5_to_10: 0.13852,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.3106,
                putting_20_to_30: -0.61008,
                putting_outside_30: 0.21643,
                fairway_around_green_15: 0.25943,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.51075,
                rough_around_green_30: 0.59474,
                total: 1.34547,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 316.0,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1794,
            round_date: '2024-09-19T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1794,
            strokes_gained_round: {
                tee: 4.33678,
                sand: 0.0,
                approach: -1.57282,
                putting: 1.96144,
                around_green: -1.16361,
                recovery: 0.0,
                rough_inside_150: -0.95279,
                rough_outside_150: 0.03722,
                fairway_50_to_100: -1.18678,
                fairway_100_to_150: -0.32262,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.18801,
                putting_inside_5: 0.93412,
                putting_5_to_10: 0.73149,
                putting_10_to_15: -0.29845,
                putting_15_to_20: -0.34169,
                putting_20_to_30: 0.50022,
                putting_outside_30: 0.43575,
                fairway_around_green_15: -0.56916,
                fairway_around_green_30: 0.02331,
                rough_around_green_15: 0.14014,
                rough_around_green_30: -0.7579,
                total: 3.56178,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 335.0,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1793,
            round_date: '2024-09-18T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1793,
            strokes_gained_round: {
                tee: 2.89764,
                sand: 0.0,
                approach: -2.52668,
                putting: -0.22226,
                around_green: -1.60924,
                recovery: 0.0,
                rough_inside_150: -1.39816,
                rough_outside_150: -0.77797,
                fairway_50_to_100: -1.9546,
                fairway_100_to_150: -0.06358,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.55622,
                putting_inside_5: -0.13167,
                putting_5_to_10: -0.42322,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.68527,
                putting_20_to_30: 0.91393,
                putting_outside_30: 0.10397,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.58468,
                rough_around_green_15: 0.0,
                rough_around_green_30: -1.02456,
                total: -1.46054,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 299.85714,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1792,
            round_date: '2024-09-17T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1792,
            strokes_gained_round: {
                tee: 0.0647,
                sand: 0.0,
                approach: -0.62717,
                putting: -1.73194,
                around_green: -0.37782,
                recovery: 0.0,
                rough_inside_150: -0.05482,
                rough_outside_150: -0.47979,
                fairway_50_to_100: -0.12933,
                fairway_100_to_150: 0.50499,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.47278,
                putting_inside_5: 0.46507,
                putting_5_to_10: -0.11971,
                putting_10_to_15: -0.38174,
                putting_15_to_20: -1.71175,
                putting_20_to_30: -0.21866,
                putting_outside_30: 0.23485,
                fairway_around_green_15: -0.09715,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.1814,
                rough_around_green_30: -0.46207,
                total: -2.67223,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 306.07143,
                eagles: 0,
                birdies: 2,
                pars: 13,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1791,
            round_date: '2024-09-16T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1791,
            strokes_gained_round: {
                tee: 1.23124,
                sand: 0.0,
                approach: -3.03024,
                putting: 2.58165,
                around_green: 1.66038,
                recovery: 0.0,
                rough_inside_150: 1.0438,
                rough_outside_150: 0.00785,
                fairway_50_to_100: -0.99523,
                fairway_100_to_150: -1.09725,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.03285,
                putting_inside_5: 2.05539,
                putting_5_to_10: -0.54579,
                putting_10_to_15: 0.0,
                putting_15_to_20: 1.14176,
                putting_20_to_30: -0.46192,
                putting_outside_30: 0.39222,
                fairway_around_green_15: -0.06076,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.65955,
                rough_around_green_30: 1.06159,
                total: 2.44303,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 289.35714,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1790,
            round_date: '2024-09-15T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1790,
            strokes_gained_round: {
                tee: 4.49832,
                sand: 0.0,
                approach: -4.61413,
                putting: 1.29587,
                around_green: 0.63848,
                recovery: 0.0,
                rough_inside_150: -0.09125,
                rough_outside_150: 0.0,
                fairway_50_to_100: -2.51904,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.79255,
                putting_inside_5: 1.52198,
                putting_5_to_10: -0.48569,
                putting_10_to_15: -0.43995,
                putting_15_to_20: 0.02049,
                putting_20_to_30: -0.12876,
                putting_outside_30: 0.8078,
                fairway_around_green_15: -0.16152,
                fairway_around_green_30: 0.01365,
                rough_around_green_15: 0.60928,
                rough_around_green_30: 0.17707,
                total: 1.81854,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 327.92857,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1789,
            round_date: '2024-09-14T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1789,
            strokes_gained_round: {
                tee: 1.54041,
                sand: 0.0,
                approach: 2.74191,
                putting: -0.23501,
                around_green: 0.50514,
                recovery: 0.0,
                rough_inside_150: 1.42588,
                rough_outside_150: 0.56019,
                fairway_50_to_100: 0.48845,
                fairway_100_to_150: 0.42582,
                fairway_150_to_200: 1.01328,
                fairway_outside_200: -0.60187,
                putting_inside_5: 0.84501,
                putting_5_to_10: -0.88148,
                putting_10_to_15: 0.09481,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.56939,
                putting_outside_30: 0.27604,
                fairway_around_green_15: -0.29723,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.19493,
                rough_around_green_30: 0.60744,
                total: 4.55245,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 308.57143,
                eagles: 1,
                birdies: 5,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1788,
            round_date: '2024-09-13T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1788,
            strokes_gained_round: {
                tee: 1.09742,
                sand: 0.0,
                approach: -0.02511,
                putting: 0.57485,
                around_green: 0.93774,
                recovery: 0.0,
                rough_inside_150: 1.64478,
                rough_outside_150: 0.02773,
                fairway_50_to_100: -0.32324,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.15591,
                fairway_outside_200: -0.24121,
                putting_inside_5: 1.06474,
                putting_5_to_10: 0.33713,
                putting_10_to_15: -1.37429,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.10747,
                putting_outside_30: 0.65473,
                fairway_around_green_15: -0.03951,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.6425,
                rough_around_green_30: 0.33475,
                total: 2.5849,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 315.07143,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1787,
            round_date: '2024-09-12T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1787,
            strokes_gained_round: {
                tee: 2.74302,
                sand: 0.0,
                approach: -0.82079,
                putting: -0.44884,
                around_green: 0.02938,
                recovery: 0.0,
                rough_inside_150: 0.41757,
                rough_outside_150: 0.02653,
                fairway_50_to_100: 0.6916,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.67119,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.78285,
                putting_5_to_10: 0.91369,
                putting_10_to_15: -0.41155,
                putting_15_to_20: -0.03203,
                putting_20_to_30: -0.43779,
                putting_outside_30: 0.3017,
                fairway_around_green_15: -0.00202,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.09439,
                rough_around_green_30: -0.06299,
                total: 1.50277,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 329.0,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1786,
            round_date: '2024-09-11T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1786,
            strokes_gained_round: {
                tee: 2.72731,
                sand: 0.0,
                approach: -2.66649,
                putting: -4.12418,
                around_green: -0.19469,
                recovery: 0.0,
                rough_inside_150: -0.92022,
                rough_outside_150: -0.02173,
                fairway_50_to_100: -1.28945,
                fairway_100_to_150: -0.27986,
                fairway_150_to_200: -0.21294,
                fairway_outside_200: 0.0,
                putting_inside_5: -1.14764,
                putting_5_to_10: -1.52434,
                putting_10_to_15: 0.0,
                putting_15_to_20: -1.44719,
                putting_20_to_30: -0.26645,
                putting_outside_30: 0.26145,
                fairway_around_green_15: -0.46352,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.60995,
                rough_around_green_30: -0.34111,
                total: -4.25804,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 37,
                three_putt_percentage: 0.1667,
                average_driving_distance: 325.71429,
                eagles: 0,
                birdies: 2,
                pars: 11,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.0,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1785,
            round_date: '2024-09-10T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1785,
            strokes_gained_round: {
                tee: 4.03009,
                sand: 0.0,
                approach: -1.29627,
                putting: -1.22044,
                around_green: 0.39892,
                recovery: 0.0,
                rough_inside_150: 0.47737,
                rough_outside_150: 0.16688,
                fairway_50_to_100: -0.57095,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.09521,
                fairway_outside_200: -0.78309,
                putting_inside_5: 0.84322,
                putting_5_to_10: -1.46235,
                putting_10_to_15: -0.47655,
                putting_15_to_20: 0.30965,
                putting_20_to_30: -0.70005,
                putting_outside_30: 0.26563,
                fairway_around_green_15: -0.0183,
                fairway_around_green_30: -0.5329,
                rough_around_green_15: 0.91602,
                rough_around_green_30: 0.0341,
                total: 1.91229,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 332.42857,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1784,
            round_date: '2024-09-09T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1784,
            strokes_gained_round: {
                tee: 3.85726,
                sand: 0.0,
                approach: -0.39524,
                putting: 2.73233,
                around_green: -1.32355,
                recovery: 0.0,
                rough_inside_150: -0.4534,
                rough_outside_150: 0.0,
                fairway_50_to_100: -1.54004,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 1.20419,
                fairway_outside_200: -0.33523,
                putting_inside_5: 0.21028,
                putting_5_to_10: 1.03547,
                putting_10_to_15: 0.59881,
                putting_15_to_20: -0.10964,
                putting_20_to_30: -0.4336,
                putting_outside_30: 1.43101,
                fairway_around_green_15: 0.04654,
                fairway_around_green_30: -0.73812,
                rough_around_green_15: 0.0,
                rough_around_green_30: -0.63197,
                total: 4.8708,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.8571,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 335.42857,
                eagles: 1,
                birdies: 6,
                pars: 10,
                bogeys: 0,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1783,
            round_date: '2024-09-08T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1783,
            strokes_gained_round: {
                tee: 1.48172,
                sand: 0.0,
                approach: -1.08175,
                putting: -0.20676,
                around_green: -0.01693,
                recovery: 0.0,
                rough_inside_150: 0.43413,
                rough_outside_150: -0.07986,
                fairway_50_to_100: -0.97584,
                fairway_100_to_150: -0.28903,
                fairway_150_to_200: -0.24424,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.64823,
                putting_5_to_10: -0.72957,
                putting_10_to_15: -0.89774,
                putting_15_to_20: -0.65782,
                putting_20_to_30: -0.346,
                putting_outside_30: 0.77613,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.05616,
                rough_around_green_15: -0.07309,
                rough_around_green_30: 0.0,
                total: 0.17628,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 33,
                three_putt_percentage: 0.0,
                average_driving_distance: 292.42857,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1782,
            round_date: '2024-09-07T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1782,
            strokes_gained_round: {
                tee: 2.09437,
                sand: 0.0,
                approach: 0.71622,
                putting: 4.62116,
                around_green: 0.3112,
                recovery: 0.0,
                rough_inside_150: 0.11261,
                rough_outside_150: 0.07873,
                fairway_50_to_100: 0.18033,
                fairway_100_to_150: -1.19701,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 1.88059,
                putting_inside_5: 0.96027,
                putting_5_to_10: 1.95105,
                putting_10_to_15: 0.54345,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.67021,
                putting_outside_30: 0.49618,
                fairway_around_green_15: -0.16674,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.19423,
                rough_around_green_30: 0.28371,
                total: 7.74295,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -9,
                green_in_regulation_percentage: 0.7222,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 317.42857,
                eagles: 2,
                birdies: 6,
                pars: 9,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 3.5,
            },
            par: 72,
            strokes_total: 63,
        },
        {
            id: 1781,
            round_date: '2024-09-06T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1781,
            strokes_gained_round: {
                tee: 1.75078,
                sand: 0.0,
                approach: -2.86513,
                putting: -2.47249,
                around_green: 0.08005,
                recovery: 0.0,
                rough_inside_150: 0.17224,
                rough_outside_150: -3e-5,
                fairway_50_to_100: -1.81899,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.32677,
                fairway_outside_200: 0.20711,
                putting_inside_5: 0.06321,
                putting_5_to_10: -1.41206,
                putting_10_to_15: -1.36203,
                putting_15_to_20: 0.41281,
                putting_20_to_30: -0.56466,
                putting_outside_30: 0.39024,
                fairway_around_green_15: -0.41439,
                fairway_around_green_30: -0.22443,
                rough_around_green_15: 0.28487,
                rough_around_green_30: 0.43401,
                total: -3.50678,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 4,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 36,
                three_putt_percentage: 0.2222,
                average_driving_distance: 313.85714,
                eagles: 0,
                birdies: 2,
                pars: 11,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1780,
            round_date: '2024-09-05T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1780,
            strokes_gained_round: {
                tee: 1.49005,
                sand: 0.0,
                approach: -1.36264,
                putting: -1.10495,
                around_green: -0.51239,
                recovery: 0.0,
                rough_inside_150: 0.76685,
                rough_outside_150: -0.1485,
                fairway_50_to_100: -0.41291,
                fairway_100_to_150: -0.54042,
                fairway_150_to_200: -0.65651,
                fairway_outside_200: 0.21123,
                putting_inside_5: 0.86833,
                putting_5_to_10: -2.02214,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.34169,
                putting_20_to_30: 0.18936,
                putting_outside_30: 0.20118,
                fairway_around_green_15: -0.8693,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.55815,
                rough_around_green_30: -0.20123,
                total: -1.48993,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 3,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6111,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 305.14286,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1779,
            round_date: '2024-09-04T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1779,
            strokes_gained_round: {
                tee: 2.40558,
                sand: 0.0,
                approach: 0.46265,
                putting: -2.36284,
                around_green: 0.22501,
                recovery: 0.0,
                rough_inside_150: 1.40271,
                rough_outside_150: -0.2079,
                fairway_50_to_100: -0.15876,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.15292,
                putting_inside_5: 0.78123,
                putting_5_to_10: -1.3047,
                putting_10_to_15: -1.64059,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.39142,
                putting_outside_30: 0.19265,
                fairway_around_green_15: -0.24391,
                fairway_around_green_30: -0.0474,
                rough_around_green_15: 0.26382,
                rough_around_green_30: 0.2525,
                total: 0.73041,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8889,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 323.85714,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1778,
            round_date: '2024-09-03T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1778,
            strokes_gained_round: {
                tee: 1.39105,
                sand: 0.0,
                approach: -2.11189,
                putting: 1.30307,
                around_green: 1.14158,
                recovery: 0.0,
                rough_inside_150: 0.54405,
                rough_outside_150: 1.13487,
                fairway_50_to_100: -1.91156,
                fairway_100_to_150: -0.81197,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.89945,
                putting_5_to_10: -1.44464,
                putting_10_to_15: -0.44863,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.53861,
                putting_outside_30: 0.75828,
                fairway_around_green_15: 0.09025,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.05132,
                rough_around_green_30: 0.0,
                total: 1.7238,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 295.28571,
                eagles: 1,
                birdies: 4,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1777,
            round_date: '2024-09-02T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1777,
            strokes_gained_round: {
                tee: 3.65917,
                sand: 0.0,
                approach: -3.36911,
                putting: 1.05421,
                around_green: 1.16541,
                recovery: 0.0,
                rough_inside_150: 0.35583,
                rough_outside_150: -0.21329,
                fairway_50_to_100: -1.06947,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.63172,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.83174,
                putting_5_to_10: 1.29798,
                putting_10_to_15: -1.73056,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.24232,
                putting_outside_30: 0.23905,
                fairway_around_green_15: -0.09715,
                fairway_around_green_30: -0.5479,
                rough_around_green_15: 1.1567,
                rough_around_green_30: 0.65376,
                total: 2.50967,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0556,
                average_driving_distance: 328.85714,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 0,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1776,
            round_date: '2024-09-01T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1776,
            strokes_gained_round: {
                tee: 0.64037,
                sand: 0.0,
                approach: -3.81736,
                putting: 1.19793,
                around_green: -0.3269,
                recovery: 0.0,
                rough_inside_150: 0.24394,
                rough_outside_150: 0.37062,
                fairway_50_to_100: -1.40878,
                fairway_100_to_150: -1.99826,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.29382,
                putting_inside_5: 1.57463,
                putting_5_to_10: 0.33474,
                putting_10_to_15: -0.68701,
                putting_15_to_20: -0.05948,
                putting_20_to_30: -0.36918,
                putting_outside_30: 0.40423,
                fairway_around_green_15: -0.58293,
                fairway_around_green_30: -0.1213,
                rough_around_green_15: 0.21817,
                rough_around_green_30: 0.15916,
                total: -2.30597,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6111,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 300.42857,
                eagles: 0,
                birdies: 2,
                pars: 13,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1775,
            round_date: '2024-08-31T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1775,
            strokes_gained_round: {
                tee: 3.21234,
                sand: 0.0,
                approach: -0.28244,
                putting: 0.53409,
                around_green: 2.10571,
                recovery: 0.0,
                rough_inside_150: 3.82685,
                rough_outside_150: 0.0,
                fairway_50_to_100: -2.16516,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.30541,
                fairway_outside_200: -0.28327,
                putting_inside_5: 1.40956,
                putting_5_to_10: 0.85359,
                putting_10_to_15: -1.03876,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.5675,
                putting_outside_30: 0.21889,
                fairway_around_green_15: 0.21696,
                fairway_around_green_30: 0.12195,
                rough_around_green_15: 1.25414,
                rough_around_green_30: 0.51266,
                total: 5.5697,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 335.85714,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1774,
            round_date: '2024-08-30T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1774,
            strokes_gained_round: {
                tee: 2.21903,
                sand: 0.0,
                approach: -1.03221,
                putting: 0.07464,
                around_green: 1.20433,
                recovery: 0.0,
                rough_inside_150: 0.88645,
                rough_outside_150: 0.06796,
                fairway_50_to_100: -0.10629,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 2.10452,
                putting_5_to_10: -2.31402,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.19547,
                putting_outside_30: 0.47961,
                fairway_around_green_15: -0.07122,
                fairway_around_green_30: 0.11667,
                rough_around_green_15: 0.56711,
                rough_around_green_30: 0.59176,
                total: 2.4658,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8333,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 322.64286,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1773,
            round_date: '2024-08-29T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1773,
            strokes_gained_round: {
                tee: 2.26694,
                sand: 0.0,
                approach: -0.51914,
                putting: 3.83645,
                around_green: 0.14583,
                recovery: 0.0,
                rough_inside_150: 1.16368,
                rough_outside_150: 0.90963,
                fairway_50_to_100: -0.3249,
                fairway_100_to_150: -0.67036,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.15892,
                putting_inside_5: 0.90677,
                putting_5_to_10: 1.12633,
                putting_10_to_15: 0.06642,
                putting_15_to_20: 0.59517,
                putting_20_to_30: 0.75355,
                putting_outside_30: 0.3882,
                fairway_around_green_15: -0.31269,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.49233,
                rough_around_green_30: -0.03381,
                total: 5.73008,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 291.28571,
                eagles: 0,
                birdies: 8,
                pars: 9,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1772,
            round_date: '2024-08-28T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1772,
            strokes_gained_round: {
                tee: 0.74499,
                sand: 0.0,
                approach: 0.39105,
                putting: 2.15831,
                around_green: 0.772,
                recovery: 0.0,
                rough_inside_150: 1.73967,
                rough_outside_150: -0.0566,
                fairway_50_to_100: 0.09034,
                fairway_100_to_150: -0.38037,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.10923,
                putting_inside_5: -0.03076,
                putting_5_to_10: 0.36598,
                putting_10_to_15: -0.04763,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 0.60587,
                putting_outside_30: 1.65907,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.22152,
                rough_around_green_15: 0.68255,
                rough_around_green_30: 0.31096,
                total: 4.06634,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 295.21429,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1771,
            round_date: '2024-08-27T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1771,
            strokes_gained_round: {
                tee: 2.17459,
                sand: 0.0,
                approach: -4.5888,
                putting: 0.20536,
                around_green: -0.25275,
                recovery: 0.0,
                rough_inside_150: 0.2203,
                rough_outside_150: 0.44926,
                fairway_50_to_100: -2.62145,
                fairway_100_to_150: -0.28295,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.46767,
                putting_inside_5: 0.88833,
                putting_5_to_10: -0.19623,
                putting_10_to_15: -0.94489,
                putting_15_to_20: -0.7359,
                putting_20_to_30: 0.52482,
                putting_outside_30: 0.66922,
                fairway_around_green_15: -0.35674,
                fairway_around_green_30: -0.15917,
                rough_around_green_15: 0.23976,
                rough_around_green_30: 0.0234,
                total: -2.46161,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 316.35714,
                eagles: 0,
                birdies: 2,
                pars: 13,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1770,
            round_date: '2024-08-26T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1770,
            strokes_gained_round: {
                tee: 4.39435,
                sand: 0.0,
                approach: 2.12551,
                putting: 3.03677,
                around_green: 0.19842,
                recovery: 0.0,
                rough_inside_150: 0.8332,
                rough_outside_150: 0.51811,
                fairway_50_to_100: 0.23963,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 1.13114,
                fairway_outside_200: -0.33187,
                putting_inside_5: 1.60136,
                putting_5_to_10: 0.65688,
                putting_10_to_15: 1.00124,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.54763,
                putting_outside_30: 0.32491,
                fairway_around_green_15: -0.0045,
                fairway_around_green_30: 0.0189,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.18403,
                total: 9.75504,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -11,
                green_in_regulation_percentage: 0.8889,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 335.78571,
                eagles: 1,
                birdies: 9,
                pars: 8,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.4,
                par_5_score: 3.75,
            },
            par: 72,
            strokes_total: 61,
        },
        {
            id: 1769,
            round_date: '2024-08-25T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1769,
            strokes_gained_round: {
                tee: 4.46009,
                sand: 0.0,
                approach: -2.82907,
                putting: -0.72899,
                around_green: 0.72279,
                recovery: 0.0,
                rough_inside_150: 0.90757,
                rough_outside_150: 0.0,
                fairway_50_to_100: -3.01344,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.12324,
                fairway_outside_200: 0.00888,
                putting_inside_5: 0.7933,
                putting_5_to_10: 0.33474,
                putting_10_to_15: 0.17763,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -1.761,
                putting_outside_30: 0.09405,
                fairway_around_green_15: -0.22662,
                fairway_around_green_30: 0.09409,
                rough_around_green_15: 0.55815,
                rough_around_green_30: 0.29717,
                total: 1.62482,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 335.92857,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1768,
            round_date: '2024-08-24T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1768,
            strokes_gained_round: {
                tee: 1.68389,
                sand: 0.0,
                approach: -1.77155,
                putting: 2.05785,
                around_green: -0.35973,
                recovery: 0.0,
                rough_inside_150: 0.27004,
                rough_outside_150: -0.22102,
                fairway_50_to_100: -0.72666,
                fairway_100_to_150: -1.31518,
                fairway_150_to_200: 0.01731,
                fairway_outside_200: 0.27381,
                putting_inside_5: 1.36909,
                putting_5_to_10: -1.09637,
                putting_10_to_15: 0.06642,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.25892,
                putting_outside_30: 1.45979,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.42959,
                rough_around_green_15: 0.4115,
                rough_around_green_30: -0.34164,
                total: 1.61047,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 288.92857,
                eagles: 1,
                birdies: 2,
                pars: 14,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1767,
            round_date: '2024-08-23T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1767,
            strokes_gained_round: {
                tee: -0.06096,
                sand: 0.0,
                approach: 1.5891,
                putting: 0.66351,
                around_green: 1.7317,
                recovery: 0.0,
                rough_inside_150: 2.97075,
                rough_outside_150: 0.44891,
                fairway_50_to_100: -0.10662,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.27778,
                putting_inside_5: 1.08653,
                putting_5_to_10: -0.02695,
                putting_10_to_15: -1.01037,
                putting_15_to_20: 0.62579,
                putting_20_to_30: -0.28497,
                putting_outside_30: 0.27348,
                fairway_around_green_15: 0.28061,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.45109,
                rough_around_green_30: 0.0,
                total: 3.92335,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.1429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 301.35714,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1766,
            round_date: '2024-08-22T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1766,
            strokes_gained_round: {
                tee: 1.89448,
                sand: 0.0,
                approach: -2.57254,
                putting: 0.35297,
                around_green: 0.74207,
                recovery: 0.0,
                rough_inside_150: 2.0476,
                rough_outside_150: -0.51779,
                fairway_50_to_100: -3.6807,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.22552,
                putting_inside_5: -0.02981,
                putting_5_to_10: -0.25823,
                putting_10_to_15: 1.09605,
                putting_15_to_20: -0.29106,
                putting_20_to_30: -0.30863,
                putting_outside_30: 0.14464,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.11859,
                rough_around_green_15: 0.70707,
                rough_around_green_30: -0.08359,
                total: 0.41698,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 311.14286,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1765,
            round_date: '2024-08-21T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1765,
            strokes_gained_round: {
                tee: 3.33237,
                sand: 0.0,
                approach: -1.57904,
                putting: 0.75369,
                around_green: 0.90062,
                recovery: 0.0,
                rough_inside_150: 1.78993,
                rough_outside_150: -0.49554,
                fairway_50_to_100: -0.96854,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.3537,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.9199,
                putting_5_to_10: 1.7553,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.38172,
                putting_20_to_30: -2.01663,
                putting_outside_30: -0.2866,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.34326,
                rough_around_green_15: 0.14663,
                rough_around_green_30: 1.09725,
                total: 3.40764,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 337.0,
                eagles: 0,
                birdies: 8,
                pars: 8,
                bogeys: 1,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1764,
            round_date: '2024-08-20T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1764,
            strokes_gained_round: {
                tee: 2.25404,
                sand: 0.0,
                approach: -1.55714,
                putting: 0.83316,
                around_green: 0.06064,
                recovery: 0.0,
                rough_inside_150: 1.50496,
                rough_outside_150: 0.25067,
                fairway_50_to_100: -1.14905,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.31334,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.08653,
                putting_5_to_10: 0.35021,
                putting_10_to_15: -0.439,
                putting_15_to_20: -0.29106,
                putting_20_to_30: -0.43921,
                putting_outside_30: 0.56569,
                fairway_around_green_15: -0.10776,
                fairway_around_green_30: -0.72246,
                rough_around_green_15: 0.89086,
                rough_around_green_30: 0.0,
                total: 1.5907,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 324.28571,
                eagles: 0,
                birdies: 7,
                pars: 7,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1763,
            round_date: '2024-08-19T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1763,
            strokes_gained_round: {
                tee: 0.5741,
                sand: 0.0,
                approach: 0.20306,
                putting: 3.19563,
                around_green: 0.6854,
                recovery: 0.0,
                rough_inside_150: 1.21957,
                rough_outside_150: 1.69496,
                fairway_50_to_100: -0.47987,
                fairway_100_to_150: -0.80861,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.22263,
                putting_inside_5: 1.33051,
                putting_5_to_10: 0.53431,
                putting_10_to_15: 0.06689,
                putting_15_to_20: 0.12176,
                putting_20_to_30: 0.60492,
                putting_outside_30: 0.53724,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.51495,
                rough_around_green_15: 0.57336,
                rough_around_green_30: 0.62699,
                total: 4.6582,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 312.35714,
                eagles: 2,
                birdies: 4,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 3.75,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1762,
            round_date: '2024-08-18T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1762,
            strokes_gained_round: {
                tee: 2.99569,
                sand: 0.0,
                approach: -3.21339,
                putting: 2.00828,
                around_green: 0.56604,
                recovery: 0.0,
                rough_inside_150: -0.32216,
                rough_outside_150: -0.04622,
                fairway_50_to_100: -1.50484,
                fairway_100_to_150: -0.78955,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.16732,
                putting_inside_5: 1.44706,
                putting_5_to_10: 0.77819,
                putting_10_to_15: -0.89774,
                putting_15_to_20: 0.41281,
                putting_20_to_30: -0.06631,
                putting_outside_30: 0.33427,
                fairway_around_green_15: -0.09185,
                fairway_around_green_30: -0.11298,
                rough_around_green_15: 0.77086,
                rough_around_green_30: 0.0,
                total: 2.35662,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 312.78571,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1761,
            round_date: '2024-08-17T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1761,
            strokes_gained_round: {
                tee: 2.00596,
                sand: 0.0,
                approach: 1.03904,
                putting: 0.45535,
                around_green: -0.29366,
                recovery: 0.0,
                rough_inside_150: 0.98275,
                rough_outside_150: -0.00251,
                fairway_50_to_100: 0.53201,
                fairway_100_to_150: -0.19282,
                fairway_150_to_200: -0.74322,
                fairway_outside_200: 0.89003,
                putting_inside_5: -0.31427,
                putting_5_to_10: -0.69928,
                putting_10_to_15: 0.54345,
                putting_15_to_20: 0.93686,
                putting_20_to_30: -0.10747,
                putting_outside_30: 0.09607,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.29366,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 3.20669,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.1111,
                average_driving_distance: 309.5,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.5,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1760,
            round_date: '2024-08-16T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1760,
            strokes_gained_round: {
                tee: 1.52086,
                sand: 0.0,
                approach: 0.90476,
                putting: 0.1871,
                around_green: -0.71513,
                recovery: 0.0,
                rough_inside_150: 0.74399,
                rough_outside_150: 1.30726,
                fairway_50_to_100: -0.18443,
                fairway_100_to_150: -0.68496,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.11137,
                putting_5_to_10: -1.89728,
                putting_10_to_15: -0.37184,
                putting_15_to_20: 0.0,
                putting_20_to_30: 1.08527,
                putting_outside_30: 0.25958,
                fairway_around_green_15: -0.12902,
                fairway_around_green_30: -0.8632,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.2771,
                total: 1.89759,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 304.5,
                eagles: 0,
                birdies: 8,
                pars: 6,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1759,
            round_date: '2024-08-15T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1759,
            strokes_gained_round: {
                tee: 2.57514,
                sand: 0.0,
                approach: -1.94512,
                putting: 2.31186,
                around_green: -0.22792,
                recovery: 0.0,
                rough_inside_150: -0.50353,
                rough_outside_150: -0.23052,
                fairway_50_to_100: 0.11228,
                fairway_100_to_150: -0.83216,
                fairway_150_to_200: -0.29063,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.88099,
                putting_5_to_10: 0.42703,
                putting_10_to_15: 0.67392,
                putting_15_to_20: 0.36218,
                putting_20_to_30: -0.59258,
                putting_outside_30: 0.56033,
                fairway_around_green_15: -0.30879,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.03774,
                rough_around_green_30: 0.11861,
                total: 2.71397,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 317.07143,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1758,
            round_date: '2024-08-14T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1758,
            strokes_gained_round: {
                tee: -0.21905,
                sand: 0.0,
                approach: -2.71408,
                putting: -0.65858,
                around_green: 0.87054,
                recovery: 0.0,
                rough_inside_150: 0.04798,
                rough_outside_150: -0.22811,
                fairway_50_to_100: -0.30691,
                fairway_100_to_150: -1.3466,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.0421,
                putting_inside_5: 1.07114,
                putting_5_to_10: -0.75938,
                putting_10_to_15: -1.37477,
                putting_15_to_20: 0.65229,
                putting_20_to_30: -0.63563,
                putting_outside_30: 0.38778,
                fairway_around_green_15: 0.0322,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.74701,
                rough_around_green_30: 0.09132,
                total: -2.72117,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: 1,
                green_in_regulation_percentage: 0.5556,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 297.85714,
                eagles: 0,
                birdies: 2,
                pars: 13,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1757,
            round_date: '2024-08-13T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1757,
            strokes_gained_round: {
                tee: 3.73869,
                sand: 0.0,
                approach: -2.23111,
                putting: -0.01054,
                around_green: 1.42114,
                recovery: 0.0,
                rough_inside_150: 1.64643,
                rough_outside_150: 0.12713,
                fairway_50_to_100: -1.82481,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.46615,
                fairway_outside_200: -0.41321,
                putting_inside_5: 0.9444,
                putting_5_to_10: -0.16641,
                putting_10_to_15: -0.04763,
                putting_15_to_20: -0.39421,
                putting_20_to_30: -0.62718,
                putting_outside_30: 0.2805,
                fairway_around_green_15: 0.0171,
                fairway_around_green_30: 0.10353,
                rough_around_green_15: 0.93498,
                rough_around_green_30: 0.36554,
                total: 2.91818,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 328.28571,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1756,
            round_date: '2024-08-12T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1756,
            strokes_gained_round: {
                tee: 1.94162,
                sand: 0.0,
                approach: -0.81178,
                putting: 0.84505,
                around_green: -0.64603,
                recovery: 0.0,
                rough_inside_150: 0.58341,
                rough_outside_150: -0.02935,
                fairway_50_to_100: -0.6339,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.43059,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.13901,
                putting_5_to_10: 1.1287,
                putting_10_to_15: 0.07605,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 0.15476,
                putting_outside_30: 0.01876,
                fairway_around_green_15: -0.23383,
                fairway_around_green_30: -0.71354,
                rough_around_green_15: 0.63552,
                rough_around_green_30: -0.33418,
                total: 1.32886,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 329.78571,
                eagles: 0,
                birdies: 7,
                pars: 7,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1755,
            round_date: '2024-08-11T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1755,
            strokes_gained_round: {
                tee: 1.33461,
                sand: 0.0,
                approach: -0.19631,
                putting: 2.25786,
                around_green: 0.73142,
                recovery: 0.0,
                rough_inside_150: 1.3764,
                rough_outside_150: 0.00244,
                fairway_50_to_100: -1.05668,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.03086,
                putting_inside_5: 1.31643,
                putting_5_to_10: 0.13757,
                putting_10_to_15: 0.18868,
                putting_15_to_20: 0.33473,
                putting_20_to_30: -0.23718,
                putting_outside_30: 0.51762,
                fairway_around_green_15: 0.03959,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.65132,
                rough_around_green_30: 0.04051,
                total: 4.12757,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.5,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1754,
            round_date: '2024-08-10T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1754,
            strokes_gained_round: {
                tee: 1.76234,
                sand: 0.0,
                approach: -4.86341,
                putting: 0.80895,
                around_green: 2.59117,
                recovery: 0.0,
                rough_inside_150: 2.93743,
                rough_outside_150: -0.28236,
                fairway_50_to_100: -3.86785,
                fairway_100_to_150: -0.18288,
                fairway_150_to_200: -0.2573,
                fairway_outside_200: -0.23139,
                putting_inside_5: 0.15184,
                putting_5_to_10: 1.34072,
                putting_10_to_15: -0.9815,
                putting_15_to_20: -0.34169,
                putting_20_to_30: 0.33793,
                putting_outside_30: 0.30165,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.39805,
                rough_around_green_15: 1.94761,
                rough_around_green_30: 1.04161,
                total: 0.29904,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 313.92857,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1753,
            round_date: '2024-08-09T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1753,
            strokes_gained_round: {
                tee: 0.3618,
                sand: 0.0,
                approach: -0.74428,
                putting: 3.49614,
                around_green: 0.75501,
                recovery: 0.0,
                rough_inside_150: 0.85344,
                rough_outside_150: 0.56718,
                fairway_50_to_100: 0.01623,
                fairway_100_to_150: -1.48393,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.2405,
                putting_inside_5: 1.00027,
                putting_5_to_10: 0.36598,
                putting_10_to_15: 0.55118,
                putting_15_to_20: 0.33615,
                putting_20_to_30: 0.51637,
                putting_outside_30: 0.72618,
                fairway_around_green_15: 0.06376,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.69125,
                rough_around_green_30: 0.0,
                total: 3.86868,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 291.64286,
                eagles: 1,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1752,
            round_date: '2024-08-08T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1752,
            strokes_gained_round: {
                tee: 3.68412,
                sand: 0.0,
                approach: -4.95374,
                putting: 1.27996,
                around_green: 1.10881,
                recovery: 0.0,
                rough_inside_150: 0.86159,
                rough_outside_150: -0.06483,
                fairway_50_to_100: -3.1237,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.8941,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.32331,
                putting_5_to_10: 0.73149,
                putting_10_to_15: -0.40966,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.68011,
                putting_outside_30: 0.65662,
                fairway_around_green_15: -0.39896,
                fairway_around_green_30: -0.03813,
                rough_around_green_15: 1.09079,
                rough_around_green_30: 0.45511,
                total: 1.11915,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6111,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 331.07143,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1751,
            round_date: '2024-08-07T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1751,
            strokes_gained_round: {
                tee: 1.47311,
                sand: 0.0,
                approach: -4.04593,
                putting: 3.44567,
                around_green: 1.89352,
                recovery: 0.0,
                rough_inside_150: -0.09424,
                rough_outside_150: -0.12384,
                fairway_50_to_100: -1.62853,
                fairway_100_to_150: -0.98886,
                fairway_150_to_200: 0.38399,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.27512,
                putting_5_to_10: 0.79159,
                putting_10_to_15: -1.06763,
                putting_15_to_20: 1.32965,
                putting_20_to_30: 1.0541,
                putting_outside_30: 0.06283,
                fairway_around_green_15: 0.25943,
                fairway_around_green_30: 0.03964,
                rough_around_green_15: 1.07283,
                rough_around_green_30: 0.52163,
                total: 2.76637,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6111,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 323.78571,
                eagles: 1,
                birdies: 5,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1750,
            round_date: '2024-08-06T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1750,
            strokes_gained_round: {
                tee: 2.41597,
                sand: 0.0,
                approach: 0.54902,
                putting: -0.57118,
                around_green: -0.60098,
                recovery: 0.0,
                rough_inside_150: 1.31839,
                rough_outside_150: 0.31105,
                fairway_50_to_100: -1.19042,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.03425,
                putting_inside_5: 0.43203,
                putting_5_to_10: -0.79015,
                putting_10_to_15: -0.50495,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.36824,
                putting_outside_30: 0.66012,
                fairway_around_green_15: -0.41684,
                fairway_around_green_30: 0.0488,
                rough_around_green_15: -0.23293,
                rough_around_green_30: 0.0,
                total: 1.79284,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 334.35714,
                eagles: 0,
                birdies: 7,
                pars: 7,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1749,
            round_date: '2024-08-05T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1749,
            strokes_gained_round: {
                tee: 1.47886,
                sand: 0.0,
                approach: -3.55738,
                putting: 1.94483,
                around_green: 0.75672,
                recovery: 0.0,
                rough_inside_150: 0.47293,
                rough_outside_150: -0.23226,
                fairway_50_to_100: -0.67581,
                fairway_100_to_150: -1.16417,
                fairway_150_to_200: -0.61715,
                fairway_outside_200: -0.32292,
                putting_inside_5: 0.00606,
                putting_5_to_10: 0.5846,
                putting_10_to_15: -0.38966,
                putting_15_to_20: 0.0,
                putting_20_to_30: 1.40721,
                putting_outside_30: 0.33663,
                fairway_around_green_15: -0.26128,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.20549,
                rough_around_green_30: 0.81251,
                total: 0.62303,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 307.35714,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 1,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1748,
            round_date: '2024-08-04T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1748,
            strokes_gained_round: {
                tee: 1.46942,
                sand: 0.0,
                approach: -6.09671,
                putting: 2.01653,
                around_green: 0.27163,
                recovery: 0.0,
                rough_inside_150: -1.53596,
                rough_outside_150: -0.76732,
                fairway_50_to_100: -1.84632,
                fairway_100_to_150: -0.18288,
                fairway_150_to_200: -0.87903,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.46932,
                putting_5_to_10: 0.5362,
                putting_10_to_15: -1.70464,
                putting_15_to_20: -0.65877,
                putting_20_to_30: 1.6869,
                putting_outside_30: 0.68752,
                fairway_around_green_15: -0.24622,
                fairway_around_green_30: -0.04424,
                rough_around_green_15: 0.30281,
                rough_around_green_30: 0.25928,
                total: -2.33914,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6111,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 303.92857,
                eagles: 0,
                birdies: 6,
                pars: 5,
                bogeys: 7,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.1,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1747,
            round_date: '2024-08-03T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1747,
            strokes_gained_round: {
                tee: 1.09698,
                sand: 0.0,
                approach: -1.21274,
                putting: -3.15676,
                around_green: -0.27125,
                recovery: 0.0,
                rough_inside_150: -0.22483,
                rough_outside_150: 1.54158,
                fairway_50_to_100: -1.55769,
                fairway_100_to_150: -0.46751,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.15231,
                putting_5_to_10: -1.55,
                putting_10_to_15: -2.38664,
                putting_15_to_20: 0.56773,
                putting_20_to_30: -0.26645,
                putting_outside_30: 0.32629,
                fairway_around_green_15: -0.48204,
                fairway_around_green_30: -0.2935,
                rough_around_green_15: 0.50428,
                rough_around_green_30: 0.0,
                total: -3.54377,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 5,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 33,
                three_putt_percentage: 0.0556,
                average_driving_distance: 304.78571,
                eagles: 2,
                birdies: 2,
                pars: 7,
                bogeys: 6,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.25,
                par_4_score: 4.1,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1746,
            round_date: '2024-08-02T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1746,
            strokes_gained_round: {
                tee: 0.47436,
                sand: 0.0,
                approach: -1.88998,
                putting: 1.00562,
                around_green: -0.56168,
                recovery: 0.0,
                rough_inside_150: -0.40542,
                rough_outside_150: 0.29323,
                fairway_50_to_100: -1.1717,
                fairway_100_to_150: -0.54826,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.6681,
                putting_inside_5: 1.16402,
                putting_5_to_10: 0.45971,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -0.08361,
                putting_20_to_30: -0.32613,
                putting_outside_30: 0.32545,
                fairway_around_green_15: -0.72318,
                fairway_around_green_30: -0.56444,
                rough_around_green_15: 0.02853,
                rough_around_green_30: 0.6974,
                total: -0.97169,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 3,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6111,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 294.85714,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1745,
            round_date: '2024-08-01T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1745,
            strokes_gained_round: {
                tee: 3.22448,
                sand: 0.0,
                approach: -0.52575,
                putting: 1.50862,
                around_green: 1.08435,
                recovery: 0.0,
                rough_inside_150: 2.19389,
                rough_outside_150: 0.32552,
                fairway_50_to_100: -1.07745,
                fairway_100_to_150: -0.54628,
                fairway_150_to_200: -0.12653,
                fairway_outside_200: -0.15704,
                putting_inside_5: 0.52397,
                putting_5_to_10: -0.82043,
                putting_10_to_15: 1.11481,
                putting_15_to_20: 0.70387,
                putting_20_to_30: -0.10747,
                putting_outside_30: 0.09388,
                fairway_around_green_15: 0.05846,
                fairway_around_green_30: -0.21328,
                rough_around_green_15: 0.83202,
                rough_around_green_30: 0.40715,
                total: 5.29171,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 25,
                three_putt_percentage: 0.0556,
                average_driving_distance: 332.35714,
                eagles: 0,
                birdies: 6,
                pars: 12,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.5,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1744,
            round_date: '2024-07-31T02:15:52.26344-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1744,
            strokes_gained_round: {
                tee: 4.04903,
                sand: 0.0,
                approach: -3.19358,
                putting: 0.55464,
                around_green: -0.19447,
                recovery: 0.0,
                rough_inside_150: -0.65447,
                rough_outside_150: 0.41994,
                fairway_50_to_100: -1.19895,
                fairway_100_to_150: -1.07752,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.35312,
                putting_inside_5: 1.35643,
                putting_5_to_10: 0.70072,
                putting_10_to_15: -0.91745,
                putting_15_to_20: -0.7359,
                putting_20_to_30: -0.41413,
                putting_outside_30: 0.56497,
                fairway_around_green_15: -0.52392,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.24099,
                rough_around_green_30: 0.08846,
                total: 1.21562,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.28571,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1551,
            round_date: '2024-07-27T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1551,
            strokes_gained_round: {
                tee: 2.93079,
                sand: 0.0,
                approach: -3.41341,
                putting: -2.39188,
                around_green: -0.2751,
                recovery: 0.0,
                rough_inside_150: -0.65055,
                rough_outside_150: -0.40362,
                fairway_50_to_100: -0.95336,
                fairway_100_to_150: -1.22448,
                fairway_150_to_200: -0.21529,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.67575,
                putting_5_to_10: 0.04479,
                putting_10_to_15: -1.88019,
                putting_15_to_20: -0.03156,
                putting_20_to_30: -0.39142,
                putting_outside_30: 0.54225,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.25025,
                rough_around_green_30: -0.02485,
                total: -3.1496,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 2,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 36,
                three_putt_percentage: 0.1667,
                average_driving_distance: 305.85714,
                eagles: 0,
                birdies: 1,
                pars: 14,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.1,
                par_5_score: 5.5,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1550,
            round_date: '2024-07-26T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1550,
            strokes_gained_round: {
                tee: 2.15131,
                sand: 0.0,
                approach: 1.89292,
                putting: -1.0736,
                around_green: 0.87156,
                recovery: 0.0,
                rough_inside_150: 2.47987,
                rough_outside_150: 1.07627,
                fairway_50_to_100: 0.43316,
                fairway_100_to_150: -0.70653,
                fairway_150_to_200: -0.46899,
                fairway_outside_200: -0.2735,
                putting_inside_5: 0.99658,
                putting_5_to_10: -0.22699,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -1.05203,
                putting_20_to_30: -0.58974,
                putting_outside_30: 0.33239,
                fairway_around_green_15: 0.02,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.85156,
                rough_around_green_30: 0.0,
                total: 3.8422,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -6,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 301.21429,
                eagles: 1,
                birdies: 5,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1549,
            round_date: '2024-07-25T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1549,
            strokes_gained_round: {
                tee: 1.87414,
                sand: 0.0,
                approach: -3.86502,
                putting: 0.69796,
                around_green: -0.73109,
                recovery: 0.0,
                rough_inside_150: -0.91954,
                rough_outside_150: 0.12176,
                fairway_50_to_100: -2.32157,
                fairway_100_to_150: -0.70928,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.05726,
                putting_inside_5: 0.55463,
                putting_5_to_10: -0.21105,
                putting_10_to_15: 0.03755,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.26178,
                putting_outside_30: 0.57861,
                fairway_around_green_15: -0.11788,
                fairway_around_green_30: -0.65833,
                rough_around_green_15: 0.04512,
                rough_around_green_30: 0.0,
                total: -2.02401,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 303.85714,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1548,
            round_date: '2024-07-24T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1548,
            strokes_gained_round: {
                tee: 2.00551,
                sand: 0.0,
                approach: 1.26664,
                putting: 0.61769,
                around_green: 0.07761,
                recovery: 0.0,
                rough_inside_150: 1.58766,
                rough_outside_150: 0.428,
                fairway_50_to_100: -1.20504,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.81619,
                putting_inside_5: 1.58729,
                putting_5_to_10: 0.07652,
                putting_10_to_15: 0.10492,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.8349,
                putting_outside_30: 0.0,
                fairway_around_green_15: -0.28256,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.36017,
                rough_around_green_30: 0.0,
                total: 3.96744,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 313.42857,
                eagles: 1,
                birdies: 5,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1547,
            round_date: '2024-07-23T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1547,
            strokes_gained_round: {
                tee: 1.50584,
                sand: 0.0,
                approach: -2.05047,
                putting: 0.36144,
                around_green: 0.03065,
                recovery: 0.0,
                rough_inside_150: -0.08255,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.44594,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.33595,
                fairway_outside_200: -0.47965,
                putting_inside_5: 1.4304,
                putting_5_to_10: -0.22699,
                putting_10_to_15: 0.09481,
                putting_15_to_20: -1.07806,
                putting_20_to_30: -0.43036,
                putting_outside_30: 0.57163,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.29445,
                rough_around_green_30: -0.2638,
                total: -0.15254,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 312.42857,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1546,
            round_date: '2024-07-22T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1546,
            strokes_gained_round: {
                tee: 2.33987,
                sand: 0.0,
                approach: -3.22473,
                putting: 4.60159,
                around_green: 0.09131,
                recovery: 0.0,
                rough_inside_150: -2.04195,
                rough_outside_150: 0.58261,
                fairway_50_to_100: -1.18573,
                fairway_100_to_150: -0.61423,
                fairway_150_to_200: 0.18506,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.44837,
                putting_5_to_10: -0.16641,
                putting_10_to_15: 1.05755,
                putting_15_to_20: 0.62579,
                putting_20_to_30: 0.34077,
                putting_outside_30: 2.29553,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.05918,
                rough_around_green_15: 0.15049,
                rough_around_green_30: 0.0,
                total: 3.80804,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 315.5,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1545,
            round_date: '2024-07-21T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1545,
            strokes_gained_round: {
                tee: 1.61322,
                sand: 0.0,
                approach: -0.2507,
                putting: -1.15303,
                around_green: 0.46372,
                recovery: 0.0,
                rough_inside_150: 1.75654,
                rough_outside_150: -0.16952,
                fairway_50_to_100: -0.41158,
                fairway_100_to_150: -0.5599,
                fairway_150_to_200: -0.34939,
                fairway_outside_200: -0.05312,
                putting_inside_5: 1.28141,
                putting_5_to_10: -2.69579,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.41231,
                putting_outside_30: 0.67366,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.2157,
                rough_around_green_30: 0.24802,
                total: 0.67321,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 34,
                three_putt_percentage: 0.1667,
                average_driving_distance: 307.57143,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1544,
            round_date: '2024-07-20T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1544,
            strokes_gained_round: {
                tee: 2.85918,
                sand: 0.0,
                approach: 0.53648,
                putting: -0.23225,
                around_green: 0.07691,
                recovery: 0.0,
                rough_inside_150: 2.05795,
                rough_outside_150: -0.17018,
                fairway_50_to_100: -0.35705,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.3343,
                fairway_outside_200: 0.02062,
                putting_inside_5: 1.58776,
                putting_5_to_10: -1.17192,
                putting_10_to_15: -1.33579,
                putting_15_to_20: -0.34169,
                putting_20_to_30: 0.75355,
                putting_outside_30: 0.27583,
                fairway_around_green_15: -0.0289,
                fairway_around_green_30: -0.25456,
                rough_around_green_15: 0.36036,
                rough_around_green_30: 0.0,
                total: 3.24031,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8889,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 321.78571,
                eagles: 0,
                birdies: 8,
                pars: 7,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.6,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1543,
            round_date: '2024-07-19T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1543,
            strokes_gained_round: {
                tee: 1.52196,
                sand: 0.0,
                approach: -1.16749,
                putting: 2.52311,
                around_green: -0.63456,
                recovery: 0.0,
                rough_inside_150: 1.41223,
                rough_outside_150: -0.07637,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.62452,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.09824,
                putting_5_to_10: 0.73149,
                putting_10_to_15: 0.00963,
                putting_15_to_20: 1.06368,
                putting_20_to_30: -0.85714,
                putting_outside_30: 0.47721,
                fairway_around_green_15: -0.77837,
                fairway_around_green_30: -0.54314,
                rough_around_green_15: 0.56714,
                rough_around_green_30: 0.11981,
                total: 2.24301,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2143,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 319.92857,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1542,
            round_date: '2024-07-18T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1542,
            strokes_gained_round: {
                tee: 2.7267,
                sand: 0.0,
                approach: -0.83979,
                putting: 1.83581,
                around_green: 0.71238,
                recovery: 0.0,
                rough_inside_150: 1.76396,
                rough_outside_150: 0.14496,
                fairway_50_to_100: -1.45951,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.37865,
                fairway_outside_200: 0.02028,
                putting_inside_5: 0.99187,
                putting_5_to_10: 0.47182,
                putting_10_to_15: 0.55261,
                putting_15_to_20: -0.39421,
                putting_20_to_30: -0.30105,
                putting_outside_30: 0.51478,
                fairway_around_green_15: -0.08125,
                fairway_around_green_30: 0.16406,
                rough_around_green_15: 0.37756,
                rough_around_green_30: 0.252,
                total: 4.43509,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 336.78571,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1541,
            round_date: '2024-07-17T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1541,
            strokes_gained_round: {
                tee: 0.62053,
                sand: 0.0,
                approach: -0.7063,
                putting: 3.56308,
                around_green: 1.3995,
                recovery: 0.0,
                rough_inside_150: 2.27452,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.23314,
                fairway_100_to_150: -0.73407,
                fairway_150_to_200: 0.10609,
                fairway_outside_200: -0.7202,
                putting_inside_5: 1.8708,
                putting_5_to_10: 0.41221,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.65229,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.62778,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.8161,
                rough_around_green_30: 0.5834,
                total: 4.8768,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 304.64286,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1540,
            round_date: '2024-07-16T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1540,
            strokes_gained_round: {
                tee: 3.9894,
                sand: 0.0,
                approach: -2.10733,
                putting: 1.21336,
                around_green: 0.8213,
                recovery: 0.0,
                rough_inside_150: 1.08551,
                rough_outside_150: -0.32954,
                fairway_50_to_100: -0.94522,
                fairway_100_to_150: -0.79348,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.49636,
                putting_inside_5: 1.46979,
                putting_5_to_10: -0.44043,
                putting_10_to_15: 0.09387,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.34553,
                putting_outside_30: 0.43566,
                fairway_around_green_15: -0.15611,
                fairway_around_green_30: -0.16696,
                rough_around_green_15: 0.48547,
                rough_around_green_30: 0.65889,
                total: 3.91672,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 336.71429,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1539,
            round_date: '2024-07-15T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1539,
            strokes_gained_round: {
                tee: 2.44509,
                sand: 0.0,
                approach: -2.5145,
                putting: -0.74048,
                around_green: 1.04283,
                recovery: 0.0,
                rough_inside_150: -1.33551,
                rough_outside_150: -0.00828,
                fairway_50_to_100: 0.17843,
                fairway_100_to_150: -0.38013,
                fairway_150_to_200: -0.43034,
                fairway_outside_200: -0.09885,
                putting_inside_5: -0.77503,
                putting_5_to_10: -0.25728,
                putting_10_to_15: 0.0385,
                putting_15_to_20: -0.65877,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.9121,
                fairway_around_green_15: 0.23291,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.80992,
                total: 0.23295,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 314.42857,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1538,
            round_date: '2024-07-14T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1538,
            strokes_gained_round: {
                tee: 0.35407,
                sand: 0.0,
                approach: -0.52454,
                putting: -0.92774,
                around_green: -1.16511,
                recovery: 0.0,
                rough_inside_150: 0.25868,
                rough_outside_150: 0.21891,
                fairway_50_to_100: -1.19689,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.15184,
                putting_5_to_10: 0.1688,
                putting_10_to_15: -0.88858,
                putting_15_to_20: -1.31612,
                putting_20_to_30: 0.65082,
                putting_outside_30: 0.3055,
                fairway_around_green_15: -0.92083,
                fairway_around_green_30: -0.04952,
                rough_around_green_15: -0.12532,
                rough_around_green_30: -0.06944,
                total: -2.26332,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: 1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 291.14286,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 5.25,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1537,
            round_date: '2024-07-13T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1537,
            strokes_gained_round: {
                tee: 2.13634,
                sand: 0.0,
                approach: -1.21711,
                putting: 1.15665,
                around_green: 1.01956,
                recovery: 0.0,
                rough_inside_150: 0.32242,
                rough_outside_150: -0.1169,
                fairway_50_to_100: 0.82963,
                fairway_100_to_150: -1.91631,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.03615,
                putting_inside_5: 1.86548,
                putting_5_to_10: -0.19718,
                putting_10_to_15: -0.95311,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.06631,
                putting_outside_30: 0.84945,
                fairway_around_green_15: 0.19901,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.74104,
                rough_around_green_30: 0.07951,
                total: 3.09545,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 310.57143,
                eagles: 0,
                birdies: 4,
                pars: 14,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1536,
            round_date: '2024-07-12T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1536,
            strokes_gained_round: {
                tee: -0.21067,
                sand: 0.0,
                approach: -3.35295,
                putting: -0.05682,
                around_green: 1.37318,
                recovery: 0.0,
                rough_inside_150: 0.46837,
                rough_outside_150: 0.07145,
                fairway_50_to_100: -1.37524,
                fairway_100_to_150: -0.46956,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.12039,
                putting_inside_5: 1.18402,
                putting_5_to_10: -0.21058,
                putting_10_to_15: -0.46882,
                putting_15_to_20: -0.60719,
                putting_20_to_30: -0.26645,
                putting_outside_30: 0.31219,
                fairway_around_green_15: -0.20145,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.31766,
                rough_around_green_30: 0.25698,
                total: -2.24725,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 1,
                green_in_regulation_percentage: 0.5556,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 294.28571,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1535,
            round_date: '2024-07-11T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1535,
            strokes_gained_round: {
                tee: 2.06191,
                sand: 0.0,
                approach: -0.36757,
                putting: 3.26576,
                around_green: 1.58677,
                recovery: 0.0,
                rough_inside_150: 3.21966,
                rough_outside_150: 0.07138,
                fairway_50_to_100: -0.85248,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.52615,
                fairway_outside_200: -0.14786,
                putting_inside_5: 1.11137,
                putting_5_to_10: 0.53478,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 2.41288,
                putting_outside_30: 0.13476,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.50765,
                rough_around_green_30: 0.07912,
                total: 6.54688,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -8,
                green_in_regulation_percentage: 0.7778,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 335.0,
                eagles: 1,
                birdies: 8,
                pars: 7,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 3.75,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1534,
            round_date: '2024-07-10T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1534,
            strokes_gained_round: {
                tee: 0.3163,
                sand: 0.0,
                approach: -3.26754,
                putting: -1.38269,
                around_green: -0.53668,
                recovery: 0.0,
                rough_inside_150: -1.37797,
                rough_outside_150: 0.12302,
                fairway_50_to_100: -0.90557,
                fairway_100_to_150: -0.86,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.6402,
                putting_inside_5: 1.41738,
                putting_5_to_10: -1.43206,
                putting_10_to_15: -1.22809,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.34844,
                putting_outside_30: 0.55021,
                fairway_around_green_15: -0.14349,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.39319,
                rough_around_green_30: 0.0,
                total: -4.87061,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 36,
                three_putt_percentage: 0.1111,
                average_driving_distance: 305.28571,
                eagles: 0,
                birdies: 2,
                pars: 10,
                bogeys: 6,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 4.2,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 76,
        },
        {
            id: 1533,
            round_date: '2024-07-09T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1533,
            strokes_gained_round: {
                tee: 2.62738,
                sand: 0.0,
                approach: -3.87493,
                putting: -0.39101,
                around_green: 0.39724,
                recovery: 0.0,
                rough_inside_150: 0.39448,
                rough_outside_150: -0.18589,
                fairway_50_to_100: -3.07317,
                fairway_100_to_150: -0.32467,
                fairway_150_to_200: -0.36335,
                fairway_outside_200: 0.07491,
                putting_inside_5: 1.04027,
                putting_5_to_10: -2.83286,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.62025,
                putting_20_to_30: 0.53671,
                putting_outside_30: 0.6658,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.57907,
                rough_around_green_30: -0.18183,
                total: -1.24131,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 0,
                green_in_regulation_percentage: 0.8333,
                total_putts: 33,
                three_putt_percentage: 0.0556,
                average_driving_distance: 293.28571,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.1,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1532,
            round_date: '2024-07-08T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1532,
            strokes_gained_round: {
                tee: 1.05818,
                sand: 0.0,
                approach: -2.87845,
                putting: -2.41539,
                around_green: -1.25579,
                recovery: 0.0,
                rough_inside_150: -1.78549,
                rough_outside_150: 0.24531,
                fairway_50_to_100: -1.32973,
                fairway_100_to_150: 0.41396,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.43364,
                putting_inside_5: -0.09167,
                putting_5_to_10: -1.32254,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.58717,
                putting_20_to_30: -0.73,
                putting_outside_30: 0.31598,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.12455,
                rough_around_green_15: -1.0586,
                rough_around_green_30: -0.07264,
                total: -5.49146,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 5,
                blown_up_and_downs: 4,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 4,
                green_in_regulation_percentage: 0.6667,
                total_putts: 34,
                three_putt_percentage: 0.0556,
                average_driving_distance: 298.28571,
                eagles: 0,
                birdies: 3,
                pars: 9,
                bogeys: 5,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 76,
        },
        {
            id: 1531,
            round_date: '2024-07-07T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1531,
            strokes_gained_round: {
                tee: 1.20743,
                sand: 0.0,
                approach: -4.24464,
                putting: 1.02683,
                around_green: 1.46844,
                recovery: 0.0,
                rough_inside_150: 0.78284,
                rough_outside_150: 0.0912,
                fairway_50_to_100: -0.08351,
                fairway_100_to_150: -2.95352,
                fairway_150_to_200: -0.18089,
                fairway_outside_200: -0.17107,
                putting_inside_5: 1.72657,
                putting_5_to_10: 0.23033,
                putting_10_to_15: -0.88811,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.24232,
                putting_outside_30: 0.54204,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.26125,
                rough_around_green_15: 1.4587,
                rough_around_green_30: 0.27099,
                total: -0.54194,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -1,
                green_in_regulation_percentage: 0.5,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 305.71429,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1530,
            round_date: '2024-07-06T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1530,
            strokes_gained_round: {
                tee: 1.4111,
                sand: 0.0,
                approach: -4.78777,
                putting: -1.38468,
                around_green: 1.62657,
                recovery: 0.0,
                rough_inside_150: 0.89743,
                rough_outside_150: -0.04673,
                fairway_50_to_100: -1.47478,
                fairway_100_to_150: -0.86853,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.53923,
                putting_inside_5: 0.52801,
                putting_5_to_10: -0.25728,
                putting_10_to_15: -0.89727,
                putting_15_to_20: 0.0,
                putting_20_to_30: -1.11703,
                putting_outside_30: 0.35888,
                fairway_around_green_15: 0.05846,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.43218,
                rough_around_green_30: 0.13593,
                total: -3.13478,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 316.42857,
                eagles: 0,
                birdies: 2,
                pars: 12,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.0,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1529,
            round_date: '2024-07-05T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1529,
            strokes_gained_round: {
                tee: 3.31961,
                sand: 0.0,
                approach: -1.16323,
                putting: 1.46105,
                around_green: 0.11213,
                recovery: 0.0,
                rough_inside_150: 0.77448,
                rough_outside_150: -0.17163,
                fairway_50_to_100: -1.10739,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.11181,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.89211,
                putting_5_to_10: -0.22841,
                putting_10_to_15: -0.52418,
                putting_15_to_20: 0.36218,
                putting_20_to_30: 0.41552,
                putting_outside_30: 0.54384,
                fairway_around_green_15: -0.16179,
                fairway_around_green_30: -0.34928,
                rough_around_green_15: 0.6232,
                rough_around_green_30: 0.0,
                total: 3.72956,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 331.14286,
                eagles: 0,
                birdies: 8,
                pars: 7,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1528,
            round_date: '2024-07-04T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1528,
            strokes_gained_round: {
                tee: 2.91285,
                sand: 0.0,
                approach: -1.50673,
                putting: -1.06863,
                around_green: -0.50299,
                recovery: 0.0,
                rough_inside_150: 0.25662,
                rough_outside_150: 0.00917,
                fairway_50_to_100: -0.70862,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.71527,
                putting_5_to_10: -1.17605,
                putting_10_to_15: 0.03755,
                putting_15_to_20: -0.29106,
                putting_20_to_30: 0.73787,
                putting_outside_30: 0.33832,
                fairway_around_green_15: -0.06184,
                fairway_around_green_30: -0.90238,
                rough_around_green_15: 0.46123,
                rough_around_green_30: 0.0,
                total: -0.16549,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 4,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 33,
                three_putt_percentage: 0.2222,
                average_driving_distance: 333.64286,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1527,
            round_date: '2024-07-03T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1527,
            strokes_gained_round: {
                tee: 3.53694,
                sand: 0.0,
                approach: -0.25313,
                putting: -0.64416,
                around_green: -0.81222,
                recovery: 0.0,
                rough_inside_150: 0.08256,
                rough_outside_150: 1.00586,
                fairway_50_to_100: -1.42006,
                fairway_100_to_150: 0.24223,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.11196,
                putting_inside_5: -0.30561,
                putting_5_to_10: 0.79348,
                putting_10_to_15: -1.36513,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.59785,
                putting_outside_30: 0.83095,
                fairway_around_green_15: -0.68669,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: -0.12553,
                total: 1.82744,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 313.64286,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1526,
            round_date: '2024-07-02T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1526,
            strokes_gained_round: {
                tee: 3.40101,
                sand: 0.0,
                approach: -0.92071,
                putting: -0.20511,
                around_green: 0.1157,
                recovery: 0.0,
                rough_inside_150: 1.12709,
                rough_outside_150: -0.47541,
                fairway_50_to_100: -1.53412,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.74451,
                fairway_outside_200: -0.07677,
                putting_inside_5: 1.30331,
                putting_5_to_10: -2.16529,
                putting_10_to_15: 0.15018,
                putting_15_to_20: -0.34169,
                putting_20_to_30: 0.43168,
                putting_outside_30: 0.4167,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.27707,
                rough_around_green_15: 0.35864,
                rough_around_green_30: 0.03413,
                total: 2.39089,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8889,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 328.71429,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1525,
            round_date: '2024-07-01T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1525,
            strokes_gained_round: {
                tee: 0.31298,
                sand: 0.0,
                approach: -1.51391,
                putting: 3.11436,
                around_green: 0.07705,
                recovery: 0.0,
                rough_inside_150: 0.19914,
                rough_outside_150: -0.25701,
                fairway_50_to_100: 0.18983,
                fairway_100_to_150: -1.34311,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.27604,
                putting_inside_5: 0.19847,
                putting_5_to_10: 0.36598,
                putting_10_to_15: 0.63731,
                putting_15_to_20: -0.7094,
                putting_20_to_30: 2.03193,
                putting_outside_30: 0.59008,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.07705,
                total: 1.99047,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 288.35714,
                eagles: 0,
                birdies: 7,
                pars: 7,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1524,
            round_date: '2024-06-30T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1524,
            strokes_gained_round: {
                tee: 1.75521,
                sand: 0.0,
                approach: 0.76385,
                putting: 0.99613,
                around_green: 1.30981,
                recovery: 0.0,
                rough_inside_150: 3.79988,
                rough_outside_150: 1.0706,
                fairway_50_to_100: -1.14148,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.12063,
                fairway_outside_200: -0.47967,
                putting_inside_5: 0.56304,
                putting_5_to_10: 0.13852,
                putting_10_to_15: -0.53381,
                putting_15_to_20: 0.51615,
                putting_20_to_30: -0.12876,
                putting_outside_30: 0.44101,
                fairway_around_green_15: -0.07653,
                fairway_around_green_30: -0.97852,
                rough_around_green_15: 1.75742,
                rough_around_green_30: 0.60744,
                total: 4.825,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 320.14286,
                eagles: 1,
                birdies: 5,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1523,
            round_date: '2024-06-29T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1523,
            strokes_gained_round: {
                tee: 0.229,
                sand: 0.0,
                approach: -1.95813,
                putting: 2.7219,
                around_green: 0.63496,
                recovery: 0.0,
                rough_inside_150: 0.89969,
                rough_outside_150: 0.90936,
                fairway_50_to_100: -2.35053,
                fairway_100_to_150: -0.0206,
                fairway_150_to_200: -0.76007,
                fairway_outside_200: 0.24094,
                putting_inside_5: 0.89459,
                putting_5_to_10: 1.92029,
                putting_10_to_15: -0.44863,
                putting_15_to_20: -0.31613,
                putting_20_to_30: 0.30238,
                putting_outside_30: 0.36941,
                fairway_around_green_15: -0.38972,
                fairway_around_green_30: 0.14777,
                rough_around_green_15: 1.13252,
                rough_around_green_30: -0.2556,
                total: 1.62773,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6111,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 290.28571,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1522,
            round_date: '2024-06-28T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1522,
            strokes_gained_round: {
                tee: 0.83105,
                sand: 0.0,
                approach: -3.1352,
                putting: -3.93067,
                around_green: 0.75237,
                recovery: 0.0,
                rough_inside_150: -0.62984,
                rough_outside_150: -0.00262,
                fairway_50_to_100: 0.42653,
                fairway_100_to_150: -1.5,
                fairway_150_to_200: -0.478,
                fairway_outside_200: -0.0995,
                putting_inside_5: -0.49021,
                putting_5_to_10: -2.98206,
                putting_10_to_15: 0.06642,
                putting_15_to_20: -0.39421,
                putting_20_to_30: -0.42414,
                putting_outside_30: 0.29353,
                fairway_around_green_15: 0.04654,
                fairway_around_green_30: -0.14592,
                rough_around_green_15: 0.6543,
                rough_around_green_30: 0.19746,
                total: -5.48245,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 5,
                blown_up_and_downs: 3,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 4,
                green_in_regulation_percentage: 0.6111,
                total_putts: 34,
                three_putt_percentage: 0.1111,
                average_driving_distance: 303.5,
                eagles: 0,
                birdies: 5,
                pars: 5,
                bogeys: 7,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 4.3,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 76,
        },
        {
            id: 1521,
            round_date: '2024-06-27T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1521,
            strokes_gained_round: {
                tee: 2.15693,
                sand: 0.0,
                approach: 0.89443,
                putting: 1.43366,
                around_green: 1.51185,
                recovery: 0.0,
                rough_inside_150: 2.84387,
                rough_outside_150: -0.27633,
                fairway_50_to_100: 0.87756,
                fairway_100_to_150: -1.22773,
                fairway_150_to_200: 0.42988,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.08899,
                putting_5_to_10: 0.53336,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.31613,
                putting_20_to_30: 0.75355,
                putting_outside_30: 0.37388,
                fairway_around_green_15: -0.47412,
                fairway_around_green_30: 0.00808,
                rough_around_green_15: 0.91777,
                rough_around_green_30: 1.06011,
                total: 5.99687,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7222,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 318.21429,
                eagles: 0,
                birdies: 7,
                pars: 11,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1520,
            round_date: '2024-06-26T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1520,
            strokes_gained_round: {
                tee: 3.37354,
                sand: 0.0,
                approach: -2.22418,
                putting: 2.23415,
                around_green: 1.0401,
                recovery: 0.0,
                rough_inside_150: 0.92059,
                rough_outside_150: -0.07059,
                fairway_50_to_100: -1.32754,
                fairway_100_to_150: -0.06901,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.2662,
                putting_inside_5: 1.11966,
                putting_5_to_10: 0.36598,
                putting_10_to_15: 0.13,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.50079,
                putting_outside_30: 1.46099,
                fairway_around_green_15: 0.05065,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.94292,
                rough_around_green_30: 0.04654,
                total: 4.42361,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -6,
                green_in_regulation_percentage: 0.8333,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 324.71429,
                eagles: 1,
                birdies: 5,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 3.75,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1519,
            round_date: '2024-06-25T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1519,
            strokes_gained_round: {
                tee: 1.28114,
                sand: 0.0,
                approach: -4.26832,
                putting: 0.01527,
                around_green: 1.89303,
                recovery: 0.0,
                rough_inside_150: 0.14394,
                rough_outside_150: 0.02547,
                fairway_50_to_100: -1.27214,
                fairway_100_to_150: -0.50095,
                fairway_150_to_200: -0.49287,
                fairway_outside_200: -0.02499,
                putting_inside_5: 0.85767,
                putting_5_to_10: 0.04623,
                putting_10_to_15: -1.64975,
                putting_15_to_20: 0.67831,
                putting_20_to_30: -0.48511,
                putting_outside_30: 0.56792,
                fairway_around_green_15: -0.06076,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.93193,
                rough_around_green_30: 1.02185,
                total: -1.07888,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 315.07143,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.1,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1518,
            round_date: '2024-06-24T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1518,
            strokes_gained_round: {
                tee: 3.02799,
                sand: 0.0,
                approach: -2.07283,
                putting: 2.58297,
                around_green: 0.70157,
                recovery: 0.0,
                rough_inside_150: 2.2323,
                rough_outside_150: -0.34047,
                fairway_50_to_100: -0.02117,
                fairway_100_to_150: -0.80582,
                fairway_150_to_200: -0.82863,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.94829,
                putting_5_to_10: -0.36359,
                putting_10_to_15: 1.02963,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.91253,
                putting_outside_30: 0.05611,
                fairway_around_green_15: -0.17741,
                fairway_around_green_30: -0.97676,
                rough_around_green_15: 1.19906,
                rough_around_green_30: 0.65668,
                total: 4.2397,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7222,
                total_putts: 25,
                three_putt_percentage: 0.0556,
                average_driving_distance: 327.92857,
                eagles: 0,
                birdies: 10,
                pars: 5,
                bogeys: 2,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.5,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1517,
            round_date: '2024-06-23T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1517,
            strokes_gained_round: {
                tee: 1.71808,
                sand: 0.0,
                approach: -3.94566,
                putting: 1.35085,
                around_green: 0.6553,
                recovery: 0.0,
                rough_inside_150: 0.13275,
                rough_outside_150: -0.43291,
                fairway_50_to_100: -1.61037,
                fairway_100_to_150: 0.29868,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0894,
                putting_inside_5: 0.06452,
                putting_5_to_10: -0.16641,
                putting_10_to_15: 0.09481,
                putting_15_to_20: -0.29106,
                putting_20_to_30: -0.21542,
                putting_outside_30: 1.8644,
                fairway_around_green_15: 0.09025,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.19493,
                rough_around_green_30: 0.37011,
                total: -0.22143,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 31,
                three_putt_percentage: 0.1111,
                average_driving_distance: 313.5,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1516,
            round_date: '2024-06-22T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1516,
            strokes_gained_round: {
                tee: 2.97099,
                sand: 0.0,
                approach: -2.31649,
                putting: 2.92177,
                around_green: 1.1225,
                recovery: 0.0,
                rough_inside_150: 0.58993,
                rough_outside_150: -0.07418,
                fairway_50_to_100: -1.45583,
                fairway_100_to_150: 0.30668,
                fairway_150_to_200: -0.4411,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.85719,
                putting_5_to_10: -0.25728,
                putting_10_to_15: 0.12226,
                putting_15_to_20: -0.65782,
                putting_20_to_30: -0.06631,
                putting_outside_30: 1.92372,
                fairway_around_green_15: -0.06008,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.81613,
                rough_around_green_30: 0.36646,
                total: 4.69877,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 332.14286,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1515,
            round_date: '2024-06-21T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1515,
            strokes_gained_round: {
                tee: 2.41565,
                sand: 0.0,
                approach: -3.70497,
                putting: -0.04531,
                around_green: 0.60881,
                recovery: 0.0,
                rough_inside_150: 1.7547,
                rough_outside_150: -0.0808,
                fairway_50_to_100: -2.08461,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.52324,
                fairway_outside_200: -0.15471,
                putting_inside_5: 1.24934,
                putting_5_to_10: 0.82377,
                putting_10_to_15: -2.92329,
                putting_15_to_20: 0.02002,
                putting_20_to_30: 0.53489,
                putting_outside_30: 0.24997,
                fairway_around_green_15: -0.26304,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.87185,
                rough_around_green_30: 0.0,
                total: -0.72582,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 319.07143,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1514,
            round_date: '2024-06-20T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1514,
            strokes_gained_round: {
                tee: 1.71917,
                sand: 0.0,
                approach: -1.66646,
                putting: -1.81466,
                around_green: -2.30204,
                recovery: 0.0,
                rough_inside_150: -1.32541,
                rough_outside_150: 0.09831,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.08846,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.78115,
                putting_inside_5: 0.57085,
                putting_5_to_10: 0.13757,
                putting_10_to_15: -0.98245,
                putting_15_to_20: -1.41927,
                putting_20_to_30: -0.50877,
                putting_outside_30: 0.3874,
                fairway_around_green_15: -0.62684,
                fairway_around_green_30: -1.42694,
                rough_around_green_15: -0.18544,
                rough_around_green_30: -0.06283,
                total: -4.06399,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: 3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 33,
                three_putt_percentage: 0.0,
                average_driving_distance: 316.85714,
                eagles: 0,
                birdies: 2,
                pars: 11,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1513,
            round_date: '2024-06-19T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1513,
            strokes_gained_round: {
                tee: 1.48118,
                sand: 0.0,
                approach: -1.41295,
                putting: -1.59423,
                around_green: -0.13713,
                recovery: 0.0,
                rough_inside_150: 0.57156,
                rough_outside_150: -0.74477,
                fairway_50_to_100: -0.62573,
                fairway_100_to_150: -0.04077,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.39707,
                putting_inside_5: -0.46915,
                putting_5_to_10: 0.13946,
                putting_10_to_15: -0.35382,
                putting_15_to_20: -0.58211,
                putting_20_to_30: -0.35692,
                putting_outside_30: 0.0283,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.10171,
                rough_around_green_30: -0.23884,
                total: -1.66313,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 0,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.14286,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1512,
            round_date: '2024-06-18T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1512,
            strokes_gained_round: {
                tee: 2.89657,
                sand: 0.0,
                approach: 0.33287,
                putting: 3.4272,
                around_green: -0.37909,
                recovery: 0.0,
                rough_inside_150: 2.66152,
                rough_outside_150: -0.36689,
                fairway_50_to_100: -1.08657,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.23022,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.70123,
                putting_5_to_10: 0.47421,
                putting_10_to_15: 0.18915,
                putting_15_to_20: 0.3106,
                putting_20_to_30: 0.47474,
                putting_outside_30: 1.27727,
                fairway_around_green_15: -0.57281,
                fairway_around_green_30: -0.5329,
                rough_around_green_15: 0.84104,
                rough_around_green_30: -0.11443,
                total: 6.27755,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -8,
                green_in_regulation_percentage: 0.7778,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 322.14286,
                eagles: 0,
                birdies: 9,
                pars: 8,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.4,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1511,
            round_date: '2024-06-17T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1511,
            strokes_gained_round: {
                tee: 4.71464,
                sand: 0.0,
                approach: 1.58633,
                putting: 0.63656,
                around_green: -0.60142,
                recovery: 0.0,
                rough_inside_150: 0.84185,
                rough_outside_150: 1.38121,
                fairway_50_to_100: -0.23359,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.49029,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.2516,
                putting_5_to_10: -1.09684,
                putting_10_to_15: -0.25995,
                putting_15_to_20: 0.70387,
                putting_20_to_30: -0.30863,
                putting_outside_30: 1.34652,
                fairway_around_green_15: 0.03721,
                fairway_around_green_30: -0.42433,
                rough_around_green_15: 0.10124,
                rough_around_green_30: -0.31555,
                total: 6.33611,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -8,
                green_in_regulation_percentage: 1.0,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 332.92857,
                eagles: 1,
                birdies: 7,
                pars: 9,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1510,
            round_date: '2024-06-16T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1510,
            strokes_gained_round: {
                tee: 1.79293,
                sand: 0.0,
                approach: -6.04148,
                putting: 1.44976,
                around_green: 1.14289,
                recovery: 0.0,
                rough_inside_150: 0.27669,
                rough_outside_150: -0.2715,
                fairway_50_to_100: -2.23107,
                fairway_100_to_150: -1.51448,
                fairway_150_to_200: -0.1587,
                fairway_outside_200: -0.42133,
                putting_inside_5: 1.69439,
                putting_5_to_10: -1.78162,
                putting_10_to_15: 0.065,
                putting_15_to_20: -0.68527,
                putting_20_to_30: 0.0,
                putting_outside_30: 2.15727,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.4943,
                rough_around_green_30: 0.64859,
                total: -1.6559,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: 0,
                green_in_regulation_percentage: 0.7222,
                total_putts: 33,
                three_putt_percentage: 0.0556,
                average_driving_distance: 302.0,
                eagles: 0,
                birdies: 2,
                pars: 14,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1509,
            round_date: '2024-06-15T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1509,
            strokes_gained_round: {
                tee: 1.32339,
                sand: 0.0,
                approach: -0.53702,
                putting: 2.98882,
                around_green: 0.83132,
                recovery: 0.0,
                rough_inside_150: 0.76823,
                rough_outside_150: 0.06154,
                fairway_50_to_100: 0.28439,
                fairway_100_to_150: -0.23951,
                fairway_150_to_200: -0.57641,
                fairway_outside_200: 0.08396,
                putting_inside_5: 1.9108,
                putting_5_to_10: 0.36598,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.36218,
                putting_20_to_30: -0.46192,
                putting_outside_30: 0.81179,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.08789,
                rough_around_green_15: 0.56263,
                rough_around_green_30: 0.35659,
                total: 4.60652,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 301.14286,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1508,
            round_date: '2024-06-14T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1508,
            strokes_gained_round: {
                tee: 2.5432,
                sand: 0.0,
                approach: 0.32696,
                putting: -0.78713,
                around_green: 0.47142,
                recovery: 0.0,
                rough_inside_150: 2.25903,
                rough_outside_150: -0.21553,
                fairway_50_to_100: -0.32042,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.83187,
                putting_inside_5: 0.95658,
                putting_5_to_10: -1.72057,
                putting_10_to_15: 0.12226,
                putting_15_to_20: 0.38726,
                putting_20_to_30: -0.68058,
                putting_outside_30: 0.14792,
                fairway_around_green_15: 0.05315,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.41827,
                rough_around_green_30: 0.0,
                total: 2.55444,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8889,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 312.57143,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1507,
            round_date: '2024-06-13T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1507,
            strokes_gained_round: {
                tee: 3.3938,
                sand: 0.0,
                approach: -2.9362,
                putting: -0.04777,
                around_green: 0.74841,
                recovery: 0.0,
                rough_inside_150: 0.72131,
                rough_outside_150: -0.69551,
                fairway_50_to_100: -1.10733,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.09705,
                fairway_outside_200: -0.3422,
                putting_inside_5: 1.0734,
                putting_5_to_10: -2.1476,
                putting_10_to_15: -0.32637,
                putting_15_to_20: 1.01352,
                putting_20_to_30: -0.24232,
                putting_outside_30: 0.58161,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.74841,
                total: 1.15825,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.9444,
                total_putts: 33,
                three_putt_percentage: 0.0556,
                average_driving_distance: 331.71429,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1506,
            round_date: '2024-06-12T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1506,
            strokes_gained_round: {
                tee: 2.13269,
                sand: 0.0,
                approach: 1.76159,
                putting: -2.09108,
                around_green: -0.20291,
                recovery: 0.0,
                rough_inside_150: 1.08494,
                rough_outside_150: -0.45569,
                fairway_50_to_100: -0.18579,
                fairway_100_to_150: 0.72541,
                fairway_150_to_200: 0.79592,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.5056,
                putting_5_to_10: -0.19718,
                putting_10_to_15: -0.95358,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.19412,
                putting_outside_30: 0.10109,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.40611,
                rough_around_green_15: 0.2032,
                rough_around_green_30: 0.0,
                total: 1.60029,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 328.28571,
                eagles: 1,
                birdies: 6,
                pars: 6,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1505,
            round_date: '2024-06-11T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1505,
            strokes_gained_round: {
                tee: 0.98349,
                sand: 0.0,
                approach: -8.47725,
                putting: 1.16901,
                around_green: 1.08763,
                recovery: 0.0,
                rough_inside_150: -1.99215,
                rough_outside_150: 0.10985,
                fairway_50_to_100: -3.3518,
                fairway_100_to_150: -1.52423,
                fairway_150_to_200: -0.50337,
                fairway_outside_200: -0.29033,
                putting_inside_5: 2.13765,
                putting_5_to_10: -1.49358,
                putting_10_to_15: -0.50495,
                putting_15_to_20: 0.62579,
                putting_20_to_30: -0.48511,
                putting_outside_30: 0.88921,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.26095,
                rough_around_green_30: -0.17332,
                total: -5.23713,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 4,
                green_in_regulation_percentage: 0.4444,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 313.07143,
                eagles: 0,
                birdies: 2,
                pars: 10,
                bogeys: 6,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.2,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 76,
        },
        {
            id: 1504,
            round_date: '2024-06-10T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1504,
            strokes_gained_round: {
                tee: -0.17179,
                sand: 0.0,
                approach: -0.36861,
                putting: 1.38706,
                around_green: 0.06907,
                recovery: 0.0,
                rough_inside_150: 0.3798,
                rough_outside_150: 0.42115,
                fairway_50_to_100: -0.61603,
                fairway_100_to_150: -0.01207,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.08562,
                putting_inside_5: 0.7597,
                putting_5_to_10: -0.41348,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.7359,
                putting_20_to_30: 1.38071,
                putting_outside_30: 0.39603,
                fairway_around_green_15: 0.06907,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.91573,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 284.85714,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1503,
            round_date: '2024-06-09T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1503,
            strokes_gained_round: {
                tee: 1.56909,
                sand: 0.0,
                approach: 1.3653,
                putting: 0.85834,
                around_green: -0.31059,
                recovery: 0.0,
                rough_inside_150: -1.00156,
                rough_outside_150: 0.37004,
                fairway_50_to_100: 0.42068,
                fairway_100_to_150: 0.49728,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 1.09444,
                putting_inside_5: 0.90099,
                putting_5_to_10: -0.51456,
                putting_10_to_15: 0.48619,
                putting_15_to_20: -1.12964,
                putting_20_to_30: -0.17276,
                putting_outside_30: 1.28813,
                fairway_around_green_15: 0.26473,
                fairway_around_green_30: -0.77287,
                rough_around_green_15: 0.56711,
                rough_around_green_30: -0.36956,
                total: 3.48214,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 311.78571,
                eagles: 1,
                birdies: 5,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1502,
            round_date: '2024-06-08T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1502,
            strokes_gained_round: {
                tee: 0.76605,
                sand: 0.0,
                approach: -2.32614,
                putting: -1.02354,
                around_green: -1.42214,
                recovery: 0.0,
                rough_inside_150: -1.04812,
                rough_outside_150: 0.33421,
                fairway_50_to_100: -0.38658,
                fairway_100_to_150: -0.66465,
                fairway_150_to_200: -0.04896,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.7284,
                putting_5_to_10: -1.23202,
                putting_10_to_15: 0.48619,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.65131,
                putting_outside_30: 1.10202,
                fairway_around_green_15: -0.89281,
                fairway_around_green_30: -0.49509,
                rough_around_green_15: -0.03423,
                rough_around_green_30: 0.0,
                total: -4.00576,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 301.85714,
                eagles: 0,
                birdies: 3,
                pars: 10,
                bogeys: 4,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 4.0,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1501,
            round_date: '2024-06-07T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1501,
            strokes_gained_round: {
                tee: 2.82103,
                sand: 0.0,
                approach: -4.45558,
                putting: 2.72783,
                around_green: 1.19456,
                recovery: 0.0,
                rough_inside_150: 0.36003,
                rough_outside_150: -0.3315,
                fairway_50_to_100: -1.99378,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.53238,
                putting_inside_5: 0.87412,
                putting_5_to_10: 1.5846,
                putting_10_to_15: 0.07463,
                putting_15_to_20: -0.94888,
                putting_20_to_30: 0.77768,
                putting_outside_30: 0.36567,
                fairway_around_green_15: 0.23291,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.15313,
                rough_around_green_30: 0.80853,
                total: 2.28784,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6111,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 336.42857,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1500,
            round_date: '2024-06-06T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1500,
            strokes_gained_round: {
                tee: 3.64725,
                sand: 0.0,
                approach: -2.72045,
                putting: 1.07251,
                around_green: 0.43922,
                recovery: 0.0,
                rough_inside_150: -0.5025,
                rough_outside_150: 0.01239,
                fairway_50_to_100: -0.98336,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.42692,
                fairway_outside_200: -0.18195,
                putting_inside_5: 2.19431,
                putting_5_to_10: -1.90101,
                putting_10_to_15: 0.09481,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.67535,
                putting_outside_30: 0.37677,
                fairway_around_green_15: -0.21816,
                fairway_around_green_30: 0.01927,
                rough_around_green_15: 0.88015,
                rough_around_green_30: -0.24204,
                total: 2.43853,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 323.28571,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1499,
            round_date: '2024-06-05T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1499,
            strokes_gained_round: {
                tee: 2.00254,
                sand: 0.0,
                approach: -1.96645,
                putting: -1.36106,
                around_green: 1.03546,
                recovery: 0.0,
                rough_inside_150: 1.66226,
                rough_outside_150: -0.38644,
                fairway_50_to_100: -0.55014,
                fairway_100_to_150: -0.43153,
                fairway_150_to_200: -0.36588,
                fairway_outside_200: -0.31857,
                putting_inside_5: 0.7681,
                putting_5_to_10: -1.01761,
                putting_10_to_15: -0.29893,
                putting_15_to_20: -1.39467,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.58204,
                fairway_around_green_15: -0.35165,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.35493,
                rough_around_green_30: 1.03218,
                total: -0.28951,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 313.5,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1498,
            round_date: '2024-06-04T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1498,
            strokes_gained_round: {
                tee: 1.83241,
                sand: 0.0,
                approach: -0.92208,
                putting: 1.78632,
                around_green: 1.43942,
                recovery: 0.0,
                rough_inside_150: 0.86825,
                rough_outside_150: 0.14921,
                fairway_50_to_100: -0.40044,
                fairway_100_to_150: -0.12351,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.23441,
                putting_inside_5: 1.32473,
                putting_5_to_10: 0.39674,
                putting_10_to_15: -0.40192,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.83448,
                fairway_around_green_15: 0.25824,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.18118,
                rough_around_green_30: 0.0,
                total: 4.13606,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 295.92857,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1497,
            round_date: '2024-06-03T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1497,
            strokes_gained_round: {
                tee: 1.48451,
                sand: 0.0,
                approach: 0.5964,
                putting: 1.46561,
                around_green: -0.61363,
                recovery: 0.0,
                rough_inside_150: 1.32258,
                rough_outside_150: 1.00971,
                fairway_50_to_100: -0.65451,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.17611,
                fairway_outside_200: -0.18577,
                putting_inside_5: 1.60729,
                putting_5_to_10: -0.22699,
                putting_10_to_15: 0.0385,
                putting_15_to_20: 0.36123,
                putting_20_to_30: -0.56797,
                putting_outside_30: 0.25356,
                fairway_around_green_15: 0.21493,
                fairway_around_green_30: -0.62383,
                rough_around_green_15: -0.07414,
                rough_around_green_30: -0.13059,
                total: 2.93289,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 307.0,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1496,
            round_date: '2024-06-02T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1496,
            strokes_gained_round: {
                tee: 1.39658,
                sand: 0.0,
                approach: -2.21524,
                putting: -0.77634,
                around_green: 0.10684,
                recovery: 0.0,
                rough_inside_150: 1.10368,
                rough_outside_150: 0.26461,
                fairway_50_to_100: -1.37904,
                fairway_100_to_150: -0.46769,
                fairway_150_to_200: -0.48171,
                fairway_outside_200: -0.11532,
                putting_inside_5: 0.53085,
                putting_5_to_10: 0.36598,
                putting_10_to_15: -1.27032,
                putting_15_to_20: 0.02002,
                putting_20_to_30: -0.38676,
                putting_outside_30: -0.03611,
                fairway_around_green_15: -0.42646,
                fairway_around_green_30: -0.10656,
                rough_around_green_15: 0.80729,
                rough_around_green_30: -0.16743,
                total: -1.48815,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 311.64286,
                eagles: 0,
                birdies: 2,
                pars: 14,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1495,
            round_date: '2024-06-01T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1495,
            strokes_gained_round: {
                tee: -1.08823,
                sand: 0.0,
                approach: 0.53803,
                putting: -0.45748,
                around_green: 1.2874,
                recovery: 0.0,
                rough_inside_150: 4.03707,
                rough_outside_150: 0.02277,
                fairway_50_to_100: -2.3153,
                fairway_100_to_150: 0.54121,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.34466,
                putting_inside_5: 1.15184,
                putting_5_to_10: -1.04979,
                putting_10_to_15: -0.55258,
                putting_15_to_20: -0.00695,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: -0.11567,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.64743,
                rough_around_green_30: 0.75564,
                total: 0.27972,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -2,
                green_in_regulation_percentage: 0.5,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 287.92857,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1494,
            round_date: '2024-05-31T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1494,
            strokes_gained_round: {
                tee: 3.24618,
                sand: 0.0,
                approach: 0.18213,
                putting: 0.21976,
                around_green: 0.2199,
                recovery: 0.0,
                rough_inside_150: 0.93866,
                rough_outside_150: -0.15567,
                fairway_50_to_100: 0.35403,
                fairway_100_to_150: -0.62934,
                fairway_150_to_200: 0.01285,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.08023,
                putting_5_to_10: -0.18634,
                putting_10_to_15: -1.40269,
                putting_15_to_20: 0.62579,
                putting_20_to_30: -0.27172,
                putting_outside_30: 1.37449,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.42802,
                rough_around_green_15: 0.18526,
                rough_around_green_30: 0.46266,
                total: 3.86797,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 4,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.2222,
                average_driving_distance: 338.64286,
                eagles: 0,
                birdies: 10,
                pars: 4,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.5,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1493,
            round_date: '2024-05-30T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1493,
            strokes_gained_round: {
                tee: 3.28568,
                sand: 0.0,
                approach: -2.34528,
                putting: 0.71961,
                around_green: 1.7473,
                recovery: 0.0,
                rough_inside_150: 2.69939,
                rough_outside_150: -0.0319,
                fairway_50_to_100: -2.1942,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.52171,
                putting_inside_5: -0.19167,
                putting_5_to_10: 2.22522,
                putting_10_to_15: -0.85924,
                putting_15_to_20: -0.39421,
                putting_20_to_30: -0.28023,
                putting_outside_30: 0.21975,
                fairway_around_green_15: -0.10671,
                fairway_around_green_30: -0.00211,
                rough_around_green_15: 1.63333,
                rough_around_green_30: 0.2228,
                total: 3.40732,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0556,
                average_driving_distance: 324.78571,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1492,
            round_date: '2024-05-29T14:38:33.443975-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1492,
            strokes_gained_round: {
                tee: 2.64504,
                sand: 0.0,
                approach: -7.91676,
                putting: 0.54084,
                around_green: 0.8448,
                recovery: 0.0,
                rough_inside_150: -1.73617,
                rough_outside_150: -0.65427,
                fairway_50_to_100: -3.39052,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.98892,
                putting_inside_5: 1.8133,
                putting_5_to_10: -1.4754,
                putting_10_to_15: 0.51505,
                putting_15_to_20: -0.39421,
                putting_20_to_30: -0.45726,
                putting_outside_30: 0.53936,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.30208,
                rough_around_green_15: 1.14688,
                rough_around_green_30: 0.0,
                total: -3.88608,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 313.57143,
                eagles: 0,
                birdies: 2,
                pars: 12,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.2,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1491,
            round_date: '2024-04-30T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1491,
            strokes_gained_round: {
                tee: -0.10918,
                sand: 0.0,
                approach: -3.59985,
                putting: 0.35375,
                around_green: -1.19959,
                recovery: 0.0,
                rough_inside_150: 0.23152,
                rough_outside_150: -0.13994,
                fairway_50_to_100: -1.53498,
                fairway_100_to_150: -2.13072,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.13918,
                putting_5_to_10: 1.21957,
                putting_10_to_15: -2.30043,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.49889,
                putting_outside_30: 0.79432,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -1.22532,
                rough_around_green_15: -0.28705,
                rough_around_green_30: 0.31278,
                total: -4.55487,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 6,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 3,
                green_in_regulation_percentage: 0.4444,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 288.5,
                eagles: 0,
                birdies: 5,
                pars: 5,
                bogeys: 8,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.4,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1490,
            round_date: '2024-04-29T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1490,
            strokes_gained_round: {
                tee: -0.13867,
                sand: 0.0,
                approach: -1.73541,
                putting: -1.26776,
                around_green: 1.88397,
                recovery: 0.0,
                rough_inside_150: 1.57612,
                rough_outside_150: 0.35644,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.70274,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.68194,
                putting_inside_5: 0.50507,
                putting_5_to_10: -0.42322,
                putting_10_to_15: -1.51626,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.41413,
                putting_outside_30: 0.58079,
                fairway_around_green_15: -0.04846,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.59421,
                rough_around_green_30: 1.33821,
                total: -1.25787,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6111,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 297.35714,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1489,
            round_date: '2024-04-28T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'tournament',
            score_to_par: null,
            round_id: 1489,
            strokes_gained_round: {
                tee: -0.39045,
                sand: 0.0,
                approach: -0.7559,
                putting: 3.14809,
                around_green: 2.80218,
                recovery: 0.0,
                rough_inside_150: 1.43915,
                rough_outside_150: 0.94955,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.21246,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.47238,
                putting_inside_5: 1.38269,
                putting_5_to_10: 0.86953,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.4984,
                putting_outside_30: 0.39748,
                fairway_around_green_15: -0.08249,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 2.01933,
                rough_around_green_30: 0.86534,
                total: 4.80392,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6111,
                total_putts: 23,
                three_putt_percentage: 0.0,
                average_driving_distance: 291.64286,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1488,
            round_date: '2024-04-27T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1488,
            strokes_gained_round: {
                tee: 0.20522,
                sand: 0.0,
                approach: -4.20599,
                putting: -1.02031,
                around_green: 0.95142,
                recovery: 0.0,
                rough_inside_150: -0.59467,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.61392,
                fairway_100_to_150: -0.27192,
                fairway_150_to_200: -1.05841,
                fairway_outside_200: -0.71565,
                putting_inside_5: -1.86816,
                putting_5_to_10: -0.55887,
                putting_10_to_15: -0.41013,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 1.81686,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.72521,
                rough_around_green_30: 0.22622,
                total: -4.06965,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 2,
                green_in_regulation_percentage: 0.7778,
                total_putts: 33,
                three_putt_percentage: 0.1667,
                average_driving_distance: 294.92857,
                eagles: 0,
                birdies: 4,
                pars: 8,
                bogeys: 6,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1487,
            round_date: '2024-04-26T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1487,
            strokes_gained_round: {
                tee: 3.27818,
                sand: 0.0,
                approach: -5.12478,
                putting: -0.39994,
                around_green: 0.92928,
                recovery: 0.0,
                rough_inside_150: -0.70821,
                rough_outside_150: -0.18398,
                fairway_50_to_100: -2.37209,
                fairway_100_to_150: -0.16791,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.89007,
                putting_inside_5: 0.83389,
                putting_5_to_10: -1.68979,
                putting_10_to_15: 0.065,
                putting_15_to_20: -0.63274,
                putting_20_to_30: -0.30863,
                putting_outside_30: 1.33233,
                fairway_around_green_15: 0.01388,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.9529,
                rough_around_green_30: -0.0375,
                total: -1.31726,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 329.0,
                eagles: 0,
                birdies: 5,
                pars: 9,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1486,
            round_date: '2024-04-25T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1486,
            strokes_gained_round: {
                tee: 2.09956,
                sand: 0.0,
                approach: -0.54713,
                putting: -2.60362,
                around_green: 0.32343,
                recovery: 0.0,
                rough_inside_150: 0.57428,
                rough_outside_150: 0.05636,
                fairway_50_to_100: -0.40647,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.03811,
                fairway_outside_200: 0.07689,
                putting_inside_5: -1.62262,
                putting_5_to_10: -0.9113,
                putting_10_to_15: -0.95358,
                putting_15_to_20: 0.43789,
                putting_20_to_30: -0.10747,
                putting_outside_30: 0.55346,
                fairway_around_green_15: -0.26066,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.29384,
                rough_around_green_30: 0.29025,
                total: -0.72776,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 3,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -1,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 334.42857,
                eagles: 0,
                birdies: 4,
                pars: 11,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1485,
            round_date: '2024-04-24T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1485,
            strokes_gained_round: {
                tee: 1.61188,
                sand: 0.0,
                approach: -0.29769,
                putting: -0.15034,
                around_green: 1.06185,
                recovery: 0.0,
                rough_inside_150: 0.49397,
                rough_outside_150: 0.63549,
                fairway_50_to_100: -0.24129,
                fairway_100_to_150: -0.09677,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.01542,
                putting_inside_5: 0.37738,
                putting_5_to_10: -1.21718,
                putting_10_to_15: 0.51505,
                putting_15_to_20: 0.36218,
                putting_20_to_30: -0.52018,
                putting_outside_30: 0.33241,
                fairway_around_green_15: -0.1037,
                fairway_around_green_30: 0.30174,
                rough_around_green_15: 0.86381,
                rough_around_green_30: 0.0,
                total: 2.22571,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 299.0,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1484,
            round_date: '2024-04-23T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1484,
            strokes_gained_round: {
                tee: 0.69982,
                sand: 0.0,
                approach: -6.03078,
                putting: 4.33858,
                around_green: 1.33819,
                recovery: 0.0,
                rough_inside_150: -0.46804,
                rough_outside_150: -0.21429,
                fairway_50_to_100: -0.14075,
                fairway_100_to_150: -1.25228,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.87844,
                putting_inside_5: 0.92677,
                putting_5_to_10: 1.18975,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.38726,
                putting_20_to_30: 1.23241,
                putting_outside_30: 0.60239,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.51497,
                rough_around_green_30: 0.82322,
                total: 0.34581,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 313.71429,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1483,
            round_date: '2024-04-22T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'tournament',
            score_to_par: null,
            round_id: 1483,
            strokes_gained_round: {
                tee: 2.63323,
                sand: 0.0,
                approach: -3.27593,
                putting: 1.86869,
                around_green: 0.42477,
                recovery: 0.0,
                rough_inside_150: -0.60672,
                rough_outside_150: -0.18796,
                fairway_50_to_100: -0.51874,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.29138,
                fairway_outside_200: -0.29634,
                putting_inside_5: 0.84833,
                putting_5_to_10: -0.42559,
                putting_10_to_15: -0.955,
                putting_15_to_20: 0.72894,
                putting_20_to_30: 1.05789,
                putting_outside_30: 0.61411,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.4449,
                rough_around_green_15: 0.51753,
                rough_around_green_30: 0.35214,
                total: 1.65076,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 322.57143,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1482,
            round_date: '2024-04-21T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1482,
            strokes_gained_round: {
                tee: 2.18212,
                sand: 0.0,
                approach: -2.24602,
                putting: 2.06373,
                around_green: 0.66153,
                recovery: 0.0,
                rough_inside_150: 1.23551,
                rough_outside_150: -0.43782,
                fairway_50_to_100: -1.59416,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.78802,
                putting_inside_5: 1.43535,
                putting_5_to_10: -0.80833,
                putting_10_to_15: -1.33769,
                putting_15_to_20: 1.01305,
                putting_20_to_30: 0.80134,
                putting_outside_30: 0.96001,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.4691,
                rough_around_green_30: 0.19244,
                total: 2.66137,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 302.64286,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1481,
            round_date: '2024-04-20T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1481,
            strokes_gained_round: {
                tee: 2.87933,
                sand: 0.0,
                approach: -0.44851,
                putting: 0.57064,
                around_green: 0.06818,
                recovery: 0.0,
                rough_inside_150: 1.55109,
                rough_outside_150: 0.8497,
                fairway_50_to_100: -0.98674,
                fairway_100_to_150: -0.75212,
                fairway_150_to_200: -0.77582,
                fairway_outside_200: -0.1577,
                putting_inside_5: 0.51511,
                putting_5_to_10: -1.108,
                putting_10_to_15: -2.35824,
                putting_15_to_20: 0.62579,
                putting_20_to_30: 2.37658,
                putting_outside_30: 0.51942,
                fairway_around_green_15: -0.10874,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.17692,
                rough_around_green_30: 0.0,
                total: 3.06965,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 31,
                three_putt_percentage: 0.1111,
                average_driving_distance: 307.28571,
                eagles: 0,
                birdies: 9,
                pars: 5,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1480,
            round_date: '2024-04-19T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1480,
            strokes_gained_round: {
                tee: 2.80156,
                sand: 0.0,
                approach: -4.61637,
                putting: 2.21449,
                around_green: 0.63928,
                recovery: 0.0,
                rough_inside_150: -1.10903,
                rough_outside_150: -0.4585,
                fairway_50_to_100: -1.00555,
                fairway_100_to_150: 0.30175,
                fairway_150_to_200: -0.0904,
                fairway_outside_200: -0.11,
                putting_inside_5: 1.77104,
                putting_5_to_10: 0.53573,
                putting_10_to_15: -0.50495,
                putting_15_to_20: -0.34169,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.75435,
                fairway_around_green_15: -0.00563,
                fairway_around_green_30: -0.075,
                rough_around_green_15: 0.34891,
                rough_around_green_30: 0.371,
                total: 1.03896,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6111,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 323.78571,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1479,
            round_date: '2024-04-18T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1479,
            strokes_gained_round: {
                tee: 2.682,
                sand: 0.0,
                approach: -3.8172,
                putting: 1.04572,
                around_green: 0.75908,
                recovery: 0.0,
                rough_inside_150: 1.04359,
                rough_outside_150: -0.47083,
                fairway_50_to_100: -1.93012,
                fairway_100_to_150: -0.79741,
                fairway_150_to_200: -0.18165,
                fairway_outside_200: -0.4418,
                putting_inside_5: -0.37864,
                putting_5_to_10: 0.07747,
                putting_10_to_15: 0.54345,
                putting_15_to_20: -0.29106,
                putting_20_to_30: 0.38247,
                putting_outside_30: 0.71203,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.50152,
                rough_around_green_30: 0.25756,
                total: 0.6696,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 316.0,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1478,
            round_date: '2024-04-17T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1478,
            strokes_gained_round: {
                tee: 0.79384,
                sand: 0.0,
                approach: -0.46601,
                putting: 4.10289,
                around_green: -0.06815,
                recovery: 0.0,
                rough_inside_150: 0.81522,
                rough_outside_150: 0.11454,
                fairway_50_to_100: -0.98682,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.0687,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.21847,
                putting_5_to_10: 0.62517,
                putting_10_to_15: -0.47655,
                putting_15_to_20: 0.0,
                putting_20_to_30: 1.82506,
                putting_outside_30: 0.91075,
                fairway_around_green_15: -0.4084,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.34025,
                total: 4.36257,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 308.92857,
                eagles: 0,
                birdies: 9,
                pars: 6,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.5,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1477,
            round_date: '2024-04-16T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'tournament',
            score_to_par: null,
            round_id: 1477,
            strokes_gained_round: {
                tee: 3.29716,
                sand: 0.0,
                approach: -1.01533,
                putting: 4.31717,
                around_green: 0.70887,
                recovery: 0.0,
                rough_inside_150: 1.79494,
                rough_outside_150: -0.0322,
                fairway_50_to_100: -1.54494,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.24065,
                fairway_outside_200: 0.0,
                putting_inside_5: 2.00047,
                putting_5_to_10: -0.19718,
                putting_10_to_15: 0.0,
                putting_15_to_20: 1.66675,
                putting_20_to_30: -0.10747,
                putting_outside_30: 0.95459,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.28362,
                rough_around_green_15: 0.99248,
                rough_around_green_30: 0.0,
                total: 7.30787,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -9,
                green_in_regulation_percentage: 0.7222,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 331.0,
                eagles: 0,
                birdies: 10,
                pars: 7,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.4,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 63,
        },
        {
            id: 1476,
            round_date: '2024-04-15T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1476,
            strokes_gained_round: {
                tee: 3.50375,
                sand: 0.0,
                approach: 0.53773,
                putting: 0.85357,
                around_green: -0.88774,
                recovery: 0.0,
                rough_inside_150: 0.62586,
                rough_outside_150: 0.69591,
                fairway_50_to_100: -1.00379,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.11191,
                putting_inside_5: 0.66042,
                putting_5_to_10: -0.9113,
                putting_10_to_15: 0.59881,
                putting_15_to_20: -0.29106,
                putting_20_to_30: -0.24232,
                putting_outside_30: 1.03901,
                fairway_around_green_15: -0.35116,
                fairway_around_green_30: -0.80934,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.27276,
                total: 4.0073,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.1111,
                average_driving_distance: 332.07143,
                eagles: 1,
                birdies: 6,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.4,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1475,
            round_date: '2024-04-14T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1475,
            strokes_gained_round: {
                tee: 2.494,
                sand: 0.0,
                approach: -2.74645,
                putting: 0.16245,
                around_green: -0.12166,
                recovery: 0.0,
                rough_inside_150: 0.9724,
                rough_outside_150: -0.24502,
                fairway_50_to_100: -1.07971,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.55636,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.45535,
                putting_5_to_10: -0.56316,
                putting_10_to_15: -0.40003,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.3531,
                putting_outside_30: 1.36508,
                fairway_around_green_15: -0.94585,
                fairway_around_green_30: -0.40246,
                rough_around_green_15: 1.22665,
                rough_around_green_30: 0.0,
                total: -0.21166,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 312.57143,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1474,
            round_date: '2024-04-13T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1474,
            strokes_gained_round: {
                tee: 2.33141,
                sand: 0.0,
                approach: -1.07732,
                putting: 0.33843,
                around_green: 1.49661,
                recovery: 0.0,
                rough_inside_150: 2.54854,
                rough_outside_150: -0.12723,
                fairway_50_to_100: -2.12161,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.14521,
                putting_inside_5: 1.64729,
                putting_5_to_10: -0.35051,
                putting_10_to_15: -0.50495,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.71661,
                putting_outside_30: 0.26321,
                fairway_around_green_15: 0.2648,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.60576,
                rough_around_green_30: 0.62605,
                total: 3.08913,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 310.42857,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1473,
            round_date: '2024-04-12T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1473,
            strokes_gained_round: {
                tee: 1.44694,
                sand: 0.0,
                approach: -2.47726,
                putting: -1.13171,
                around_green: 0.34571,
                recovery: 0.0,
                rough_inside_150: 0.50045,
                rough_outside_150: -0.5196,
                fairway_50_to_100: -2.16741,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.03908,
                putting_inside_5: -0.65575,
                putting_5_to_10: -0.7291,
                putting_10_to_15: -0.47655,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -0.58886,
                putting_outside_30: 1.68626,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.09409,
                rough_around_green_15: 0.73499,
                rough_around_green_30: -0.48336,
                total: -1.81632,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 326.92857,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1472,
            round_date: '2024-04-11T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1472,
            strokes_gained_round: {
                tee: 1.79454,
                sand: 0.0,
                approach: 1.45908,
                putting: -0.52259,
                around_green: -0.63593,
                recovery: 0.0,
                rough_inside_150: 1.79805,
                rough_outside_150: 0.43069,
                fairway_50_to_100: -0.70893,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.15921,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.46507,
                putting_5_to_10: -0.42559,
                putting_10_to_15: -1.99282,
                putting_15_to_20: -0.24596,
                putting_20_to_30: 0.84724,
                putting_outside_30: 0.82946,
                fairway_around_green_15: -0.53745,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.09848,
                rough_around_green_30: 0.0,
                total: 2.09509,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 301.57143,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1471,
            round_date: '2024-04-10T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1471,
            strokes_gained_round: {
                tee: 2.55615,
                sand: 0.0,
                approach: 0.62479,
                putting: 0.8687,
                around_green: 1.31704,
                recovery: 0.0,
                rough_inside_150: 3.00045,
                rough_outside_150: -0.09577,
                fairway_50_to_100: -0.47295,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.25339,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.37738,
                putting_5_to_10: -0.65402,
                putting_10_to_15: -1.48645,
                putting_15_to_20: 0.33615,
                putting_20_to_30: 0.80458,
                putting_outside_30: 0.49105,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.07724,
                rough_around_green_15: 0.61675,
                rough_around_green_30: 0.62305,
                total: 5.36668,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 335.07143,
                eagles: 0,
                birdies: 9,
                pars: 7,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.3,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1470,
            round_date: '2024-04-09T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1470,
            strokes_gained_round: {
                tee: 2.31484,
                sand: 0.0,
                approach: -1.1289,
                putting: 2.78972,
                around_green: 1.21463,
                recovery: 0.0,
                rough_inside_150: 1.43875,
                rough_outside_150: 0.05739,
                fairway_50_to_100: -1.19475,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.46586,
                fairway_outside_200: -0.32036,
                putting_inside_5: 0.09137,
                putting_5_to_10: 0.47373,
                putting_10_to_15: 2.08766,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.51971,
                putting_outside_30: 0.65667,
                fairway_around_green_15: 0.21696,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.99768,
                rough_around_green_30: 0.0,
                total: 5.1903,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.07143,
                eagles: 1,
                birdies: 6,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1469,
            round_date: '2024-04-08T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1469,
            strokes_gained_round: {
                tee: 1.39586,
                sand: 0.0,
                approach: 0.68624,
                putting: 1.04445,
                around_green: 0.54898,
                recovery: 0.0,
                rough_inside_150: 2.06183,
                rough_outside_150: 0.30229,
                fairway_50_to_100: -0.84742,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.18645,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.9863,
                putting_5_to_10: -1.108,
                putting_10_to_15: 0.51505,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.17276,
                putting_outside_30: 0.82386,
                fairway_around_green_15: 0.0772,
                fairway_around_green_30: -0.17222,
                rough_around_green_15: 1.03511,
                rough_around_green_30: -0.39111,
                total: 3.67553,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2143,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0556,
                average_driving_distance: 316.42857,
                eagles: 0,
                birdies: 8,
                pars: 7,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.6,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1468,
            round_date: '2024-04-07T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1468,
            strokes_gained_round: {
                tee: 1.78622,
                sand: 0.0,
                approach: 5.00572,
                putting: 0.30749,
                around_green: 0.46248,
                recovery: 0.0,
                rough_inside_150: 2.96691,
                rough_outside_150: 2.17473,
                fairway_50_to_100: 0.2504,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.24896,
                putting_5_to_10: 0.65546,
                putting_10_to_15: 0.57137,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.43732,
                putting_outside_30: 0.10862,
                fairway_around_green_15: 0.02,
                fairway_around_green_30: 0.05616,
                rough_around_green_15: 0.38632,
                rough_around_green_30: 0.0,
                total: 7.56191,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.1429,
                score_to_par: -9,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 321.42857,
                eagles: 0,
                birdies: 10,
                pars: 7,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.4,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 63,
        },
        {
            id: 1467,
            round_date: '2024-04-06T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1467,
            strokes_gained_round: {
                tee: 0.85355,
                sand: 0.0,
                approach: 2.74822,
                putting: -1.63472,
                around_green: 0.15411,
                recovery: 0.0,
                rough_inside_150: 1.4108,
                rough_outside_150: 0.57618,
                fairway_50_to_100: -0.14749,
                fairway_100_to_150: 0.62141,
                fairway_150_to_200: 0.86425,
                fairway_outside_200: -0.31044,
                putting_inside_5: -1.58949,
                putting_5_to_10: 0.36598,
                putting_10_to_15: -0.43853,
                putting_15_to_20: -0.7094,
                putting_20_to_30: -0.32613,
                putting_outside_30: 1.06285,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.18904,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.34315,
                total: 2.12116,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 295.21429,
                eagles: 1,
                birdies: 4,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1466,
            round_date: '2024-04-05T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1466,
            strokes_gained_round: {
                tee: 2.51158,
                sand: 0.0,
                approach: 0.56369,
                putting: 0.72659,
                around_green: -0.13757,
                recovery: 0.0,
                rough_inside_150: 0.70987,
                rough_outside_150: 0.11003,
                fairway_50_to_100: 0.65363,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.18358,
                fairway_outside_200: -0.36939,
                putting_inside_5: -0.06541,
                putting_5_to_10: 1.03547,
                putting_10_to_15: -0.29845,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.39095,
                putting_outside_30: 0.76207,
                fairway_around_green_15: -0.49445,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.35485,
                rough_around_green_30: 0.00203,
                total: 3.66429,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 325.71429,
                eagles: 0,
                birdies: 8,
                pars: 7,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1465,
            round_date: '2024-04-04T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1465,
            strokes_gained_round: {
                tee: 0.34128,
                sand: 0.0,
                approach: 0.22147,
                putting: -0.46566,
                around_green: 1.31208,
                recovery: 0.0,
                rough_inside_150: 1.59108,
                rough_outside_150: 1.07291,
                fairway_50_to_100: -0.04807,
                fairway_100_to_150: -1.30154,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.00638,
                putting_inside_5: 1.06189,
                putting_5_to_10: -1.93225,
                putting_10_to_15: -0.44863,
                putting_15_to_20: 0.62579,
                putting_20_to_30: -0.06631,
                putting_outside_30: 0.29385,
                fairway_around_green_15: 0.22556,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.82059,
                rough_around_green_30: 0.26594,
                total: 1.40918,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.1111,
                average_driving_distance: 295.5,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1464,
            round_date: '2024-04-03T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1464,
            strokes_gained_round: {
                tee: 1.81129,
                sand: 0.0,
                approach: -3.83385,
                putting: -0.76491,
                around_green: 1.07201,
                recovery: 0.0,
                rough_inside_150: -1.08734,
                rough_outside_150: -0.18447,
                fairway_50_to_100: -1.17284,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.33386,
                putting_inside_5: -0.67575,
                putting_5_to_10: -0.48569,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -0.92332,
                putting_20_to_30: 0.91253,
                putting_outside_30: 0.94113,
                fairway_around_green_15: 0.05721,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.6339,
                rough_around_green_30: 0.38091,
                total: -1.71547,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 312.14286,
                eagles: 0,
                birdies: 2,
                pars: 13,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1463,
            round_date: '2024-04-02T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1463,
            strokes_gained_round: {
                tee: 2.2489,
                sand: 0.0,
                approach: -0.44171,
                putting: -3.17916,
                around_green: -1.15465,
                recovery: 0.0,
                rough_inside_150: 0.95948,
                rough_outside_150: -0.28343,
                fairway_50_to_100: -1.49312,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.017,
                putting_inside_5: 0.99412,
                putting_5_to_10: -2.58579,
                putting_10_to_15: -0.91603,
                putting_15_to_20: -0.76193,
                putting_20_to_30: -0.32329,
                putting_outside_30: 0.41376,
                fairway_around_green_15: -0.34839,
                fairway_around_green_30: -0.81372,
                rough_around_green_15: 0.09644,
                rough_around_green_30: -0.08899,
                total: -2.52663,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 321.07143,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1462,
            round_date: '2024-04-01T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1462,
            strokes_gained_round: {
                tee: 0.01305,
                sand: 0.0,
                approach: -3.71804,
                putting: 1.32743,
                around_green: -0.6632,
                recovery: 0.0,
                rough_inside_150: -2.46659,
                rough_outside_150: 0.32457,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.92448,
                fairway_150_to_200: -0.27388,
                fairway_outside_200: -0.09602,
                putting_inside_5: 0.82322,
                putting_5_to_10: -0.65402,
                putting_10_to_15: -0.41013,
                putting_15_to_20: -0.63274,
                putting_20_to_30: 0.86947,
                putting_outside_30: 1.33163,
                fairway_around_green_15: -0.06076,
                fairway_around_green_30: -0.30424,
                rough_around_green_15: -0.29821,
                rough_around_green_30: 0.0,
                total: -3.04076,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 295.35714,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1461,
            round_date: '2024-03-31T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1461,
            strokes_gained_round: {
                tee: 3.44347,
                sand: 0.0,
                approach: -1.52358,
                putting: 1.25158,
                around_green: 1.45699,
                recovery: 0.0,
                rough_inside_150: 1.49136,
                rough_outside_150: -0.41911,
                fairway_50_to_100: -1.04991,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.59696,
                fairway_outside_200: -0.22095,
                putting_inside_5: 2.03055,
                putting_5_to_10: -1.03532,
                putting_10_to_15: 0.59881,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.58832,
                putting_outside_30: 0.24585,
                fairway_around_green_15: 0.26479,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.50818,
                rough_around_green_30: -0.31598,
                total: 4.62847,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 26,
                three_putt_percentage: 0.0556,
                average_driving_distance: 335.57143,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1460,
            round_date: '2024-03-30T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1460,
            strokes_gained_round: {
                tee: 2.47333,
                sand: 0.0,
                approach: -5.2917,
                putting: 0.87821,
                around_green: -0.31382,
                recovery: 0.0,
                rough_inside_150: -0.93193,
                rough_outside_150: 0.0,
                fairway_50_to_100: -2.79204,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -1.0979,
                fairway_outside_200: -0.29872,
                putting_inside_5: 0.5182,
                putting_5_to_10: 0.76177,
                putting_10_to_15: -1.53455,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.12876,
                putting_outside_30: 1.26155,
                fairway_around_green_15: -0.1982,
                fairway_around_green_30: -0.28672,
                rough_around_green_15: 0.98735,
                rough_around_green_30: -0.81625,
                total: -2.25397,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 331.78571,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1459,
            round_date: '2024-03-29T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1459,
            strokes_gained_round: {
                tee: 1.69213,
                sand: 0.0,
                approach: -1.56605,
                putting: 2.44098,
                around_green: -0.33604,
                recovery: 0.0,
                rough_inside_150: 0.18683,
                rough_outside_150: 0.05304,
                fairway_50_to_100: -0.40292,
                fairway_100_to_150: -0.25208,
                fairway_150_to_200: -0.49266,
                fairway_outside_200: 0.16012,
                putting_inside_5: 1.28934,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.12273,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.25837,
                putting_outside_30: 0.77054,
                fairway_around_green_15: -0.57945,
                fairway_around_green_30: -0.57497,
                rough_around_green_15: 0.1618,
                rough_around_green_30: 0.65658,
                total: 2.23104,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 308.07143,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1458,
            round_date: '2024-03-28T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1458,
            strokes_gained_round: {
                tee: 1.16517,
                sand: 0.0,
                approach: -0.11013,
                putting: 1.92407,
                around_green: -0.0783,
                recovery: 0.0,
                rough_inside_150: -0.44353,
                rough_outside_150: 0.32411,
                fairway_50_to_100: 0.34709,
                fairway_100_to_150: -0.26471,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.1229,
                putting_inside_5: -0.17167,
                putting_5_to_10: 1.55478,
                putting_10_to_15: 0.17763,
                putting_15_to_20: 0.70387,
                putting_20_to_30: -0.74311,
                putting_outside_30: 0.40256,
                fairway_around_green_15: 0.27944,
                fairway_around_green_30: -0.55372,
                rough_around_green_15: 0.19598,
                rough_around_green_30: 0.0,
                total: 2.90081,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 286.5,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1457,
            round_date: '2024-03-27T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1457,
            strokes_gained_round: {
                tee: 2.35853,
                sand: 0.0,
                approach: -4.27633,
                putting: 2.82583,
                around_green: 0.89387,
                recovery: 0.0,
                rough_inside_150: -0.85459,
                rough_outside_150: 0.12879,
                fairway_50_to_100: -1.58762,
                fairway_100_to_150: 0.1466,
                fairway_150_to_200: -0.54999,
                fairway_outside_200: -0.66565,
                putting_inside_5: 1.22981,
                putting_5_to_10: 0.56507,
                putting_10_to_15: -0.32732,
                putting_15_to_20: 0.65229,
                putting_20_to_30: -0.32329,
                putting_outside_30: 1.02928,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.86076,
                rough_around_green_30: 0.0331,
                total: 1.8019,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 315.78571,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1456,
            round_date: '2024-03-26T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1456,
            strokes_gained_round: {
                tee: 2.2157,
                sand: 0.0,
                approach: -4.86863,
                putting: 2.82479,
                around_green: -0.04234,
                recovery: 0.0,
                rough_inside_150: 0.33427,
                rough_outside_150: -0.26924,
                fairway_50_to_100: -1.70787,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.5608,
                fairway_outside_200: -0.63585,
                putting_inside_5: 0.61013,
                putting_5_to_10: 0.0,
                putting_10_to_15: -0.35477,
                putting_15_to_20: 1.24604,
                putting_20_to_30: 0.96563,
                putting_outside_30: 0.35776,
                fairway_around_green_15: -0.4201,
                fairway_around_green_30: -0.67813,
                rough_around_green_15: 0.62009,
                rough_around_green_30: 0.43581,
                total: 0.12952,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.71429,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1455,
            round_date: '2024-03-25T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1455,
            strokes_gained_round: {
                tee: 3.37409,
                sand: 0.0,
                approach: 0.90259,
                putting: 0.15482,
                around_green: -0.44636,
                recovery: 0.0,
                rough_inside_150: 1.1322,
                rough_outside_150: -0.07094,
                fairway_50_to_100: -1.43402,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.8704,
                fairway_outside_200: 0.01584,
                putting_inside_5: -0.22896,
                putting_5_to_10: 0.19957,
                putting_10_to_15: -0.43995,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.21866,
                putting_outside_30: 0.84282,
                fairway_around_green_15: 0.00939,
                fairway_around_green_30: -0.23203,
                rough_around_green_15: 0.38,
                rough_around_green_30: -0.60373,
                total: 3.98515,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 328.42857,
                eagles: 1,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1454,
            round_date: '2024-03-24T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1454,
            strokes_gained_round: {
                tee: 2.58591,
                sand: 0.0,
                approach: -1.34147,
                putting: 4.8571,
                around_green: 1.28022,
                recovery: 0.0,
                rough_inside_150: 0.54428,
                rough_outside_150: 1.71317,
                fairway_50_to_100: -1.00238,
                fairway_100_to_150: -0.31453,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.28956,
                putting_5_to_10: 1.82942,
                putting_10_to_15: 0.12226,
                putting_15_to_20: 0.70387,
                putting_20_to_30: 0.53489,
                putting_outside_30: 0.37709,
                fairway_around_green_15: -0.09426,
                fairway_around_green_30: 0.18632,
                rough_around_green_15: 1.13267,
                rough_around_green_30: 0.05549,
                total: 7.38176,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -9,
                green_in_regulation_percentage: 0.6667,
                total_putts: 22,
                three_putt_percentage: 0.0,
                average_driving_distance: 334.92857,
                eagles: 2,
                birdies: 7,
                pars: 7,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 3.5,
            },
            par: 72,
            strokes_total: 63,
        },
        {
            id: 1453,
            round_date: '2024-03-23T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1453,
            strokes_gained_round: {
                tee: 1.86467,
                sand: 0.0,
                approach: 1.20397,
                putting: 0.1775,
                around_green: 0.19581,
                recovery: 0.0,
                rough_inside_150: 1.93188,
                rough_outside_150: 0.19866,
                fairway_50_to_100: -0.45293,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.2898,
                fairway_outside_200: -0.08625,
                putting_inside_5: 0.66089,
                putting_5_to_10: 0.36598,
                putting_10_to_15: -0.41013,
                putting_15_to_20: -0.29106,
                putting_20_to_30: -0.61394,
                putting_outside_30: 0.46576,
                fairway_around_green_15: 0.32714,
                fairway_around_green_30: -0.86949,
                rough_around_green_15: 0.3534,
                rough_around_green_30: 0.38476,
                total: 3.44196,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.57143,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1452,
            round_date: '2024-03-22T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1452,
            strokes_gained_round: {
                tee: 1.71317,
                sand: 0.0,
                approach: 0.24636,
                putting: 2.47493,
                around_green: 0.24034,
                recovery: 0.0,
                rough_inside_150: 1.56577,
                rough_outside_150: 0.84627,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.63853,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.35246,
                putting_inside_5: 0.8152,
                putting_5_to_10: -0.22841,
                putting_10_to_15: 0.13142,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.38437,
                putting_outside_30: 1.37235,
                fairway_around_green_15: -0.04953,
                fairway_around_green_30: -0.28402,
                rough_around_green_15: 0.57388,
                rough_around_green_30: 0.0,
                total: 4.67479,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 299.92857,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1451,
            round_date: '2024-03-21T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1451,
            strokes_gained_round: {
                tee: 0.89525,
                sand: 0.0,
                approach: -3.33434,
                putting: 0.27143,
                around_green: -0.36865,
                recovery: 0.0,
                rough_inside_150: 0.15453,
                rough_outside_150: -0.12006,
                fairway_50_to_100: -1.92449,
                fairway_100_to_150: -0.80384,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.03324,
                putting_inside_5: 1.42909,
                putting_5_to_10: -1.30804,
                putting_10_to_15: -0.98245,
                putting_15_to_20: 0.65229,
                putting_20_to_30: -0.25752,
                putting_outside_30: 0.73806,
                fairway_around_green_15: -0.51142,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.14277,
                rough_around_green_30: 0.0,
                total: -2.53632,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 3,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6111,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 299.28571,
                eagles: 0,
                birdies: 4,
                pars: 9,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1450,
            round_date: '2024-03-20T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1450,
            strokes_gained_round: {
                tee: 4.03632,
                sand: 0.0,
                approach: -2.59832,
                putting: -3.01282,
                around_green: 0.53044,
                recovery: 0.0,
                rough_inside_150: 0.40214,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.77251,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.40858,
                fairway_outside_200: -0.65675,
                putting_inside_5: -1.47199,
                putting_5_to_10: -0.3813,
                putting_10_to_15: -0.92613,
                putting_15_to_20: -1.02695,
                putting_20_to_30: -0.06631,
                putting_outside_30: 0.85987,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.18282,
                rough_around_green_30: 0.34763,
                total: -1.04438,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: 0,
                green_in_regulation_percentage: 0.8889,
                total_putts: 35,
                three_putt_percentage: 0.1111,
                average_driving_distance: 328.85714,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1449,
            round_date: '2024-03-19T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1449,
            strokes_gained_round: {
                tee: 2.35396,
                sand: 0.0,
                approach: -1.48118,
                putting: 2.08682,
                around_green: 0.01368,
                recovery: 0.0,
                rough_inside_150: 0.41737,
                rough_outside_150: 0.36927,
                fairway_50_to_100: -0.03412,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.73958,
                fairway_outside_200: -0.4553,
                putting_inside_5: 0.91412,
                putting_5_to_10: -0.94348,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 1.4022,
                putting_20_to_30: 0.51921,
                putting_outside_30: 0.61596,
                fairway_around_green_15: 0.05315,
                fairway_around_green_30: -0.30036,
                rough_around_green_15: 0.30281,
                rough_around_green_30: -0.04192,
                total: 2.97328,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 322.57143,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1448,
            round_date: '2024-03-18T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1448,
            strokes_gained_round: {
                tee: 2.28949,
                sand: 0.0,
                approach: 0.35221,
                putting: -0.17565,
                around_green: -0.1296,
                recovery: 0.0,
                rough_inside_150: 0.68771,
                rough_outside_150: -0.45333,
                fairway_50_to_100: -0.59592,
                fairway_100_to_150: 0.43592,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.83389,
                putting_5_to_10: 0.66949,
                putting_10_to_15: -1.4489,
                putting_15_to_20: -0.29106,
                putting_20_to_30: -0.61624,
                putting_outside_30: 0.67716,
                fairway_around_green_15: -0.02858,
                fairway_around_green_30: 0.30174,
                rough_around_green_15: -0.01429,
                rough_around_green_30: -0.38848,
                total: 2.33645,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 3,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 326.85714,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1431,
            round_date: '2024-03-17T20:08:19.576-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 0,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1431,
            strokes_gained_round: {
                tee: 0.0,
                sand: 0.0,
                approach: 0.0,
                putting: 0.0,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.0,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.0,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.0,
                score_to_par: 0,
                green_in_regulation_percentage: 0.0,
                total_putts: 0,
                three_putt_percentage: 0.0,
                average_driving_distance: 0.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 0,
            },
            par: 0,
            strokes_total: 0,
        },
        {
            id: 1447,
            round_date: '2024-03-17T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1447,
            strokes_gained_round: {
                tee: 1.54029,
                sand: 0.0,
                approach: 2.29092,
                putting: -2.74895,
                around_green: 0.53087,
                recovery: 0.0,
                rough_inside_150: 1.89163,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.49473,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.24565,
                fairway_outside_200: 0.76428,
                putting_inside_5: -1.00258,
                putting_5_to_10: -1.62732,
                putting_10_to_15: 0.00963,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -0.08665,
                putting_outside_30: 0.32568,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.4333,
                rough_around_green_15: 0.56282,
                rough_around_green_30: 0.40135,
                total: 1.61314,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.1111,
                average_driving_distance: 306.21429,
                eagles: 1,
                birdies: 4,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1446,
            round_date: '2024-03-16T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1446,
            strokes_gained_round: {
                tee: 2.37041,
                sand: 0.0,
                approach: -1.08295,
                putting: -2.40007,
                around_green: 0.39836,
                recovery: 0.0,
                rough_inside_150: 1.04342,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.68227,
                fairway_150_to_200: -0.17468,
                fairway_outside_200: -0.4299,
                putting_inside_5: 1.30981,
                putting_5_to_10: -2.4954,
                putting_10_to_15: -0.89774,
                putting_15_to_20: -0.27104,
                putting_20_to_30: -0.5329,
                putting_outside_30: 0.4872,
                fairway_around_green_15: -0.27992,
                fairway_around_green_30: -0.16123,
                rough_around_green_15: 0.11408,
                rough_around_green_30: 0.72543,
                total: -0.71425,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 334.78571,
                eagles: 0,
                birdies: 6,
                pars: 7,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1445,
            round_date: '2024-03-15T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1445,
            strokes_gained_round: {
                tee: 2.32958,
                sand: 0.0,
                approach: 0.59188,
                putting: -0.03265,
                around_green: 0.20093,
                recovery: 0.0,
                rough_inside_150: 1.14426,
                rough_outside_150: 0.09069,
                fairway_50_to_100: -0.11351,
                fairway_100_to_150: -0.5073,
                fairway_150_to_200: 0.46614,
                fairway_outside_200: 0.16202,
                putting_inside_5: 0.26981,
                putting_5_to_10: -0.25823,
                putting_10_to_15: -0.46692,
                putting_15_to_20: -0.31613,
                putting_20_to_30: 0.45534,
                putting_outside_30: 0.28348,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.44949,
                rough_around_green_15: 0.97415,
                rough_around_green_30: -0.32373,
                total: 3.08974,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 297.85714,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1444,
            round_date: '2024-03-14T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1444,
            strokes_gained_round: {
                tee: 2.31639,
                sand: 0.0,
                approach: -2.55151,
                putting: 0.02948,
                around_green: 1.14207,
                recovery: 0.0,
                rough_inside_150: 0.44798,
                rough_outside_150: -0.22463,
                fairway_50_to_100: -0.42969,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.76413,
                fairway_outside_200: -0.35892,
                putting_inside_5: 0.23847,
                putting_5_to_10: 0.22985,
                putting_10_to_15: -0.35429,
                putting_15_to_20: -0.05948,
                putting_20_to_30: -0.39142,
                putting_outside_30: 0.36635,
                fairway_around_green_15: 0.05315,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.82407,
                rough_around_green_30: 0.26485,
                total: 0.93643,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 329.0,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1443,
            round_date: '2024-03-13T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1443,
            strokes_gained_round: {
                tee: 3.61446,
                sand: 0.0,
                approach: 1.59824,
                putting: 3.27124,
                around_green: 1.17491,
                recovery: 0.0,
                rough_inside_150: 2.24291,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.04118,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.16685,
                fairway_outside_200: -0.12964,
                putting_inside_5: 0.43085,
                putting_5_to_10: 2.49844,
                putting_10_to_15: -1.03876,
                putting_15_to_20: 1.38123,
                putting_20_to_30: -0.43779,
                putting_outside_30: 0.43727,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.27332,
                rough_around_green_15: 0.56413,
                rough_around_green_30: 0.33746,
                total: 9.65886,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -11,
                green_in_regulation_percentage: 0.8889,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 331.28571,
                eagles: 1,
                birdies: 9,
                pars: 8,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.4,
                par_5_score: 3.75,
            },
            par: 72,
            strokes_total: 61,
        },
        {
            id: 1442,
            round_date: '2024-03-12T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1442,
            strokes_gained_round: {
                tee: 2.72275,
                sand: 0.0,
                approach: -1.66979,
                putting: -0.56194,
                around_green: 1.16877,
                recovery: 0.0,
                rough_inside_150: 2.55708,
                rough_outside_150: -0.11397,
                fairway_50_to_100: -1.00422,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.16727,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.52245,
                putting_5_to_10: -0.08942,
                putting_10_to_15: -1.31222,
                putting_15_to_20: -0.60719,
                putting_20_to_30: -0.26043,
                putting_outside_30: 0.18487,
                fairway_around_green_15: -0.29474,
                fairway_around_green_30: 0.14829,
                rough_around_green_15: 1.40509,
                rough_around_green_30: -0.08987,
                total: 1.65979,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 326.14286,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1441,
            round_date: '2024-03-11T00:56:45.233898-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1441,
            strokes_gained_round: {
                tee: -0.20487,
                sand: 0.0,
                approach: 1.49014,
                putting: 3.39446,
                around_green: 0.91152,
                recovery: 0.0,
                rough_inside_150: 2.10485,
                rough_outside_150: -0.17278,
                fairway_50_to_100: 0.03854,
                fairway_100_to_150: 0.25181,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.56823,
                putting_5_to_10: 0.85359,
                putting_10_to_15: 1.62987,
                putting_15_to_20: -1.00045,
                putting_20_to_30: -0.21542,
                putting_outside_30: 0.55864,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.31304,
                rough_around_green_30: 0.59848,
                total: 5.59125,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7778,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 303.0,
                eagles: 0,
                birdies: 9,
                pars: 7,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.4,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1440,
            round_date: '2024-03-10T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1440,
            strokes_gained_round: {
                tee: 3.01034,
                sand: 0.0,
                approach: -1.42226,
                putting: -0.15792,
                around_green: 1.72933,
                recovery: 0.0,
                rough_inside_150: 3.41922,
                rough_outside_150: 0.0,
                fairway_50_to_100: -1.94192,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.74895,
                fairway_outside_200: -0.45792,
                putting_inside_5: -0.36987,
                putting_5_to_10: -0.24181,
                putting_10_to_15: 0.15018,
                putting_15_to_20: 0.25807,
                putting_20_to_30: -0.17276,
                putting_outside_30: 0.21826,
                fairway_around_green_15: 0.23822,
                fairway_around_green_30: 0.03964,
                rough_around_green_15: 1.03359,
                rough_around_green_30: 0.41789,
                total: 3.15948,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 325.85714,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1439,
            round_date: '2024-03-09T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1439,
            strokes_gained_round: {
                tee: 0.69874,
                sand: 0.0,
                approach: 0.39442,
                putting: 3.17154,
                around_green: 0.63918,
                recovery: 0.0,
                rough_inside_150: 2.33212,
                rough_outside_150: -0.20534,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.34562,
                putting_inside_5: 0.76417,
                putting_5_to_10: 1.92124,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.19547,
                putting_outside_30: 0.68161,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.92566,
                rough_around_green_15: 1.09181,
                rough_around_green_30: 0.47303,
                total: 4.90388,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 313.14286,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1438,
            round_date: '2024-03-08T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1438,
            strokes_gained_round: {
                tee: 1.30546,
                sand: 0.0,
                approach: -3.63978,
                putting: 1.49,
                around_green: 0.82995,
                recovery: 0.0,
                rough_inside_150: -1.43306,
                rough_outside_150: -0.24067,
                fairway_50_to_100: -0.65159,
                fairway_100_to_150: -0.50451,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.23847,
                putting_5_to_10: -0.51551,
                putting_10_to_15: -0.01876,
                putting_15_to_20: -0.65877,
                putting_20_to_30: 0.42079,
                putting_outside_30: 1.02378,
                fairway_around_green_15: 0.02,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.50373,
                rough_around_green_30: 0.30622,
                total: -0.01437,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.1429,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 301.5,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.1,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1437,
            round_date: '2024-03-07T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1437,
            strokes_gained_round: {
                tee: 1.32195,
                sand: 0.0,
                approach: 0.64958,
                putting: -1.70217,
                around_green: 0.28234,
                recovery: 0.0,
                rough_inside_150: 0.40145,
                rough_outside_150: -0.06198,
                fairway_50_to_100: 0.57778,
                fairway_100_to_150: -0.82319,
                fairway_150_to_200: 0.21325,
                fairway_outside_200: 0.29817,
                putting_inside_5: 0.25763,
                putting_5_to_10: -0.94253,
                putting_10_to_15: -0.95358,
                putting_15_to_20: 0.33663,
                putting_20_to_30: -0.56805,
                putting_outside_30: 0.16774,
                fairway_around_green_15: 0.32643,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.08672,
                rough_around_green_30: 0.04263,
                total: 0.5517,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6667,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 306.78571,
                eagles: 1,
                birdies: 3,
                pars: 11,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1436,
            round_date: '2024-03-06T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1436,
            strokes_gained_round: {
                tee: 2.98968,
                sand: 0.0,
                approach: -2.62152,
                putting: -1.33739,
                around_green: 1.96413,
                recovery: 0.0,
                rough_inside_150: 0.76195,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.89216,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.52026,
                fairway_outside_200: -0.28931,
                putting_inside_5: 1.20402,
                putting_5_to_10: -2.07866,
                putting_10_to_15: -1.44721,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.82493,
                putting_outside_30: 0.52724,
                fairway_around_green_15: 0.23822,
                fairway_around_green_30: -0.08556,
                rough_around_green_15: 1.09182,
                rough_around_green_30: 0.71965,
                total: 0.9949,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 335.28571,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 2,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1435,
            round_date: '2024-03-05T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1435,
            strokes_gained_round: {
                tee: 2.43761,
                sand: 0.0,
                approach: -1.57651,
                putting: 1.11272,
                around_green: 0.73373,
                recovery: 0.0,
                rough_inside_150: 1.18601,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.992,
                fairway_100_to_150: -0.74721,
                fairway_150_to_200: -0.23198,
                fairway_outside_200: 0.13846,
                putting_inside_5: 1.24534,
                putting_5_to_10: -1.37148,
                putting_10_to_15: 0.01011,
                putting_15_to_20: -0.31613,
                putting_20_to_30: 0.41316,
                putting_outside_30: 1.13173,
                fairway_around_green_15: -0.16507,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.71925,
                rough_around_green_30: 0.17955,
                total: 2.70755,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 317.5,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1434,
            round_date: '2024-03-04T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1434,
            strokes_gained_round: {
                tee: 2.13957,
                sand: 0.0,
                approach: -1.29561,
                putting: 1.46454,
                around_green: -0.76666,
                recovery: 0.0,
                rough_inside_150: 0.37171,
                rough_outside_150: 0.32683,
                fairway_50_to_100: -1.35687,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.99317,
                putting_5_to_10: 0.0,
                putting_10_to_15: -1.01037,
                putting_15_to_20: -0.7094,
                putting_20_to_30: 0.674,
                putting_outside_30: 1.51714,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -1.31312,
                rough_around_green_15: 0.54646,
                rough_around_green_30: 0.0,
                total: 1.54184,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 333.28571,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1433,
            round_date: '2024-03-03T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1433,
            strokes_gained_round: {
                tee: 1.40271,
                sand: 0.0,
                approach: 1.99837,
                putting: 2.47215,
                around_green: 0.59364,
                recovery: 0.0,
                rough_inside_150: 2.12595,
                rough_outside_150: 0.51315,
                fairway_50_to_100: 0.72036,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.30294,
                putting_5_to_10: 0.2308,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.72894,
                putting_20_to_30: -0.52729,
                putting_outside_30: 0.73675,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.42696,
                rough_around_green_15: 0.37734,
                rough_around_green_30: 0.64325,
                total: 6.46687,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2143,
                score_to_par: -8,
                green_in_regulation_percentage: 0.8333,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 313.5,
                eagles: 1,
                birdies: 6,
                pars: 11,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 3.75,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1432,
            round_date: '2024-03-02T00:56:45.233898-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1432,
            strokes_gained_round: {
                tee: 1.17268,
                sand: 0.0,
                approach: -2.32548,
                putting: 0.93579,
                around_green: 0.68633,
                recovery: 0.0,
                rough_inside_150: 1.8739,
                rough_outside_150: 0.02383,
                fairway_50_to_100: -2.28425,
                fairway_100_to_150: -0.48967,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.55308,
                putting_inside_5: 1.40909,
                putting_5_to_10: -0.65402,
                putting_10_to_15: -0.94395,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 0.53536,
                putting_outside_30: 0.98352,
                fairway_around_green_15: 0.03504,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.3344,
                rough_around_green_30: 0.31689,
                total: 0.46932,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 303.0,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1430,
            round_date: '2024-02-05T03:04:10.722-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1430,
            strokes_gained_round: {
                tee: 2.35685,
                sand: 0.0,
                approach: 1.63621,
                putting: -1.74686,
                around_green: 1.2477,
                recovery: 0.0,
                rough_inside_150: 0.95576,
                rough_outside_150: 0.92783,
                fairway_50_to_100: 1.34685,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.44755,
                fairway_outside_200: -0.05312,
                putting_inside_5: 1.09634,
                putting_5_to_10: -1.76297,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.24232,
                putting_outside_30: 0.01204,
                fairway_around_green_15: -0.08715,
                fairway_around_green_30: 0.2413,
                rough_around_green_15: 0.96957,
                rough_around_green_30: 0.12398,
                total: 3.4939,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 316.57143,
                eagles: 1,
                birdies: 6,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1429,
            round_date: '2024-02-04T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1429,
            strokes_gained_round: {
                tee: 1.35642,
                sand: 0.0,
                approach: -4.24258,
                putting: 0.38414,
                around_green: 1.82091,
                recovery: 0.0,
                rough_inside_150: 1.03015,
                rough_outside_150: -0.70095,
                fairway_50_to_100: -0.28901,
                fairway_100_to_150: -1.74124,
                fairway_150_to_200: -0.49783,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.68326,
                putting_5_to_10: 0.53573,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -0.37325,
                putting_20_to_30: -0.41413,
                putting_outside_30: 0.48634,
                fairway_around_green_15: -0.1529,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.45642,
                rough_around_green_30: 0.51738,
                total: -0.68111,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -1,
                green_in_regulation_percentage: 0.6667,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 303.07143,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.1,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1428,
            round_date: '2024-02-03T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1428,
            strokes_gained_round: {
                tee: 1.9612,
                sand: 0.0,
                approach: 0.47982,
                putting: -0.46477,
                around_green: -0.11769,
                recovery: 0.0,
                rough_inside_150: 0.9285,
                rough_outside_150: 0.13434,
                fairway_50_to_100: -0.23629,
                fairway_100_to_150: -0.09677,
                fairway_150_to_200: -0.18645,
                fairway_outside_200: -0.30461,
                putting_inside_5: 0.10606,
                putting_5_to_10: -0.45446,
                putting_10_to_15: -0.43853,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.43921,
                putting_outside_30: 0.76137,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.10349,
                rough_around_green_15: 0.30729,
                rough_around_green_30: -0.32149,
                total: 1.85857,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 326.07143,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1427,
            round_date: '2024-02-02T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1427,
            strokes_gained_round: {
                tee: 1.26616,
                sand: 0.0,
                approach: -1.52437,
                putting: 3.76984,
                around_green: -0.01393,
                recovery: 0.0,
                rough_inside_150: -0.57014,
                rough_outside_150: -0.36987,
                fairway_50_to_100: -0.41105,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.14563,
                putting_inside_5: 0.65592,
                putting_5_to_10: 0.56554,
                putting_10_to_15: -0.01876,
                putting_15_to_20: 1.04049,
                putting_20_to_30: 0.78377,
                putting_outside_30: 0.74288,
                fairway_around_green_15: 0.02,
                fairway_around_green_30: -0.13283,
                rough_around_green_15: 0.19933,
                rough_around_green_30: -0.10044,
                total: 3.4977,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 311.07143,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.6,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1426,
            round_date: '2024-02-01T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1426,
            strokes_gained_round: {
                tee: 2.15872,
                sand: 0.0,
                approach: -0.37306,
                putting: -0.2901,
                around_green: 0.65464,
                recovery: 0.0,
                rough_inside_150: 0.43455,
                rough_outside_150: 0.67597,
                fairway_50_to_100: -0.55094,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.65992,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.64262,
                putting_5_to_10: 1.15946,
                putting_10_to_15: -1.03876,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.36824,
                putting_outside_30: 0.60005,
                fairway_around_green_15: -0.13322,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.22785,
                rough_around_green_30: 0.56001,
                total: 2.1502,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 329.14286,
                eagles: 0,
                birdies: 8,
                pars: 6,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1425,
            round_date: '2024-01-31T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1425,
            strokes_gained_round: {
                tee: 2.65238,
                sand: 0.0,
                approach: 1.23207,
                putting: 0.004,
                around_green: -1.37279,
                recovery: 0.0,
                rough_inside_150: 2.75563,
                rough_outside_150: 0.23387,
                fairway_50_to_100: -0.6234,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.42263,
                putting_inside_5: 0.95412,
                putting_5_to_10: -0.25823,
                putting_10_to_15: -0.37353,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.69531,
                putting_outside_30: 0.37695,
                fairway_around_green_15: -1.09746,
                fairway_around_green_30: -1.37778,
                rough_around_green_15: 1.10246,
                rough_around_green_30: 0.0,
                total: 2.51566,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 322.64286,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1424,
            round_date: '2024-01-30T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1424,
            strokes_gained_round: {
                tee: 1.26526,
                sand: 0.0,
                approach: -4.23092,
                putting: 3.01228,
                around_green: 0.57453,
                recovery: 0.0,
                rough_inside_150: 0.23502,
                rough_outside_150: -0.03758,
                fairway_50_to_100: -1.96416,
                fairway_100_to_150: -1.19927,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.69041,
                putting_inside_5: 0.74905,
                putting_5_to_10: 1.49468,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.41238,
                putting_outside_30: 1.18093,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.57453,
                rough_around_green_30: 0.0,
                total: 0.62114,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6667,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 298.28571,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1423,
            round_date: '2024-01-29T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1423,
            strokes_gained_round: {
                tee: 2.12726,
                sand: 0.0,
                approach: -1.19782,
                putting: 0.67134,
                around_green: 0.25242,
                recovery: 0.0,
                rough_inside_150: 1.23246,
                rough_outside_150: -0.18316,
                fairway_50_to_100: -1.07913,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.15824,
                putting_5_to_10: -1.46329,
                putting_10_to_15: 0.06689,
                putting_15_to_20: -0.60719,
                putting_20_to_30: -0.56899,
                putting_outside_30: 2.08569,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.28856,
                rough_around_green_30: -0.03614,
                total: 1.85321,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8889,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 328.92857,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1422,
            round_date: '2024-01-28T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1422,
            strokes_gained_round: {
                tee: 3.37732,
                sand: 0.0,
                approach: -4.22301,
                putting: -0.77719,
                around_green: 0.879,
                recovery: 0.0,
                rough_inside_150: -1.15826,
                rough_outside_150: 0.38166,
                fairway_50_to_100: -1.21057,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.30687,
                fairway_outside_200: -0.37411,
                putting_inside_5: 0.23847,
                putting_5_to_10: -1.45757,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.41281,
                putting_20_to_30: -0.28213,
                putting_outside_30: 0.31122,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.08028,
                rough_around_green_15: 0.76798,
                rough_around_green_30: 0.1913,
                total: -0.74388,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 3,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 328.85714,
                eagles: 1,
                birdies: 3,
                pars: 11,
                bogeys: 2,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1421,
            round_date: '2024-01-27T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1421,
            strokes_gained_round: {
                tee: 2.60992,
                sand: 0.0,
                approach: -1.10474,
                putting: 2.45962,
                around_green: -0.28037,
                recovery: 0.0,
                rough_inside_150: 0.69682,
                rough_outside_150: -0.08236,
                fairway_50_to_100: 0.4163,
                fairway_100_to_150: -1.69844,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.01072,
                putting_inside_5: 0.7952,
                putting_5_to_10: 0.73196,
                putting_10_to_15: -0.34419,
                putting_15_to_20: 1.01447,
                putting_20_to_30: -0.37108,
                putting_outside_30: 0.63325,
                fairway_around_green_15: -0.70672,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.21445,
                rough_around_green_30: 0.21189,
                total: 3.68443,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 305.64286,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1420,
            round_date: '2024-01-26T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1420,
            strokes_gained_round: {
                tee: 2.14058,
                sand: 0.0,
                approach: -0.22628,
                putting: 1.80362,
                around_green: 0.8011,
                recovery: 0.0,
                rough_inside_150: 2.42289,
                rough_outside_150: -0.01738,
                fairway_50_to_100: -0.78254,
                fairway_100_to_150: -0.52897,
                fairway_150_to_200: -0.33737,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.49696,
                putting_5_to_10: 0.35021,
                putting_10_to_15: 1.085,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 0.96319,
                putting_outside_30: 0.2964,
                fairway_around_green_15: 0.22523,
                fairway_around_green_30: -0.52022,
                rough_around_green_15: 0.187,
                rough_around_green_30: 0.90909,
                total: 4.51902,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 302.78571,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1419,
            round_date: '2024-01-25T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1419,
            strokes_gained_round: {
                tee: 3.81167,
                sand: 0.0,
                approach: 0.94845,
                putting: -2.82499,
                around_green: -0.66199,
                recovery: 0.0,
                rough_inside_150: 1.48232,
                rough_outside_150: 0.68002,
                fairway_50_to_100: -1.12185,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.36841,
                fairway_outside_200: 0.0,
                putting_inside_5: -1.31674,
                putting_5_to_10: 0.47231,
                putting_10_to_15: -0.46739,
                putting_15_to_20: -0.78843,
                putting_20_to_30: -0.78758,
                putting_outside_30: 0.06283,
                fairway_around_green_15: -0.31047,
                fairway_around_green_30: -0.81197,
                rough_around_green_15: 0.75002,
                rough_around_green_30: -0.28957,
                total: 1.27314,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 337.21429,
                eagles: 1,
                birdies: 3,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1418,
            round_date: '2024-01-24T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1418,
            strokes_gained_round: {
                tee: 2.35724,
                sand: 0.0,
                approach: -0.77158,
                putting: 3.96824,
                around_green: 0.13604,
                recovery: 0.0,
                rough_inside_150: 2.55973,
                rough_outside_150: 0.10268,
                fairway_50_to_100: -0.83087,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.49175,
                fairway_outside_200: -0.27245,
                putting_inside_5: 0.60326,
                putting_5_to_10: 1.15852,
                putting_10_to_15: 1.6395,
                putting_15_to_20: 0.67831,
                putting_20_to_30: -0.46192,
                putting_outside_30: 0.35057,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.60969,
                rough_around_green_15: 0.29741,
                rough_around_green_30: 0.44832,
                total: 5.68993,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7222,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 320.85714,
                eagles: 0,
                birdies: 9,
                pars: 7,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1417,
            round_date: '2024-01-23T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1417,
            strokes_gained_round: {
                tee: 0.4405,
                sand: 0.0,
                approach: -0.22604,
                putting: -1.06527,
                around_green: 0.38161,
                recovery: 0.0,
                rough_inside_150: 0.9514,
                rough_outside_150: -0.08625,
                fairway_50_to_100: 0.02748,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.28842,
                putting_inside_5: 0.05114,
                putting_5_to_10: -0.85025,
                putting_10_to_15: -0.95358,
                putting_15_to_20: -0.37561,
                putting_20_to_30: 0.67447,
                putting_outside_30: 0.38857,
                fairway_around_green_15: -0.10776,
                fairway_around_green_30: -0.34088,
                rough_around_green_15: 0.53572,
                rough_around_green_30: 0.29453,
                total: -0.4692,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 296.07143,
                eagles: 0,
                birdies: 4,
                pars: 11,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1416,
            round_date: '2024-01-22T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1416,
            strokes_gained_round: {
                tee: 3.85725,
                sand: 0.0,
                approach: -0.46301,
                putting: 1.97683,
                around_green: 0.23688,
                recovery: 0.0,
                rough_inside_150: 1.30853,
                rough_outside_150: 0.39689,
                fairway_50_to_100: -0.83575,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.72197,
                putting_inside_5: 1.62823,
                putting_5_to_10: 0.33474,
                putting_10_to_15: -0.95311,
                putting_15_to_20: 0.2841,
                putting_20_to_30: -0.19547,
                putting_outside_30: 0.87833,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.30405,
                rough_around_green_15: 0.54093,
                rough_around_green_30: 0.0,
                total: 5.60794,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -7,
                green_in_regulation_percentage: 0.8889,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 325.42857,
                eagles: 0,
                birdies: 8,
                pars: 9,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 1415,
            round_date: '2024-01-21T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1415,
            strokes_gained_round: {
                tee: 1.74383,
                sand: 0.0,
                approach: -2.99157,
                putting: -2.18267,
                around_green: 0.07272,
                recovery: 0.0,
                rough_inside_150: -0.76944,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.90503,
                fairway_100_to_150: 0.48274,
                fairway_150_to_200: -0.88431,
                fairway_outside_200: 0.12166,
                putting_inside_5: -2.53152,
                putting_5_to_10: 0.13757,
                putting_10_to_15: -0.55258,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.28345,
                putting_outside_30: 0.48041,
                fairway_around_green_15: -0.19863,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.55196,
                rough_around_green_30: -0.28061,
                total: -3.35769,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 34,
                three_putt_percentage: 0.1667,
                average_driving_distance: 316.07143,
                eagles: 0,
                birdies: 4,
                pars: 8,
                bogeys: 6,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1414,
            round_date: '2024-01-20T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1414,
            strokes_gained_round: {
                tee: 4.8427,
                sand: 0.0,
                approach: 0.59797,
                putting: 1.34639,
                around_green: 0.25947,
                recovery: 0.0,
                rough_inside_150: 0.6714,
                rough_outside_150: -0.21392,
                fairway_50_to_100: 0.35233,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.02803,
                putting_inside_5: 0.1845,
                putting_5_to_10: 0.73149,
                putting_10_to_15: 0.09387,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.73932,
                putting_outside_30: 1.39199,
                fairway_around_green_15: 0.21458,
                fairway_around_green_30: 0.04488,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 7.04652,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -8,
                green_in_regulation_percentage: 0.8889,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 332.57143,
                eagles: 0,
                birdies: 9,
                pars: 8,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.5,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1413,
            round_date: '2024-01-19T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1413,
            strokes_gained_round: {
                tee: 2.84409,
                sand: 0.0,
                approach: -2.80197,
                putting: 0.91769,
                around_green: -0.72198,
                recovery: 0.0,
                rough_inside_150: -0.87759,
                rough_outside_150: 0.49669,
                fairway_50_to_100: -1.58203,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.24424,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.0734,
                putting_5_to_10: -0.56316,
                putting_10_to_15: -0.91603,
                putting_15_to_20: 0.28457,
                putting_20_to_30: 0.50069,
                putting_outside_30: 0.53821,
                fairway_around_green_15: -0.18271,
                fairway_around_green_30: -0.67957,
                rough_around_green_15: 0.35859,
                rough_around_green_30: -0.21829,
                total: 0.23783,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 3,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 335.21429,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1412,
            round_date: '2024-01-18T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1412,
            strokes_gained_round: {
                tee: 1.59055,
                sand: 0.0,
                approach: -2.09596,
                putting: 1.61742,
                around_green: 0.28431,
                recovery: 0.0,
                rough_inside_150: 0.66586,
                rough_outside_150: 0.02388,
                fairway_50_to_100: -1.66681,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.6333,
                putting_inside_5: 1.2381,
                putting_5_to_10: -0.94253,
                putting_10_to_15: -0.955,
                putting_15_to_20: 0.30965,
                putting_20_to_30: -0.32613,
                putting_outside_30: 2.29334,
                fairway_around_green_15: 0.01267,
                fairway_around_green_30: -0.21394,
                rough_around_green_15: 0.32201,
                rough_around_green_30: 0.16357,
                total: 1.39633,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 318.07143,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1411,
            round_date: '2024-01-17T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1411,
            strokes_gained_round: {
                tee: 0.68439,
                sand: 0.0,
                approach: 0.33823,
                putting: 4.42232,
                around_green: 1.35063,
                recovery: 0.0,
                rough_inside_150: 1.92482,
                rough_outside_150: 0.34831,
                fairway_50_to_100: -0.02574,
                fairway_100_to_150: 0.08876,
                fairway_150_to_200: -0.38065,
                fairway_outside_200: -0.26664,
                putting_inside_5: 1.53558,
                putting_5_to_10: 0.59631,
                putting_10_to_15: 0.59881,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.24232,
                putting_outside_30: 1.93394,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.1219,
                rough_around_green_30: 0.22873,
                total: 6.79557,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -8,
                green_in_regulation_percentage: 0.7222,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 303.42857,
                eagles: 0,
                birdies: 9,
                pars: 8,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.5,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1410,
            round_date: '2024-01-16T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1410,
            strokes_gained_round: {
                tee: 2.61906,
                sand: 0.0,
                approach: -1.98818,
                putting: 0.55309,
                around_green: 0.29757,
                recovery: 0.0,
                rough_inside_150: 1.28981,
                rough_outside_150: -0.06617,
                fairway_50_to_100: -3.33344,
                fairway_100_to_150: -0.04379,
                fairway_150_to_200: 0.563,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.65013,
                putting_5_to_10: -1.11087,
                putting_10_to_15: 0.00963,
                putting_15_to_20: 0.3106,
                putting_20_to_30: -0.26178,
                putting_outside_30: 0.95537,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.10001,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.39759,
                total: 1.48155,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 324.28571,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1409,
            round_date: '2024-01-15T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1409,
            strokes_gained_round: {
                tee: 1.04038,
                sand: 0.0,
                approach: -0.79072,
                putting: -0.303,
                around_green: 0.53959,
                recovery: 0.0,
                rough_inside_150: 0.10272,
                rough_outside_150: -0.08979,
                fairway_50_to_100: -0.30565,
                fairway_100_to_150: -0.46126,
                fairway_150_to_200: -0.00407,
                fairway_outside_200: 0.17812,
                putting_inside_5: 0.48706,
                putting_5_to_10: 0.07747,
                putting_10_to_15: -1.53502,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.6675,
                fairway_around_green_15: -0.11966,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.65926,
                rough_around_green_30: 0.0,
                total: 0.48625,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 295.92857,
                eagles: 0,
                birdies: 7,
                pars: 6,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1408,
            round_date: '2024-01-14T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1408,
            strokes_gained_round: {
                tee: 1.2513,
                sand: 0.0,
                approach: -0.20776,
                putting: -0.39521,
                around_green: 0.07954,
                recovery: 0.0,
                rough_inside_150: 0.84815,
                rough_outside_150: -0.01471,
                fairway_50_to_100: -0.14514,
                fairway_100_to_150: -0.49493,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.04152,
                putting_inside_5: 0.91851,
                putting_5_to_10: -0.80833,
                putting_10_to_15: 0.065,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.87423,
                putting_outside_30: 0.30384,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.54866,
                rough_around_green_15: 0.6282,
                rough_around_green_30: 0.0,
                total: 0.72787,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 305.0,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1407,
            round_date: '2024-01-13T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1407,
            strokes_gained_round: {
                tee: 4.49745,
                sand: 0.0,
                approach: -3.67496,
                putting: 0.86668,
                around_green: 0.31795,
                recovery: 0.0,
                rough_inside_150: -0.88585,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.75653,
                fairway_100_to_150: -0.32338,
                fairway_150_to_200: -0.55443,
                fairway_outside_200: -0.02891,
                putting_inside_5: 1.56245,
                putting_5_to_10: 0.1087,
                putting_10_to_15: -1.54418,
                putting_15_to_20: -0.29106,
                putting_20_to_30: 0.0,
                putting_outside_30: 1.03077,
                fairway_around_green_15: -0.29883,
                fairway_around_green_30: -0.10656,
                rough_around_green_15: 0.47531,
                rough_around_green_30: 0.24802,
                total: 2.00712,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -4,
                green_in_regulation_percentage: 0.6667,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 334.35714,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1406,
            round_date: '2024-01-12T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1406,
            strokes_gained_round: {
                tee: 2.65531,
                sand: 0.0,
                approach: -1.91305,
                putting: -0.6471,
                around_green: 0.7492,
                recovery: 0.0,
                rough_inside_150: 1.03711,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.50697,
                fairway_100_to_150: -0.56113,
                fairway_150_to_200: -0.35682,
                fairway_outside_200: 0.19843,
                putting_inside_5: 1.73601,
                putting_5_to_10: -1.90101,
                putting_10_to_15: -1.01037,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.06631,
                putting_outside_30: 0.59458,
                fairway_around_green_15: -0.33724,
                fairway_around_green_30: -0.63723,
                rough_around_green_15: 1.72366,
                rough_around_green_30: 0.0,
                total: 0.84437,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 294.5,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1405,
            round_date: '2024-01-11T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1405,
            strokes_gained_round: {
                tee: 2.87183,
                sand: 0.0,
                approach: -5.14125,
                putting: 1.19117,
                around_green: 1.12855,
                recovery: 0.0,
                rough_inside_150: -0.33985,
                rough_outside_150: 0.0,
                fairway_50_to_100: -2.13273,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.19076,
                fairway_outside_200: -0.20435,
                putting_inside_5: -0.0001,
                putting_5_to_10: 0.80848,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.21866,
                putting_outside_30: 1.02263,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.29384,
                rough_around_green_30: 0.83471,
                total: 0.0503,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.8571,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7222,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 318.71429,
                eagles: 0,
                birdies: 4,
                pars: 11,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1404,
            round_date: '2024-01-10T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1404,
            strokes_gained_round: {
                tee: 2.90001,
                sand: 0.0,
                approach: -2.03582,
                putting: 0.43579,
                around_green: -0.09915,
                recovery: 0.0,
                rough_inside_150: 0.16348,
                rough_outside_150: -0.10818,
                fairway_50_to_100: -0.4814,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.27964,
                fairway_outside_200: -0.31588,
                putting_inside_5: 0.71592,
                putting_5_to_10: 0.0,
                putting_10_to_15: -2.2359,
                putting_15_to_20: 1.35473,
                putting_20_to_30: 0.17179,
                putting_outside_30: 0.42924,
                fairway_around_green_15: 0.03189,
                fairway_around_green_30: -0.46236,
                rough_around_green_15: 0.10267,
                rough_around_green_30: 0.22866,
                total: 1.20084,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 325.14286,
                eagles: 1,
                birdies: 3,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1403,
            round_date: '2024-01-09T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1403,
            strokes_gained_round: {
                tee: 2.71374,
                sand: 0.0,
                approach: -0.90705,
                putting: -1.3394,
                around_green: 0.33454,
                recovery: 0.0,
                rough_inside_150: 1.57905,
                rough_outside_150: -0.31276,
                fairway_50_to_100: -1.10937,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.00539,
                fairway_outside_200: 0.01873,
                putting_inside_5: 1.4944,
                putting_5_to_10: -1.47682,
                putting_10_to_15: -1.85274,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.49576,
                fairway_around_green_15: 0.06241,
                fairway_around_green_30: -0.37156,
                rough_around_green_15: 0.64369,
                rough_around_green_30: 0.0,
                total: 0.80182,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 334.92857,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1402,
            round_date: '2024-01-08T02:04:10.722-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 9,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1402,
            strokes_gained_round: {
                tee: 0.84382,
                sand: 0.0,
                approach: -0.72061,
                putting: 0.00556,
                around_green: 1.57821,
                recovery: 0.0,
                rough_inside_150: 1.21858,
                rough_outside_150: -0.2082,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: -0.09969,
                fairway_150_to_200: -0.32189,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.40408,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.48619,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.26178,
                putting_outside_30: 0.18524,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.35963,
                rough_around_green_15: 0.38,
                rough_around_green_30: 0.83858,
                total: 1.70698,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.6,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 14,
                three_putt_percentage: 0.0,
                average_driving_distance: 335.2,
                eagles: 0,
                birdies: 4,
                pars: 4,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.0,
                par_5_score: 4.25,
            },
            par: 36,
            strokes_total: 33,
        },
        {
            id: 1401,
            round_date: '2024-01-07T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1401,
            strokes_gained_round: {
                tee: 0.97487,
                sand: 0.0,
                approach: -4.23217,
                putting: -2.12441,
                around_green: 1.35254,
                recovery: 0.0,
                rough_inside_150: -0.59023,
                rough_outside_150: -0.02732,
                fairway_50_to_100: -1.79482,
                fairway_100_to_150: 0.38062,
                fairway_150_to_200: -0.54292,
                fairway_outside_200: -0.24313,
                putting_inside_5: -0.29674,
                putting_5_to_10: -1.48975,
                putting_10_to_15: -0.47655,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.45205,
                putting_outside_30: 0.59068,
                fairway_around_green_15: -0.06182,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.65192,
                rough_around_green_30: -0.23756,
                total: -4.02916,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 3,
                green_in_regulation_percentage: 0.5556,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 307.42857,
                eagles: 0,
                birdies: 1,
                pars: 13,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 5.0,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 1320,
            round_date: '2024-01-06T13:30:52.646-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 0,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1320,
            strokes_gained_round: {
                tee: 0.0,
                sand: 0.0,
                approach: 0.0,
                putting: 0.0,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.0,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.0,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.0,
                score_to_par: 0,
                green_in_regulation_percentage: 0.0,
                total_putts: 0,
                three_putt_percentage: 0.0,
                average_driving_distance: 0.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 0,
            },
            par: 0,
            strokes_total: 0,
        },
        {
            id: 1319,
            round_date: '2024-01-06T13:26:05.033-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 0,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1319,
            strokes_gained_round: {
                tee: 0.0,
                sand: 0.0,
                approach: 0.0,
                putting: 0.0,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.0,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.0,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.0,
                score_to_par: 0,
                green_in_regulation_percentage: 0.0,
                total_putts: 0,
                three_putt_percentage: 0.0,
                average_driving_distance: 0.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 0,
            },
            par: 0,
            strokes_total: 0,
        },
        {
            id: 1318,
            round_date: '2024-01-06T13:25:13.465-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 0,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1318,
            strokes_gained_round: {
                tee: 0.0,
                sand: 0.0,
                approach: 0.0,
                putting: 0.0,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.0,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.0,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.0,
                score_to_par: 0,
                green_in_regulation_percentage: 0.0,
                total_putts: 0,
                three_putt_percentage: 0.0,
                average_driving_distance: 0.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 0,
            },
            par: 0,
            strokes_total: 0,
        },
        {
            id: 1317,
            round_date: '2024-01-06T13:23:23.643-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 0,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1317,
            strokes_gained_round: {
                tee: 0.0,
                sand: 0.0,
                approach: 0.0,
                putting: 0.0,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.0,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.0,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.0,
                score_to_par: 0,
                green_in_regulation_percentage: 0.0,
                total_putts: 0,
                three_putt_percentage: 0.0,
                average_driving_distance: 0.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 0,
            },
            par: 0,
            strokes_total: 0,
        },
        {
            id: 1316,
            round_date: '2024-01-06T13:21:25.163-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 0,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1316,
            strokes_gained_round: {
                tee: 0.0,
                sand: 0.0,
                approach: 0.0,
                putting: 0.0,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.0,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: 0.0,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.0,
                score_to_par: 0,
                green_in_regulation_percentage: 0.0,
                total_putts: 0,
                three_putt_percentage: 0.0,
                average_driving_distance: 0.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 0,
            },
            par: 0,
            strokes_total: 0,
        },
        {
            id: 1400,
            round_date: '2024-01-06T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1400,
            strokes_gained_round: {
                tee: 0.6039,
                sand: 0.0,
                approach: -1.53743,
                putting: 0.98548,
                around_green: 1.2614,
                recovery: 0.0,
                rough_inside_150: 0.36332,
                rough_outside_150: 0.09886,
                fairway_50_to_100: -0.12207,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.0928,
                fairway_outside_200: -0.33662,
                putting_inside_5: 1.13918,
                putting_5_to_10: -0.76033,
                putting_10_to_15: -0.46692,
                putting_15_to_20: -0.31613,
                putting_20_to_30: 0.38626,
                putting_outside_30: 1.00342,
                fairway_around_green_15: -0.18673,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.64449,
                rough_around_green_30: 0.80364,
                total: 1.31335,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2143,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 320.42857,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1399,
            round_date: '2024-01-05T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1399,
            strokes_gained_round: {
                tee: 3.54007,
                sand: 0.0,
                approach: -1.06173,
                putting: -1.94039,
                around_green: 0.29256,
                recovery: 0.0,
                rough_inside_150: 0.64612,
                rough_outside_150: -0.21756,
                fairway_50_to_100: -0.85757,
                fairway_100_to_150: 0.56329,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.50912,
                putting_inside_5: 0.85389,
                putting_5_to_10: -1.13971,
                putting_10_to_15: -0.955,
                putting_15_to_20: -0.68527,
                putting_20_to_30: -0.41698,
                putting_outside_30: 0.40268,
                fairway_around_green_15: -0.19007,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.48263,
                rough_around_green_30: 0.0,
                total: 0.83052,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7222,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 332.42857,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1398,
            round_date: '2024-01-04T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1398,
            strokes_gained_round: {
                tee: 2.49351,
                sand: 0.0,
                approach: -1.58832,
                putting: -0.83443,
                around_green: 0.81358,
                recovery: 0.0,
                rough_inside_150: 1.63705,
                rough_outside_150: -0.22431,
                fairway_50_to_100: 0.02654,
                fairway_100_to_150: -0.58014,
                fairway_150_to_200: -0.27544,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.11444,
                putting_5_to_10: -1.99474,
                putting_10_to_15: -0.50495,
                putting_15_to_20: -0.71035,
                putting_20_to_30: 0.69671,
                putting_outside_30: 0.56445,
                fairway_around_green_15: 0.03721,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.50986,
                rough_around_green_30: 0.26651,
                total: 0.88434,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 336.42857,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1397,
            round_date: '2024-01-03T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1397,
            strokes_gained_round: {
                tee: 0.50649,
                sand: 0.0,
                approach: 0.57072,
                putting: -0.00835,
                around_green: 0.4115,
                recovery: 0.0,
                rough_inside_150: 0.4163,
                rough_outside_150: 0.43345,
                fairway_50_to_100: 0.96449,
                fairway_100_to_150: -0.20482,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.05785,
                putting_inside_5: 0.93317,
                putting_5_to_10: -0.70199,
                putting_10_to_15: -0.95358,
                putting_15_to_20: -1.13011,
                putting_20_to_30: 0.47474,
                putting_outside_30: 1.36943,
                fairway_around_green_15: -0.37762,
                fairway_around_green_30: -0.19174,
                rough_around_green_15: 0.98085,
                rough_around_green_30: 0.0,
                total: 1.48036,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 302.07143,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1396,
            round_date: '2024-01-02T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1396,
            strokes_gained_round: {
                tee: 2.69794,
                sand: 0.0,
                approach: 0.19912,
                putting: 1.81741,
                around_green: -0.13047,
                recovery: 0.0,
                rough_inside_150: 0.08506,
                rough_outside_150: 0.26336,
                fairway_50_to_100: -0.03205,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.7509,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.43535,
                putting_5_to_10: -0.05771,
                putting_10_to_15: -0.47655,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -0.30152,
                putting_outside_30: 1.58557,
                fairway_around_green_15: -0.6118,
                fairway_around_green_30: -0.36742,
                rough_around_green_15: 0.84876,
                rough_around_green_30: 0.0,
                total: 4.58401,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 318.42857,
                eagles: 1,
                birdies: 6,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1395,
            round_date: '2024-01-01T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1395,
            strokes_gained_round: {
                tee: 2.15142,
                sand: 0.0,
                approach: -3.30143,
                putting: -2.45519,
                around_green: 1.23804,
                recovery: 0.0,
                rough_inside_150: 0.70124,
                rough_outside_150: 0.25064,
                fairway_50_to_100: -0.66857,
                fairway_100_to_150: -0.75271,
                fairway_150_to_200: -0.65199,
                fairway_outside_200: -0.29076,
                putting_inside_5: -0.05167,
                putting_5_to_10: -1.21623,
                putting_10_to_15: -1.61615,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -0.30105,
                putting_outside_30: 1.09762,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.24498,
                rough_around_green_30: -0.00694,
                total: -2.36716,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: 1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 35,
                three_putt_percentage: 0.1111,
                average_driving_distance: 316.57143,
                eagles: 0,
                birdies: 2,
                pars: 13,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.1,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 1394,
            round_date: '2023-12-31T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1394,
            strokes_gained_round: {
                tee: 1.35887,
                sand: 0.0,
                approach: -0.13399,
                putting: -0.35215,
                around_green: 0.2784,
                recovery: 0.0,
                rough_inside_150: -0.57989,
                rough_outside_150: -0.04809,
                fairway_50_to_100: 0.1381,
                fairway_100_to_150: 0.22644,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.09158,
                putting_inside_5: 1.24981,
                putting_5_to_10: -0.13613,
                putting_10_to_15: 0.13142,
                putting_15_to_20: -1.74101,
                putting_20_to_30: -0.08665,
                putting_outside_30: 0.23041,
                fairway_around_green_15: 0.09791,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.36961,
                rough_around_green_30: -0.18912,
                total: 1.15113,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 302.78571,
                eagles: 0,
                birdies: 7,
                pars: 7,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1393,
            round_date: '2023-12-30T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1393,
            strokes_gained_round: {
                tee: 1.71369,
                sand: 0.0,
                approach: -3.52187,
                putting: -2.64762,
                around_green: 0.96867,
                recovery: 0.0,
                rough_inside_150: 1.19857,
                rough_outside_150: -0.23535,
                fairway_50_to_100: -2.83002,
                fairway_100_to_150: -0.21854,
                fairway_150_to_200: -0.17213,
                fairway_outside_200: 0.13226,
                putting_inside_5: -1.15877,
                putting_5_to_10: -2.49351,
                putting_10_to_15: -0.50495,
                putting_15_to_20: 0.3106,
                putting_20_to_30: -0.21542,
                putting_outside_30: 1.41442,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.72006,
                rough_around_green_30: 0.24861,
                total: -3.48713,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: 2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 36,
                three_putt_percentage: 0.0556,
                average_driving_distance: 303.71429,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 4.0,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1392,
            round_date: '2023-12-29T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1392,
            strokes_gained_round: {
                tee: 3.98149,
                sand: 0.0,
                approach: -1.42024,
                putting: 1.31276,
                around_green: -0.74687,
                recovery: 0.0,
                rough_inside_150: 0.50892,
                rough_outside_150: 0.0,
                fairway_50_to_100: -1.3284,
                fairway_100_to_150: -0.2223,
                fairway_150_to_200: -0.48794,
                fairway_outside_200: 0.06027,
                putting_inside_5: 0.69639,
                putting_5_to_10: 0.06391,
                putting_10_to_15: 0.15018,
                putting_15_to_20: -0.58211,
                putting_20_to_30: 0.36395,
                putting_outside_30: 0.62043,
                fairway_around_green_15: -0.83318,
                fairway_around_green_30: 0.09409,
                rough_around_green_15: 0.0,
                rough_around_green_30: -0.00778,
                total: 3.12715,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 328.57143,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1391,
            round_date: '2023-12-28T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1391,
            strokes_gained_round: {
                tee: 0.30448,
                sand: 0.0,
                approach: -1.54609,
                putting: 0.32362,
                around_green: 2.18605,
                recovery: 0.0,
                rough_inside_150: 3.37817,
                rough_outside_150: 0.01818,
                fairway_50_to_100: -1.49422,
                fairway_100_to_150: -0.38226,
                fairway_150_to_200: -0.46827,
                fairway_outside_200: -0.21302,
                putting_inside_5: 1.10653,
                putting_5_to_10: -1.32254,
                putting_10_to_15: 0.48619,
                putting_15_to_20: -0.45227,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.50572,
                fairway_around_green_15: -0.19863,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.77111,
                rough_around_green_30: 0.61357,
                total: 1.26806,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 291.64286,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1390,
            round_date: '2023-12-27T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1390,
            strokes_gained_round: {
                tee: 3.92736,
                sand: 0.0,
                approach: -0.29196,
                putting: -0.90597,
                around_green: 0.60791,
                recovery: 0.0,
                rough_inside_150: 0.78484,
                rough_outside_150: 0.09392,
                fairway_50_to_100: -0.85718,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.08515,
                fairway_outside_200: -0.21511,
                putting_inside_5: -1.42489,
                putting_5_to_10: -0.33236,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.73977,
                putting_outside_30: 0.5327,
                fairway_around_green_15: -0.12258,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.30729,
                rough_around_green_30: 0.4232,
                total: 3.33735,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 330.71429,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1389,
            round_date: '2023-12-26T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1389,
            strokes_gained_round: {
                tee: 2.72598,
                sand: 0.0,
                approach: -0.24613,
                putting: -1.18984,
                around_green: 0.80762,
                recovery: 0.0,
                rough_inside_150: 1.78815,
                rough_outside_150: 0.15529,
                fairway_50_to_100: -0.28397,
                fairway_100_to_150: -1.36459,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.11908,
                putting_inside_5: -1.65091,
                putting_5_to_10: 0.12449,
                putting_10_to_15: 0.06642,
                putting_15_to_20: 0.72894,
                putting_20_to_30: -0.36918,
                putting_outside_30: -0.0896,
                fairway_around_green_15: 0.27248,
                fairway_around_green_30: -0.1351,
                rough_around_green_15: 0.67025,
                rough_around_green_30: 0.0,
                total: 2.09763,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0556,
                average_driving_distance: 322.14286,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1388,
            round_date: '2023-12-25T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1388,
            strokes_gained_round: {
                tee: 0.53201,
                sand: 0.0,
                approach: -1.86295,
                putting: 0.88913,
                around_green: -0.21721,
                recovery: 0.0,
                rough_inside_150: -0.19311,
                rough_outside_150: 0.37623,
                fairway_50_to_100: -0.19002,
                fairway_100_to_150: -1.12682,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.45712,
                putting_inside_5: 0.88833,
                putting_5_to_10: -0.5775,
                putting_10_to_15: 0.57137,
                putting_15_to_20: -0.71035,
                putting_20_to_30: -0.4795,
                putting_outside_30: 1.19678,
                fairway_around_green_15: -0.64976,
                fairway_around_green_30: -0.75381,
                rough_around_green_15: 0.9071,
                rough_around_green_30: 0.27926,
                total: -0.65902,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 301.57143,
                eagles: 0,
                birdies: 2,
                pars: 14,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 1387,
            round_date: '2023-12-24T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1387,
            strokes_gained_round: {
                tee: 2.25385,
                sand: 0.0,
                approach: -3.21951,
                putting: 2.26603,
                around_green: 0.58,
                recovery: 0.0,
                rough_inside_150: 0.07574,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.61015,
                fairway_100_to_150: -0.85963,
                fairway_150_to_200: -0.38073,
                fairway_outside_200: -0.01236,
                putting_inside_5: 0.95412,
                putting_5_to_10: -1.33928,
                putting_10_to_15: 0.57137,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 1.16347,
                putting_outside_30: 1.31056,
                fairway_around_green_15: 0.04252,
                fairway_around_green_30: -0.6202,
                rough_around_green_15: 0.80109,
                rough_around_green_30: 0.35659,
                total: 1.88036,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 328.21429,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1386,
            round_date: '2023-12-23T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1386,
            strokes_gained_round: {
                tee: 4.5333,
                sand: 0.0,
                approach: -1.04102,
                putting: 0.98303,
                around_green: -1.03442,
                recovery: 0.0,
                rough_inside_150: 0.99892,
                rough_outside_150: -0.47705,
                fairway_50_to_100: -1.68085,
                fairway_100_to_150: 0.63256,
                fairway_150_to_200: -0.1289,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.30199,
                putting_5_to_10: -0.82138,
                putting_10_to_15: 0.0,
                putting_15_to_20: 1.0386,
                putting_20_to_30: -1.05356,
                putting_outside_30: 0.51738,
                fairway_around_green_15: 0.02,
                fairway_around_green_30: -1.35723,
                rough_around_green_15: 0.30281,
                rough_around_green_30: 0.0,
                total: 3.44089,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 332.64286,
                eagles: 1,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 1385,
            round_date: '2023-12-22T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1385,
            strokes_gained_round: {
                tee: 1.5936,
                sand: 0.0,
                approach: -3.51958,
                putting: 2.02979,
                around_green: 0.20953,
                recovery: 0.0,
                rough_inside_150: 0.24916,
                rough_outside_150: 0.44892,
                fairway_50_to_100: -1.72326,
                fairway_100_to_150: -0.56296,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.76171,
                putting_5_to_10: 0.26062,
                putting_10_to_15: -0.55258,
                putting_15_to_20: -0.68385,
                putting_20_to_30: 1.42755,
                putting_outside_30: 0.81634,
                fairway_around_green_15: -0.54581,
                fairway_around_green_30: 0.05089,
                rough_around_green_15: 0.53123,
                rough_around_green_30: 0.17323,
                total: 0.31334,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6667,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 323.14286,
                eagles: 0,
                birdies: 5,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1384,
            round_date: '2023-12-21T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1384,
            strokes_gained_round: {
                tee: 4.01399,
                sand: 0.0,
                approach: -2.38461,
                putting: 2.86915,
                around_green: 1.38359,
                recovery: 0.0,
                rough_inside_150: -0.09147,
                rough_outside_150: 1.04518,
                fairway_50_to_100: -1.02335,
                fairway_100_to_150: -0.48643,
                fairway_150_to_200: -0.47407,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.23715,
                putting_5_to_10: -0.31928,
                putting_10_to_15: 0.66571,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.26645,
                putting_outside_30: 1.55202,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.02913,
                rough_around_green_15: 0.27063,
                rough_around_green_30: 1.08383,
                total: 5.88213,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -8,
                green_in_regulation_percentage: 0.8889,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 307.92857,
                eagles: 1,
                birdies: 6,
                pars: 11,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 1383,
            round_date: '2023-12-20T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1383,
            strokes_gained_round: {
                tee: -0.13048,
                sand: 0.0,
                approach: -3.36617,
                putting: -1.8507,
                around_green: 2.12605,
                recovery: 0.0,
                rough_inside_150: -0.55335,
                rough_outside_150: -0.00401,
                fairway_50_to_100: 0.27277,
                fairway_100_to_150: -1.15947,
                fairway_150_to_200: -0.02377,
                fairway_outside_200: -0.02559,
                putting_inside_5: -1.09167,
                putting_5_to_10: -0.4554,
                putting_10_to_15: -1.00989,
                putting_15_to_20: -0.31613,
                putting_20_to_30: 0.0,
                putting_outside_30: 1.0224,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.04424,
                rough_around_green_15: 1.44151,
                rough_around_green_30: 0.72878,
                total: -3.22131,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 2,
                green_in_regulation_percentage: 0.5556,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 291.71429,
                eagles: 0,
                birdies: 1,
                pars: 14,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 1382,
            round_date: '2023-12-19T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1382,
            strokes_gained_round: {
                tee: 1.75061,
                sand: 0.0,
                approach: -0.65646,
                putting: -1.35976,
                around_green: -0.56155,
                recovery: 0.0,
                rough_inside_150: 0.14579,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.28485,
                fairway_100_to_150: -0.0082,
                fairway_150_to_200: -1.15217,
                fairway_outside_200: 0.20929,
                putting_inside_5: 0.32199,
                putting_5_to_10: 0.07747,
                putting_10_to_15: -1.03876,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.81415,
                putting_outside_30: 0.0937,
                fairway_around_green_15: -0.03104,
                fairway_around_green_30: 0.0,
                rough_around_green_15: -0.14403,
                rough_around_green_30: -0.38648,
                total: -0.82716,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 323.42857,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.25,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 1381,
            round_date: '2023-12-18T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1381,
            strokes_gained_round: {
                tee: 0.22953,
                sand: 0.0,
                approach: 1.73884,
                putting: -0.17566,
                around_green: -1.0208,
                recovery: 0.0,
                rough_inside_150: 0.66409,
                rough_outside_150: 0.41043,
                fairway_50_to_100: -0.13136,
                fairway_100_to_150: 0.55416,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.16634,
                putting_inside_5: 0.41214,
                putting_5_to_10: -0.27225,
                putting_10_to_15: -1.39042,
                putting_15_to_20: -1.31329,
                putting_20_to_30: 1.84588,
                putting_outside_30: 0.5423,
                fairway_around_green_15: -0.20833,
                fairway_around_green_30: -0.73728,
                rough_around_green_15: 0.09888,
                rough_around_green_30: -0.17407,
                total: 0.77191,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0556,
                average_driving_distance: 294.85714,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 2,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 1380,
            round_date: '2023-12-17T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1380,
            strokes_gained_round: {
                tee: 3.4166,
                sand: 0.0,
                approach: 0.35991,
                putting: -0.62092,
                around_green: 0.87565,
                recovery: 0.0,
                rough_inside_150: 1.83875,
                rough_outside_150: -0.23214,
                fairway_50_to_100: 0.5154,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -1.03363,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.84596,
                putting_5_to_10: 0.22985,
                putting_10_to_15: -0.98245,
                putting_15_to_20: -1.26596,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.55167,
                fairway_around_green_15: 0.05712,
                fairway_around_green_30: -0.35319,
                rough_around_green_15: 0.56263,
                rough_around_green_30: 0.60908,
                total: 4.03124,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -6,
                green_in_regulation_percentage: 0.8889,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 333.42857,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 1379,
            round_date: '2023-12-16T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1379,
            strokes_gained_round: {
                tee: 1.35949,
                sand: 0.0,
                approach: -0.5058,
                putting: 1.76175,
                around_green: -0.30947,
                recovery: 0.0,
                rough_inside_150: 1.61642,
                rough_outside_150: 0.57537,
                fairway_50_to_100: -2.57374,
                fairway_100_to_150: 0.0019,
                fairway_150_to_200: 0.01971,
                fairway_outside_200: -0.09165,
                putting_inside_5: 0.93317,
                putting_5_to_10: 0.44297,
                putting_10_to_15: 0.0385,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.71343,
                putting_outside_30: 1.06054,
                fairway_around_green_15: 0.21696,
                fairway_around_green_30: -0.58024,
                rough_around_green_15: 0.27361,
                rough_around_green_30: -0.2198,
                total: 2.30596,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.0,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 1378,
            round_date: '2023-12-15T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1378,
            strokes_gained_round: {
                tee: 1.2745,
                sand: 0.0,
                approach: -0.22468,
                putting: 0.39298,
                around_green: 0.20438,
                recovery: 0.0,
                rough_inside_150: 0.28407,
                rough_outside_150: 1.71005,
                fairway_50_to_100: 0.27896,
                fairway_100_to_150: -0.82206,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.32425,
                putting_5_to_10: -1.01808,
                putting_10_to_15: -0.89727,
                putting_15_to_20: -0.29106,
                putting_20_to_30: 0.43168,
                putting_outside_30: 0.84345,
                fairway_around_green_15: -0.4003,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.60468,
                rough_around_green_30: 0.0,
                total: 1.64718,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.85714,
                eagles: 0,
                birdies: 6,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 1377,
            round_date: '2023-12-14T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1377,
            strokes_gained_round: {
                tee: 2.06644,
                sand: 0.0,
                approach: 1.52319,
                putting: -1.0385,
                around_green: 0.68947,
                recovery: 0.0,
                rough_inside_150: 3.45943,
                rough_outside_150: 0.04636,
                fairway_50_to_100: -0.48194,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.21048,
                fairway_outside_200: -0.1547,
                putting_inside_5: 1.01896,
                putting_5_to_10: -0.73086,
                putting_10_to_15: -0.95311,
                putting_15_to_20: -0.84554,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.47205,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.61443,
                rough_around_green_30: 0.07503,
                total: 3.2406,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 308.0,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 895,
            round_date: '2023-12-13T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 895,
            strokes_gained_round: {
                tee: 1.94592,
                sand: 0.0,
                approach: -3.96924,
                putting: 1.28937,
                around_green: 1.17702,
                recovery: 0.0,
                rough_inside_150: 1.11843,
                rough_outside_150: -0.52448,
                fairway_50_to_100: -1.86479,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.16727,
                fairway_outside_200: -0.12818,
                putting_inside_5: 0.84833,
                putting_5_to_10: -0.24418,
                putting_10_to_15: -0.12007,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.38477,
                putting_outside_30: 0.42051,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.70889,
                rough_around_green_15: 1.5574,
                rough_around_green_30: 0.32851,
                total: 0.44306,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5385,
                score_to_par: -1,
                green_in_regulation_percentage: 0.6111,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 314.53846,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.6,
                par_4_score: 3.88889,
                par_5_score: 4.25,
            },
            par: 71,
            strokes_total: 70,
        },
        {
            id: 1376,
            round_date: '2023-12-13T02:04:10.722118-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 1376,
            strokes_gained_round: {
                tee: 3.71828,
                sand: 0.0,
                approach: -0.40085,
                putting: 0.82734,
                around_green: -0.32509,
                recovery: 0.0,
                rough_inside_150: 0.59359,
                rough_outside_150: 0.31795,
                fairway_50_to_100: -0.10095,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.16115,
                fairway_outside_200: -0.35372,
                putting_inside_5: 0.90099,
                putting_5_to_10: 0.19957,
                putting_10_to_15: -0.38269,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.14861,
                putting_outside_30: 0.32858,
                fairway_around_green_15: -0.2705,
                fairway_around_green_30: 0.05089,
                rough_around_green_15: 0.0,
                rough_around_green_30: -0.10548,
                total: 3.81969,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0,
                average_driving_distance: 336.28571,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 894,
            round_date: '2023-12-12T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 894,
            strokes_gained_round: {
                tee: 1.0957,
                sand: 0.0,
                approach: 1.56126,
                putting: -1.94385,
                around_green: 0.72131,
                recovery: 0.0,
                rough_inside_150: 1.99246,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.8302,
                fairway_100_to_150: -0.21137,
                fairway_150_to_200: -0.37069,
                fairway_outside_200: -0.2418,
                putting_inside_5: 0.75592,
                putting_5_to_10: -2.23479,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.7094,
                putting_20_to_30: -0.34979,
                putting_outside_30: 0.5942,
                fairway_around_green_15: -0.06537,
                fairway_around_green_30: 0.34913,
                rough_around_green_15: 0.43755,
                rough_around_green_30: 0.0,
                total: 1.43441,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8889,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 287.57143,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 893,
            round_date: '2023-12-11T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 893,
            strokes_gained_round: {
                tee: 1.27185,
                sand: 0.0,
                approach: -6.47873,
                putting: -0.49578,
                around_green: 0.96972,
                recovery: 0.0,
                rough_inside_150: -0.59884,
                rough_outside_150: -0.00316,
                fairway_50_to_100: -3.14983,
                fairway_100_to_150: -0.75218,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.06114,
                putting_inside_5: -0.52076,
                putting_5_to_10: -0.5029,
                putting_10_to_15: 0.12226,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.41413,
                putting_outside_30: 0.81975,
                fairway_around_green_15: -0.16152,
                fairway_around_green_30: 0.07659,
                rough_around_green_15: 1.03946,
                rough_around_green_30: 0.01519,
                total: -4.73294,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 4,
                blown_up_and_downs: 2,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 3,
                green_in_regulation_percentage: 0.5556,
                total_putts: 31,
                three_putt_percentage: 0.1111,
                average_driving_distance: 294.71429,
                eagles: 0,
                birdies: 3,
                pars: 9,
                bogeys: 6,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.4,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 75,
        },
        {
            id: 892,
            round_date: '2023-12-10T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 892,
            strokes_gained_round: {
                tee: 0.68912,
                sand: 0.0,
                approach: -1.57216,
                putting: 1.6808,
                around_green: 1.18572,
                recovery: 0.0,
                rough_inside_150: 2.39475,
                rough_outside_150: 0.02453,
                fairway_50_to_100: -0.80757,
                fairway_100_to_150: -1.50018,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.29934,
                putting_inside_5: 1.64042,
                putting_5_to_10: -0.39435,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.67831,
                putting_20_to_30: -0.30152,
                putting_outside_30: 0.47914,
                fairway_around_green_15: -0.19863,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.42569,
                rough_around_green_30: -0.04134,
                total: 1.98348,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6111,
                total_putts: 27,
                three_putt_percentage: 0.0556,
                average_driving_distance: 295.21429,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 891,
            round_date: '2023-12-09T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 891,
            strokes_gained_round: {
                tee: 0.95202,
                sand: 0.0,
                approach: 2.87355,
                putting: 4.52814,
                around_green: 1.85708,
                recovery: 0.0,
                rough_inside_150: 4.4148,
                rough_outside_150: -0.13986,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.4974,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.14116,
                putting_inside_5: 2.23227,
                putting_5_to_10: 0.10823,
                putting_10_to_15: 0.51505,
                putting_15_to_20: 1.38218,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.2904,
                fairway_around_green_15: -0.09979,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.01159,
                rough_around_green_30: 0.94528,
                total: 10.21079,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -11,
                green_in_regulation_percentage: 0.7778,
                total_putts: 21,
                three_putt_percentage: 0.0,
                average_driving_distance: 300.42857,
                eagles: 0,
                birdies: 11,
                pars: 7,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.4,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 61,
        },
        {
            id: 890,
            round_date: '2023-12-08T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 890,
            strokes_gained_round: {
                tee: 2.09858,
                sand: 0.0,
                approach: 2.53445,
                putting: -0.24024,
                around_green: 0.82499,
                recovery: 0.0,
                rough_inside_150: 2.04435,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.57606,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.65218,
                putting_inside_5: 1.39535,
                putting_5_to_10: 0.99115,
                putting_10_to_15: -2.31974,
                putting_15_to_20: -0.08361,
                putting_20_to_30: -0.26645,
                putting_outside_30: 0.04306,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.82499,
                rough_around_green_30: 0.0,
                total: 5.21778,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: -6,
                green_in_regulation_percentage: 0.7778,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 311.5,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.5,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 889,
            round_date: '2023-12-07T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 889,
            strokes_gained_round: {
                tee: 1.5905,
                sand: 0.0,
                approach: -2.79705,
                putting: -0.14924,
                around_green: 0.4082,
                recovery: 0.0,
                rough_inside_150: -0.15021,
                rough_outside_150: 0.42154,
                fairway_50_to_100: -1.85994,
                fairway_100_to_150: -0.63807,
                fairway_150_to_200: 0.33515,
                fairway_outside_200: -0.55602,
                putting_inside_5: -1.57778,
                putting_5_to_10: -1.18641,
                putting_10_to_15: 0.48619,
                putting_15_to_20: 0.07112,
                putting_20_to_30: 0.91253,
                putting_outside_30: 1.14511,
                fairway_around_green_15: 0.03471,
                fairway_around_green_30: 0.02398,
                rough_around_green_15: 0.08748,
                rough_around_green_30: 0.26204,
                total: -0.94759,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6111,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 304.0,
                eagles: 1,
                birdies: 2,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 888,
            round_date: '2023-12-06T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 888,
            strokes_gained_round: {
                tee: 1.85337,
                sand: 0.0,
                approach: -1.61103,
                putting: 4.1743,
                around_green: -1.37773,
                recovery: 0.0,
                rough_inside_150: -0.34571,
                rough_outside_150: 0.00763,
                fairway_50_to_100: -0.84548,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.42555,
                putting_inside_5: 0.5926,
                putting_5_to_10: 0.6867,
                putting_10_to_15: 0.59881,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 1.29974,
                putting_outside_30: 1.36417,
                fairway_around_green_15: -0.25544,
                fairway_around_green_30: -1.1242,
                rough_around_green_15: 0.47888,
                rough_around_green_30: -0.47696,
                total: 3.03891,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -4,
                green_in_regulation_percentage: 0.5556,
                total_putts: 26,
                three_putt_percentage: 0.0556,
                average_driving_distance: 332.0,
                eagles: 0,
                birdies: 9,
                pars: 5,
                bogeys: 3,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 887,
            round_date: '2023-12-05T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 887,
            strokes_gained_round: {
                tee: 1.42183,
                sand: 0.0,
                approach: -0.36023,
                putting: 4.55242,
                around_green: -0.00027,
                recovery: 0.0,
                rough_inside_150: 1.20875,
                rough_outside_150: -0.18845,
                fairway_50_to_100: -1.37244,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.37617,
                fairway_outside_200: 0.89702,
                putting_inside_5: 1.14402,
                putting_5_to_10: 0.13946,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.65229,
                putting_20_to_30: 2.04417,
                putting_outside_30: 0.57248,
                fairway_around_green_15: -0.52921,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.06778,
                rough_around_green_30: -0.53884,
                total: 5.61375,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7778,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 316.0,
                eagles: 1,
                birdies: 7,
                pars: 8,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 886,
            round_date: '2023-12-04T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 886,
            strokes_gained_round: {
                tee: 1.51714,
                sand: 0.0,
                approach: -1.44794,
                putting: 1.3632,
                around_green: 0.34829,
                recovery: 0.0,
                rough_inside_150: 0.7647,
                rough_outside_150: -0.5228,
                fairway_50_to_100: 0.59466,
                fairway_100_to_150: -1.43409,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.89658,
                putting_5_to_10: -0.01866,
                putting_10_to_15: 0.51505,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.38676,
                putting_outside_30: 0.35698,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.50213,
                rough_around_green_15: 0.71117,
                rough_around_green_30: 0.13925,
                total: 1.78069,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 28,
                three_putt_percentage: 0.1111,
                average_driving_distance: 306.14286,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 2,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 885,
            round_date: '2023-12-03T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 885,
            strokes_gained_round: {
                tee: 0.50996,
                sand: 0.0,
                approach: -1.5383,
                putting: 2.72047,
                around_green: 0.67412,
                recovery: 0.0,
                rough_inside_150: 0.46218,
                rough_outside_150: 0.18623,
                fairway_50_to_100: 0.27324,
                fairway_100_to_150: -0.68884,
                fairway_150_to_200: 0.12542,
                fairway_outside_200: -0.10108,
                putting_inside_5: 1.08653,
                putting_5_to_10: -0.22699,
                putting_10_to_15: 0.52468,
                putting_15_to_20: 0.70387,
                putting_20_to_30: -0.56655,
                putting_outside_30: 1.19893,
                fairway_around_green_15: -0.16507,
                fairway_around_green_30: 0.21755,
                rough_around_green_15: 0.62164,
                rough_around_green_30: 0.0,
                total: 2.36624,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 302.64286,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 884,
            round_date: '2023-12-02T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 884,
            strokes_gained_round: {
                tee: 1.67378,
                sand: 0.0,
                approach: -4.55449,
                putting: -0.2677,
                around_green: 1.03687,
                recovery: 0.0,
                rough_inside_150: -0.50534,
                rough_outside_150: 0.43624,
                fairway_50_to_100: -2.17227,
                fairway_100_to_150: -0.43831,
                fairway_150_to_200: -0.58126,
                fairway_outside_200: -0.22545,
                putting_inside_5: -0.31674,
                putting_5_to_10: -1.37341,
                putting_10_to_15: 0.51505,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.0,
                putting_outside_30: 1.2751,
                fairway_around_green_15: 0.25943,
                fairway_around_green_30: -0.32527,
                rough_around_green_15: 1.10271,
                rough_around_green_30: 0.0,
                total: -2.11153,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 313.28571,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 2,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 883,
            round_date: '2023-12-01T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 883,
            strokes_gained_round: {
                tee: 5.20772,
                sand: 0.0,
                approach: -0.13311,
                putting: -3.1511,
                around_green: 0.44161,
                recovery: 0.0,
                rough_inside_150: 0.67953,
                rough_outside_150: -0.05322,
                fairway_50_to_100: -0.03602,
                fairway_100_to_150: -0.09172,
                fairway_150_to_200: 0.22578,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.55731,
                putting_5_to_10: -1.4754,
                putting_10_to_15: -1.37429,
                putting_15_to_20: 0.72894,
                putting_20_to_30: -0.76345,
                putting_outside_30: 0.2904,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.341,
                rough_around_green_15: 0.78261,
                rough_around_green_30: 0.0,
                total: 2.36511,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8889,
                total_putts: 32,
                three_putt_percentage: 0.0,
                average_driving_distance: 324.5,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 882,
            round_date: '2023-11-30T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 882,
            strokes_gained_round: {
                tee: 0.58488,
                sand: 0.0,
                approach: -2.17384,
                putting: -0.94391,
                around_green: 0.81127,
                recovery: 0.0,
                rough_inside_150: 0.9187,
                rough_outside_150: 0.96073,
                fairway_50_to_100: -1.3453,
                fairway_100_to_150: -1.12117,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.40033,
                putting_inside_5: 0.13692,
                putting_5_to_10: -1.81157,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.72341,
                putting_20_to_30: -0.48511,
                putting_outside_30: 0.49243,
                fairway_around_green_15: 0.21696,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.46564,
                rough_around_green_30: 0.12867,
                total: -1.7216,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 297.07143,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 881,
            round_date: '2023-11-29T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 881,
            strokes_gained_round: {
                tee: 2.56209,
                sand: 0.0,
                approach: -3.00379,
                putting: -2.3631,
                around_green: -0.45573,
                recovery: 0.0,
                rough_inside_150: -1.22849,
                rough_outside_150: -0.30766,
                fairway_50_to_100: 0.08547,
                fairway_100_to_150: -0.57566,
                fairway_150_to_200: -0.06295,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.39271,
                putting_5_to_10: -0.60829,
                putting_10_to_15: -1.47682,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.25138,
                putting_outside_30: 0.68223,
                fairway_around_green_15: -0.17944,
                fairway_around_green_30: -0.71074,
                rough_around_green_15: -0.3553,
                rough_around_green_30: 0.78975,
                total: -3.26053,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 2,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 33,
                three_putt_percentage: 0.1667,
                average_driving_distance: 335.0,
                eagles: 0,
                birdies: 7,
                pars: 5,
                bogeys: 4,
                double_bogeys: 2,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.5,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 880,
            round_date: '2023-11-28T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 880,
            strokes_gained_round: {
                tee: 4.19493,
                sand: 0.0,
                approach: -2.86045,
                putting: 1.6254,
                around_green: 0.76354,
                recovery: 0.0,
                rough_inside_150: 0.01623,
                rough_outside_150: -0.01413,
                fairway_50_to_100: -1.36309,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.44744,
                fairway_outside_200: -0.19445,
                putting_inside_5: 1.16402,
                putting_5_to_10: -0.39435,
                putting_10_to_15: 0.58147,
                putting_15_to_20: 0.25807,
                putting_20_to_30: -0.28213,
                putting_outside_30: 0.29831,
                fairway_around_green_15: -0.21444,
                fairway_around_green_30: -0.27791,
                rough_around_green_15: 0.50912,
                rough_around_green_30: 0.74677,
                total: 3.72343,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 330.5,
                eagles: 1,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 879,
            round_date: '2023-11-27T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 879,
            strokes_gained_round: {
                tee: 1.96552,
                sand: 0.0,
                approach: 0.38057,
                putting: 0.20123,
                around_green: 0.87638,
                recovery: 0.0,
                rough_inside_150: 2.2711,
                rough_outside_150: 0.47198,
                fairway_50_to_100: -1.9619,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.52307,
                putting_inside_5: 0.62729,
                putting_5_to_10: -0.19623,
                putting_10_to_15: 0.03755,
                putting_15_to_20: -0.78843,
                putting_20_to_30: -0.17276,
                putting_outside_30: 0.6938,
                fairway_around_green_15: -0.12914,
                fairway_around_green_30: 0.08184,
                rough_around_green_15: 0.30281,
                rough_around_green_30: 0.62087,
                total: 3.42369,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7778,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 300.71429,
                eagles: 0,
                birdies: 7,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 878,
            round_date: '2023-11-26T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 878,
            strokes_gained_round: {
                tee: 1.24525,
                sand: 0.0,
                approach: 2.97894,
                putting: 0.80643,
                around_green: -0.30826,
                recovery: 0.0,
                rough_inside_150: 1.84305,
                rough_outside_150: 1.17051,
                fairway_50_to_100: 0.61864,
                fairway_100_to_150: -0.45494,
                fairway_150_to_200: -0.32524,
                fairway_outside_200: -0.23223,
                putting_inside_5: -1.14091,
                putting_5_to_10: 0.33474,
                putting_10_to_15: -0.47655,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.42742,
                putting_outside_30: 1.66174,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.05089,
                rough_around_green_15: 0.36859,
                rough_around_green_30: -0.72774,
                total: 4.72236,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -6,
                green_in_regulation_percentage: 0.9444,
                total_putts: 30,
                three_putt_percentage: 0.1111,
                average_driving_distance: 294.14286,
                eagles: 0,
                birdies: 9,
                pars: 6,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 877,
            round_date: '2023-11-25T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 877,
            strokes_gained_round: {
                tee: 0.16256,
                sand: 0.0,
                approach: -3.91892,
                putting: 1.86264,
                around_green: 0.25932,
                recovery: 0.0,
                rough_inside_150: 1.14833,
                rough_outside_150: 0.34463,
                fairway_50_to_100: -3.20377,
                fairway_100_to_150: -0.43747,
                fairway_150_to_200: -0.38797,
                fairway_outside_200: -0.12635,
                putting_inside_5: 1.33786,
                putting_5_to_10: -1.33928,
                putting_10_to_15: -0.35429,
                putting_15_to_20: 0.01955,
                putting_20_to_30: 1.56334,
                putting_outside_30: 0.63546,
                fairway_around_green_15: -0.57003,
                fairway_around_green_30: -0.42696,
                rough_around_green_15: 0.82678,
                rough_around_green_30: 0.42953,
                total: -1.6344,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.5556,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 295.57143,
                eagles: 0,
                birdies: 2,
                pars: 14,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.0,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 876,
            round_date: '2023-11-24T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 876,
            strokes_gained_round: {
                tee: 2.21851,
                sand: 0.0,
                approach: 1.85364,
                putting: -2.62046,
                around_green: -0.65821,
                recovery: 0.0,
                rough_inside_150: 2.16973,
                rough_outside_150: -0.19869,
                fairway_50_to_100: 0.11665,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.27621,
                putting_5_to_10: -2.43293,
                putting_10_to_15: -1.45126,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.48511,
                putting_outside_30: 0.47264,
                fairway_around_green_15: 0.07313,
                fairway_around_green_30: -0.87456,
                rough_around_green_15: 0.18589,
                rough_around_green_30: -0.04266,
                total: 0.7935,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8889,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 324.14286,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 875,
            round_date: '2023-11-23T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 875,
            strokes_gained_round: {
                tee: 1.13303,
                sand: 0.0,
                approach: -2.56688,
                putting: 5.26222,
                around_green: 0.61145,
                recovery: 0.0,
                rough_inside_150: 0.68347,
                rough_outside_150: 0.02197,
                fairway_50_to_100: 0.05733,
                fairway_100_to_150: -1.58857,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.24919,
                putting_inside_5: 1.16402,
                putting_5_to_10: 0.0,
                putting_10_to_15: 1.86381,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.24232,
                putting_outside_30: 2.47671,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.25072,
                rough_around_green_15: 0.50915,
                rough_around_green_30: 0.35302,
                total: 4.43981,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -6,
                green_in_regulation_percentage: 0.8333,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 301.57143,
                eagles: 0,
                birdies: 6,
                pars: 12,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 865,
            round_date: '2023-11-23T08:14:10.564-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 6,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 865,
            strokes_gained_round: {
                tee: -2.78827,
                sand: 0.0,
                approach: 0.42479,
                putting: -2.27794,
                around_green: 0.37201,
                recovery: 0.0,
                rough_inside_150: 0.37201,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.28845,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 1.40228,
                fairway_outside_200: -0.24988,
                putting_inside_5: -1.18104,
                putting_5_to_10: 0.45684,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -0.52675,
                putting_20_to_30: -0.49317,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.37201,
                total: -4.26941,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 2,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 0.8,
                score_to_par: 3,
                green_in_regulation_percentage: 0.6667,
                total_putts: 11,
                three_putt_percentage: 0.0,
                average_driving_distance: 273.8,
                eagles: 0,
                birdies: 1,
                pars: 3,
                bogeys: 0,
                double_bogeys: 2,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 2,
                par_3_score: 5.0,
                par_4_score: 4.33333,
                par_5_score: 5.0,
            },
            par: 25,
            strokes_total: 28,
        },
        {
            id: 874,
            round_date: '2023-11-22T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 874,
            strokes_gained_round: {
                tee: 1.58239,
                sand: 0.0,
                approach: -3.30732,
                putting: 4.70724,
                around_green: 1.85673,
                recovery: 0.0,
                rough_inside_150: 1.79984,
                rough_outside_150: -0.26584,
                fairway_50_to_100: -0.91453,
                fairway_100_to_150: 0.01603,
                fairway_150_to_200: -0.76301,
                fairway_outside_200: -0.14317,
                putting_inside_5: 1.38364,
                putting_5_to_10: 0.70072,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.00648,
                putting_20_to_30: 0.80458,
                putting_outside_30: 1.82477,
                fairway_around_green_15: -0.02998,
                fairway_around_green_30: -0.32527,
                rough_around_green_15: 1.58215,
                rough_around_green_30: 0.62983,
                total: 4.83903,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 317.85714,
                eagles: 0,
                birdies: 8,
                pars: 8,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 864,
            round_date: '2023-11-22T00:43:15.057306-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 864,
            strokes_gained_round: {
                tee: 3.68374,
                sand: 0.0,
                approach: -2.04586,
                putting: -1.9548,
                around_green: 0.14078,
                recovery: 0.0,
                rough_inside_150: 0.17018,
                rough_outside_150: 0.28594,
                fairway_50_to_100: -1.07236,
                fairway_100_to_150: -1.30987,
                fairway_150_to_200: -0.51996,
                fairway_outside_200: 0.21456,
                putting_inside_5: -1.32645,
                putting_5_to_10: -0.45351,
                putting_10_to_15: -0.57296,
                putting_15_to_20: -0.36771,
                putting_20_to_30: -0.10747,
                putting_outside_30: 0.87331,
                fairway_around_green_15: -0.05799,
                fairway_around_green_30: 0.35963,
                rough_around_green_15: -0.16086,
                rough_around_green_30: 0.0,
                total: -0.17614,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 33,
                three_putt_percentage: 0.1111,
                average_driving_distance: 325.0,
                eagles: 0,
                birdies: 6,
                pars: 7,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 873,
            round_date: '2023-11-21T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 873,
            strokes_gained_round: {
                tee: 1.90766,
                sand: 0.0,
                approach: -2.45623,
                putting: 1.8467,
                around_green: 1.303,
                recovery: 0.0,
                rough_inside_150: -1.02618,
                rough_outside_150: 0.78155,
                fairway_50_to_100: -1.41474,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.13369,
                putting_inside_5: 0.60042,
                putting_5_to_10: 0.86905,
                putting_10_to_15: 0.54345,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.58832,
                putting_outside_30: 0.4221,
                fairway_around_green_15: 0.29418,
                fairway_around_green_30: 0.07826,
                rough_around_green_15: 0.86,
                rough_around_green_30: 0.07055,
                total: 2.60114,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.6111,
                total_putts: 26,
                three_putt_percentage: 0.0556,
                average_driving_distance: 320.57143,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 863,
            round_date: '2023-11-21T00:43:15.057306-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 863,
            strokes_gained_round: {
                tee: 2.47455,
                sand: 0.0,
                approach: -2.23082,
                putting: 3.79345,
                around_green: -0.5683,
                recovery: 0.0,
                rough_inside_150: -0.51141,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.02412,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.67736,
                fairway_outside_200: -0.25997,
                putting_inside_5: 1.32956,
                putting_5_to_10: 0.26062,
                putting_10_to_15: 1.02963,
                putting_15_to_20: -0.34169,
                putting_20_to_30: 0.3626,
                putting_outside_30: 1.15272,
                fairway_around_green_15: -0.54275,
                fairway_around_green_30: -0.21523,
                rough_around_green_15: 0.405,
                rough_around_green_30: -0.21532,
                total: 3.46888,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 25,
                three_putt_percentage: 0.0,
                average_driving_distance: 321.42857,
                eagles: 0,
                birdies: 8,
                pars: 7,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 862,
            round_date: '2023-11-20T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 862,
            strokes_gained_round: {
                tee: 2.89689,
                sand: 0.0,
                approach: -0.86941,
                putting: 3.37424,
                around_green: 0.11505,
                recovery: 0.0,
                rough_inside_150: 1.13058,
                rough_outside_150: 0.0,
                fairway_50_to_100: -1.36646,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.32778,
                fairway_outside_200: -0.32542,
                putting_inside_5: 2.17431,
                putting_5_to_10: 0.76177,
                putting_10_to_15: -0.42119,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.56598,
                putting_outside_30: 0.66108,
                fairway_around_green_15: -0.16151,
                fairway_around_green_30: 0.05558,
                rough_around_green_15: 0.22098,
                rough_around_green_30: 0.0,
                total: 5.51678,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -7,
                green_in_regulation_percentage: 0.7778,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 332.35714,
                eagles: 1,
                birdies: 6,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 65,
        },
        {
            id: 872,
            round_date: '2023-11-20T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 872,
            strokes_gained_round: {
                tee: 1.9409,
                sand: 0.0,
                approach: -3.17115,
                putting: 0.96648,
                around_green: -0.4354,
                recovery: 0.0,
                rough_inside_150: -1.79839,
                rough_outside_150: 0.12546,
                fairway_50_to_100: -1.20713,
                fairway_100_to_150: 0.22074,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.50753,
                putting_5_to_10: -1.16953,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.30531,
                putting_outside_30: 0.93378,
                fairway_around_green_15: -0.13614,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.53866,
                rough_around_green_30: -0.83792,
                total: -0.69918,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.35714,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 861,
            round_date: '2023-11-19T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 861,
            strokes_gained_round: {
                tee: 4.45534,
                sand: 0.0,
                approach: -1.95909,
                putting: -2.04629,
                around_green: 1.59279,
                recovery: 0.0,
                rough_inside_150: 2.19692,
                rough_outside_150: 0.0,
                fairway_50_to_100: -1.12137,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.34311,
                fairway_outside_200: -0.02954,
                putting_inside_5: -0.63527,
                putting_5_to_10: -0.94253,
                putting_10_to_15: -0.86982,
                putting_15_to_20: -0.29106,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.69239,
                fairway_around_green_15: 0.03721,
                fairway_around_green_30: -0.58427,
                rough_around_green_15: 0.54918,
                rough_around_green_30: 1.59068,
                total: 2.04276,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.1111,
                average_driving_distance: 335.5,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 871,
            round_date: '2023-11-19T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 871,
            strokes_gained_round: {
                tee: 2.11555,
                sand: 0.0,
                approach: -1.20705,
                putting: -1.19769,
                around_green: -0.75083,
                recovery: 0.0,
                rough_inside_150: -0.77508,
                rough_outside_150: 0.0733,
                fairway_50_to_100: -0.066,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.60304,
                putting_5_to_10: -0.16641,
                putting_10_to_15: -1.51626,
                putting_15_to_20: 0.41281,
                putting_20_to_30: -0.85058,
                putting_outside_30: 0.31972,
                fairway_around_green_15: -0.50839,
                fairway_around_green_30: -0.52665,
                rough_around_green_15: 0.06695,
                rough_around_green_30: 0.21726,
                total: -1.04002,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 323.21429,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.9,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 860,
            round_date: '2023-11-18T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 860,
            strokes_gained_round: {
                tee: 0.09846,
                sand: 0.0,
                approach: -4.05232,
                putting: 0.84171,
                around_green: 0.6223,
                recovery: 0.0,
                rough_inside_150: 0.19637,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.71027,
                fairway_100_to_150: -1.27021,
                fairway_150_to_200: -0.25391,
                fairway_outside_200: -0.64191,
                putting_inside_5: 0.67013,
                putting_5_to_10: -0.94445,
                putting_10_to_15: -0.41013,
                putting_15_to_20: -0.29106,
                putting_20_to_30: 0.63182,
                putting_outside_30: 1.1854,
                fairway_around_green_15: -0.66452,
                fairway_around_green_30: -0.08556,
                rough_around_green_15: 0.67047,
                rough_around_green_30: 0.70191,
                total: -2.48984,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 1,
                green_in_regulation_percentage: 0.6111,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 296.28571,
                eagles: 0,
                birdies: 3,
                pars: 11,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.2,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 73,
        },
        {
            id: 870,
            round_date: '2023-11-18T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 870,
            strokes_gained_round: {
                tee: -0.2516,
                sand: 0.0,
                approach: -0.85383,
                putting: -3.39104,
                around_green: -0.45614,
                recovery: 0.0,
                rough_inside_150: -0.62027,
                rough_outside_150: 0.66668,
                fairway_50_to_100: 0.26412,
                fairway_100_to_150: -0.30687,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.53937,
                putting_inside_5: -0.82863,
                putting_5_to_10: 0.66949,
                putting_10_to_15: -2.20139,
                putting_15_to_20: -0.31613,
                putting_20_to_30: -0.58649,
                putting_outside_30: -0.12788,
                fairway_around_green_15: -0.36186,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: -0.09428,
                total: -4.95262,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 1,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 4,
                green_in_regulation_percentage: 0.7778,
                total_putts: 35,
                three_putt_percentage: 0.1667,
                average_driving_distance: 292.28571,
                eagles: 0,
                birdies: 4,
                pars: 7,
                bogeys: 6,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.25,
                par_4_score: 4.0,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 76,
        },
        {
            id: 802,
            round_date: '2023-11-18T10:33:44.599-06:00',
            number_of_holes: 9,
            possible_error_holes: 0,
            number_of_holes_complete: 1,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 802,
            strokes_gained_round: {
                tee: 0.2335,
                sand: 0.0,
                approach: -0.02582,
                putting: -0.48495,
                around_green: 0.0,
                recovery: 0.0,
                rough_inside_150: 0.0,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.02582,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.02,
                putting_5_to_10: 0.0,
                putting_10_to_15: -0.50495,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.0,
                total: -0.27726,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 1.0,
                score_to_par: 0,
                green_in_regulation_percentage: 1.0,
                total_putts: 4,
                three_putt_percentage: 0.0,
                average_driving_distance: 280.0,
                eagles: 0,
                birdies: 0,
                pars: 2,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 4.0,
                par_5_score: 0,
            },
            par: 4,
            strokes_total: 4,
        },
        {
            id: 801,
            round_date: '2023-11-18T08:27:02.176-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 1,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 801,
            strokes_gained_round: {
                tee: -0.04672,
                sand: 0.0,
                approach: -1.15848,
                putting: -2.04631,
                around_green: -0.32177,
                recovery: 0.0,
                rough_inside_150: -0.32177,
                rough_outside_150: 0.0,
                fairway_50_to_100: 0.0,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.06761,
                putting_inside_5: -0.79493,
                putting_5_to_10: 0.0,
                putting_10_to_15: 0.0,
                putting_15_to_20: -0.47612,
                putting_20_to_30: -0.77526,
                putting_outside_30: 0.0,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.0,
                rough_around_green_30: -0.32177,
                total: -3.57328,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: false,
            traditional_stats: {
                fairway_hit_percentage: 1.0,
                score_to_par: 3,
                green_in_regulation_percentage: 0.0,
                total_putts: 4,
                three_putt_percentage: 0.0556,
                average_driving_distance: 250.0,
                eagles: 0,
                birdies: 0,
                pars: 0,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 1,
                penalty_strokes: 0,
                par_3_score: 0,
                par_4_score: 0,
                par_5_score: 8.0,
            },
            par: 5,
            strokes_total: 8,
        },
        {
            id: 859,
            round_date: '2023-11-17T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 859,
            strokes_gained_round: {
                tee: 2.29017,
                sand: 0.0,
                approach: -2.93544,
                putting: 1.84115,
                around_green: 0.22608,
                recovery: 0.0,
                rough_inside_150: -0.97927,
                rough_outside_150: -0.1455,
                fairway_50_to_100: -1.90107,
                fairway_100_to_150: 0.68583,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.29757,
                putting_inside_5: 1.48837,
                putting_5_to_10: -1.00456,
                putting_10_to_15: 0.97237,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.16888,
                putting_outside_30: 0.55384,
                fairway_around_green_15: 0.17214,
                fairway_around_green_30: -0.23138,
                rough_around_green_15: -0.17264,
                rough_around_green_30: 0.45797,
                total: 1.42196,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -3,
                green_in_regulation_percentage: 0.7222,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 306.42857,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 869,
            round_date: '2023-11-17T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 869,
            strokes_gained_round: {
                tee: 3.06878,
                sand: 0.0,
                approach: -0.69111,
                putting: -0.81772,
                around_green: 0.55801,
                recovery: 0.0,
                rough_inside_150: 0.63478,
                rough_outside_150: 0.37533,
                fairway_50_to_100: -0.87447,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.16239,
                fairway_outside_200: -0.23008,
                putting_inside_5: -1.05523,
                putting_5_to_10: -1.14115,
                putting_10_to_15: -0.42119,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.0,
                putting_outside_30: 1.79985,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.3245,
                rough_around_green_30: 0.23351,
                total: 2.11796,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 3,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8889,
                total_putts: 34,
                three_putt_percentage: 0.1667,
                average_driving_distance: 334.07143,
                eagles: 0,
                birdies: 7,
                pars: 7,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 858,
            round_date: '2023-11-16T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 858,
            strokes_gained_round: {
                tee: 2.70709,
                sand: 0.0,
                approach: -2.76121,
                putting: 2.01394,
                around_green: -0.04414,
                recovery: 0.0,
                rough_inside_150: -0.54386,
                rough_outside_150: 0.094,
                fairway_50_to_100: -0.83285,
                fairway_100_to_150: -0.54684,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.25822,
                putting_inside_5: 0.30473,
                putting_5_to_10: 0.39674,
                putting_10_to_15: 0.66523,
                putting_15_to_20: 0.04557,
                putting_20_to_30: -0.39142,
                putting_outside_30: 0.99309,
                fairway_around_green_15: 0.02002,
                fairway_around_green_30: 0.09409,
                rough_around_green_15: -0.15825,
                rough_around_green_30: 0.0,
                total: 1.91568,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 322.35714,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 868,
            round_date: '2023-11-16T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 868,
            strokes_gained_round: {
                tee: 2.01285,
                sand: 0.0,
                approach: -2.17316,
                putting: -0.33692,
                around_green: 0.20836,
                recovery: 0.0,
                rough_inside_150: -0.27658,
                rough_outside_150: 1.25185,
                fairway_50_to_100: -2.65588,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.13303,
                putting_inside_5: 1.40909,
                putting_5_to_10: -1.56724,
                putting_10_to_15: 0.09481,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.46152,
                putting_outside_30: 0.18793,
                fairway_around_green_15: 0.05721,
                fairway_around_green_30: -0.11585,
                rough_around_green_15: 0.40655,
                rough_around_green_30: -0.13955,
                total: -0.28887,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -1,
                green_in_regulation_percentage: 0.6111,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 320.92857,
                eagles: 1,
                birdies: 4,
                pars: 8,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 857,
            round_date: '2023-11-15T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 857,
            strokes_gained_round: {
                tee: -0.08112,
                sand: 0.0,
                approach: -4.01931,
                putting: 0.54189,
                around_green: 1.8881,
                recovery: 0.0,
                rough_inside_150: -1.06675,
                rough_outside_150: 0.99769,
                fairway_50_to_100: -1.52951,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.5168,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.13918,
                putting_5_to_10: -1.14066,
                putting_10_to_15: -0.955,
                putting_15_to_20: 0.62579,
                putting_20_to_30: -0.19547,
                putting_outside_30: 1.06805,
                fairway_around_green_15: 0.03063,
                fairway_around_green_30: -0.19577,
                rough_around_green_15: 1.22301,
                rough_around_green_30: 0.83024,
                total: -1.67044,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: 0,
                green_in_regulation_percentage: 0.5556,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 299.42857,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 867,
            round_date: '2023-11-15T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 867,
            strokes_gained_round: {
                tee: 1.52257,
                sand: 0.0,
                approach: 2.2045,
                putting: 2.80951,
                around_green: 1.65433,
                recovery: 0.0,
                rough_inside_150: 3.81147,
                rough_outside_150: 0.43236,
                fairway_50_to_100: -0.34854,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.10245,
                putting_inside_5: 0.70905,
                putting_5_to_10: 0.1688,
                putting_10_to_15: 0.66523,
                putting_15_to_20: 0.59375,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.67267,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.54469,
                rough_around_green_30: 1.10964,
                total: 8.1909,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2143,
                score_to_par: -9,
                green_in_regulation_percentage: 0.8889,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 311.85714,
                eagles: 0,
                birdies: 9,
                pars: 9,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.5,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 63,
        },
        {
            id: 856,
            round_date: '2023-11-14T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 856,
            strokes_gained_round: {
                tee: 3.95755,
                sand: 0.0,
                approach: -4.00021,
                putting: 4.14458,
                around_green: 1.10384,
                recovery: 0.0,
                rough_inside_150: 0.13465,
                rough_outside_150: 0.21492,
                fairway_50_to_100: -2.69392,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.21276,
                fairway_outside_200: -0.29399,
                putting_inside_5: 0.35535,
                putting_5_to_10: 1.89095,
                putting_10_to_15: 1.0585,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 0.93335,
                putting_outside_30: 0.30065,
                fairway_around_green_15: -0.17503,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.90503,
                rough_around_green_30: 0.37384,
                total: 5.20575,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 24,
                three_putt_percentage: 0.0556,
                average_driving_distance: 335.92857,
                eagles: 0,
                birdies: 8,
                pars: 9,
                bogeys: 0,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 866,
            round_date: '2023-11-14T14:15:17.566989-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 866,
            strokes_gained_round: {
                tee: 2.54599,
                sand: 0.0,
                approach: 1.24714,
                putting: -0.95617,
                around_green: -0.74585,
                recovery: 0.0,
                rough_inside_150: 1.43349,
                rough_outside_150: 0.19778,
                fairway_50_to_100: -0.74744,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.63084,
                fairway_outside_200: 0.00326,
                putting_inside_5: 1.09209,
                putting_5_to_10: 0.0,
                putting_10_to_15: -1.33721,
                putting_15_to_20: -0.71035,
                putting_20_to_30: -0.50363,
                putting_outside_30: 0.50293,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.73034,
                rough_around_green_15: -0.01551,
                rough_around_green_30: 0.0,
                total: 2.09111,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 320.64286,
                eagles: 1,
                birdies: 4,
                pars: 10,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 855,
            round_date: '2023-11-13T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 855,
            strokes_gained_round: {
                tee: 0.6512,
                sand: 0.0,
                approach: -2.26938,
                putting: 1.06076,
                around_green: 0.5548,
                recovery: 0.0,
                rough_inside_150: 0.74549,
                rough_outside_150: 0.21274,
                fairway_50_to_100: -1.42171,
                fairway_100_to_150: -0.06146,
                fairway_150_to_200: -0.05326,
                fairway_outside_200: -0.29734,
                putting_inside_5: 0.21763,
                putting_5_to_10: -0.35051,
                putting_10_to_15: -0.95311,
                putting_15_to_20: 1.01447,
                putting_20_to_30: 0.40992,
                putting_outside_30: 0.72237,
                fairway_around_green_15: -0.45494,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.38,
                rough_around_green_30: 0.62975,
                total: -0.00261,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6667,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 302.57143,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 4.0,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 854,
            round_date: '2023-11-12T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 854,
            strokes_gained_round: {
                tee: 3.71784,
                sand: 0.0,
                approach: -1.43168,
                putting: 2.3254,
                around_green: -0.79708,
                recovery: 0.0,
                rough_inside_150: -0.01974,
                rough_outside_150: -0.17071,
                fairway_50_to_100: -0.61341,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.74429,
                fairway_outside_200: -0.07414,
                putting_inside_5: 0.68326,
                putting_5_to_10: -0.22841,
                putting_10_to_15: -0.86982,
                putting_15_to_20: 0.72894,
                putting_20_to_30: 1.2514,
                putting_outside_30: 0.76002,
                fairway_around_green_15: -0.42834,
                fairway_around_green_30: -0.78037,
                rough_around_green_15: 0.0,
                rough_around_green_30: 0.41163,
                total: 3.81449,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 337.85714,
                eagles: 1,
                birdies: 5,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 853,
            round_date: '2023-11-11T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 853,
            strokes_gained_round: {
                tee: 1.28483,
                sand: 0.0,
                approach: 0.51927,
                putting: -0.70232,
                around_green: 1.36852,
                recovery: 0.0,
                rough_inside_150: 1.76963,
                rough_outside_150: -0.23491,
                fairway_50_to_100: 0.08136,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.34228,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.54019,
                putting_5_to_10: -0.91225,
                putting_10_to_15: -0.29893,
                putting_15_to_20: -0.68527,
                putting_20_to_30: -0.34607,
                putting_outside_30: 0.0,
                fairway_around_green_15: -0.07057,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.98033,
                rough_around_green_30: 0.45875,
                total: 2.4703,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -4,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 324.5,
                eagles: 0,
                birdies: 7,
                pars: 8,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 852,
            round_date: '2023-11-10T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 852,
            strokes_gained_round: {
                tee: -0.17892,
                sand: 0.0,
                approach: -1.77405,
                putting: 0.53934,
                around_green: -0.17497,
                recovery: 0.0,
                rough_inside_150: 1.89786,
                rough_outside_150: 0.03439,
                fairway_50_to_100: -0.85062,
                fairway_100_to_150: -1.30701,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.1922,
                putting_inside_5: -0.89101,
                putting_5_to_10: -0.31928,
                putting_10_to_15: -0.92519,
                putting_15_to_20: -0.39421,
                putting_20_to_30: 0.80458,
                putting_outside_30: 2.26443,
                fairway_around_green_15: -0.4441,
                fairway_around_green_30: -1.01205,
                rough_around_green_15: 0.91116,
                rough_around_green_30: 0.37002,
                total: -1.5886,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6667,
                total_putts: 31,
                three_putt_percentage: 0.1111,
                average_driving_distance: 283.5,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 4.0,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 800,
            round_date: '2023-11-10T15:02:52.450251-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 800,
            strokes_gained_round: {
                tee: 2.84159,
                sand: 0.0,
                approach: -0.24082,
                putting: 0.89945,
                around_green: -0.30911,
                recovery: 0.0,
                rough_inside_150: 0.7795,
                rough_outside_150: 0.13229,
                fairway_50_to_100: -0.74944,
                fairway_100_to_150: -0.78844,
                fairway_150_to_200: 0.8316,
                fairway_outside_200: -0.26211,
                putting_inside_5: 1.47582,
                putting_5_to_10: 0.0,
                putting_10_to_15: -1.291,
                putting_15_to_20: -1.12964,
                putting_20_to_30: 1.25337,
                putting_outside_30: 0.59091,
                fairway_around_green_15: 0.01799,
                fairway_around_green_30: -0.20224,
                rough_around_green_15: -0.02964,
                rough_around_green_30: -0.09522,
                total: 3.19111,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 320.64286,
                eagles: 1,
                birdies: 5,
                pars: 9,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 851,
            round_date: '2023-11-09T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 851,
            strokes_gained_round: {
                tee: 2.57698,
                sand: 0.0,
                approach: 0.39043,
                putting: -1.80551,
                around_green: 0.67433,
                recovery: 0.0,
                rough_inside_150: 1.80733,
                rough_outside_150: 0.18478,
                fairway_50_to_100: -0.48337,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.01072,
                putting_inside_5: -0.03571,
                putting_5_to_10: -0.35148,
                putting_10_to_15: 0.00963,
                putting_15_to_20: -1.73683,
                putting_20_to_30: -0.12876,
                putting_outside_30: 0.43764,
                fairway_around_green_15: 0.03721,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.36411,
                rough_around_green_30: 0.27302,
                total: 1.83624,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8889,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 333.42857,
                eagles: 0,
                birdies: 4,
                pars: 13,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 69,
        },
        {
            id: 799,
            round_date: '2023-11-09T15:02:52.450251-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 799,
            strokes_gained_round: {
                tee: 3.46706,
                sand: 0.0,
                approach: -1.77746,
                putting: 0.01425,
                around_green: 1.26626,
                recovery: 0.0,
                rough_inside_150: 1.46358,
                rough_outside_150: -0.39078,
                fairway_50_to_100: -0.43663,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.41776,
                putting_inside_5: -0.30408,
                putting_5_to_10: -0.42417,
                putting_10_to_15: -1.40363,
                putting_15_to_20: 0.36218,
                putting_20_to_30: 1.43458,
                putting_outside_30: 0.34937,
                fairway_around_green_15: -0.07653,
                fairway_around_green_30: -0.0579,
                rough_around_green_15: 0.76,
                rough_around_green_30: 0.64069,
                total: 2.97011,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 29,
                three_putt_percentage: 0.0556,
                average_driving_distance: 321.78571,
                eagles: 1,
                birdies: 5,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 850,
            round_date: '2023-11-08T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 850,
            strokes_gained_round: {
                tee: 1.79128,
                sand: 0.0,
                approach: -1.81626,
                putting: 1.34166,
                around_green: 1.16571,
                recovery: 0.0,
                rough_inside_150: 1.94321,
                rough_outside_150: -0.37966,
                fairway_50_to_100: -1.72906,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.4171,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.57816,
                putting_5_to_10: 0.41221,
                putting_10_to_15: 0.55261,
                putting_15_to_20: -0.39421,
                putting_20_to_30: -0.19547,
                putting_outside_30: 0.38838,
                fairway_around_green_15: -0.06061,
                fairway_around_green_30: 0.07826,
                rough_around_green_15: 0.7638,
                rough_around_green_30: 0.38426,
                total: 2.4824,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 316.57143,
                eagles: 0,
                birdies: 6,
                pars: 10,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 798,
            round_date: '2023-11-08T15:02:52.450251-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 798,
            strokes_gained_round: {
                tee: 2.61532,
                sand: 0.0,
                approach: -2.38357,
                putting: -0.26542,
                around_green: 0.03607,
                recovery: 0.0,
                rough_inside_150: 1.36189,
                rough_outside_150: -0.15039,
                fairway_50_to_100: -0.59057,
                fairway_100_to_150: -0.72968,
                fairway_150_to_200: -0.48288,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.9466,
                putting_5_to_10: 1.22051,
                putting_10_to_15: -0.44863,
                putting_15_to_20: 0.25807,
                putting_20_to_30: -0.97414,
                putting_outside_30: 0.62536,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.61858,
                rough_around_green_15: 0.62613,
                rough_around_green_30: 0.02852,
                total: 0.00239,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -2,
                green_in_regulation_percentage: 0.8333,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 328.28571,
                eagles: 0,
                birdies: 6,
                pars: 8,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 849,
            round_date: '2023-11-07T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 849,
            strokes_gained_round: {
                tee: 1.24146,
                sand: 0.0,
                approach: -4.82689,
                putting: -1.75085,
                around_green: 0.0872,
                recovery: 0.0,
                rough_inside_150: 0.29324,
                rough_outside_150: 0.15547,
                fairway_50_to_100: -1.13223,
                fairway_100_to_150: -1.78992,
                fairway_150_to_200: -0.90205,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.4618,
                putting_5_to_10: -0.48664,
                putting_10_to_15: -0.47655,
                putting_15_to_20: -0.29106,
                putting_20_to_30: -0.51883,
                putting_outside_30: 0.48404,
                fairway_around_green_15: -0.8367,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.79588,
                rough_around_green_30: 0.12802,
                total: -5.24908,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 3,
                blown_up_and_downs: 2,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 4,
                green_in_regulation_percentage: 0.6667,
                total_putts: 34,
                three_putt_percentage: 0.0556,
                average_driving_distance: 304.14286,
                eagles: 0,
                birdies: 1,
                pars: 12,
                bogeys: 5,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.3,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 76,
        },
        {
            id: 797,
            round_date: '2023-11-07T15:02:52.450251-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 797,
            strokes_gained_round: {
                tee: 3.45559,
                sand: 0.0,
                approach: -3.45098,
                putting: -0.76551,
                around_green: 1.22189,
                recovery: 0.0,
                rough_inside_150: 0.76957,
                rough_outside_150: -0.32801,
                fairway_50_to_100: -0.80984,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.35609,
                fairway_outside_200: -0.6435,
                putting_inside_5: 1.22497,
                putting_5_to_10: -2.93728,
                putting_10_to_15: -0.42119,
                putting_15_to_20: -0.31613,
                putting_20_to_30: 0.80316,
                putting_outside_30: 0.88095,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.09828,
                rough_around_green_15: 0.23623,
                rough_around_green_30: 0.88739,
                total: 0.46099,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.1111,
                average_driving_distance: 335.85714,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 5.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 848,
            round_date: '2023-11-06T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 848,
            strokes_gained_round: {
                tee: 2.9113,
                sand: 0.0,
                approach: -3.48881,
                putting: 2.44427,
                around_green: 0.94961,
                recovery: 0.0,
                rough_inside_150: 1.27296,
                rough_outside_150: 0.0,
                fairway_50_to_100: -2.21988,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.3488,
                fairway_outside_200: -0.09866,
                putting_inside_5: 1.67355,
                putting_5_to_10: -0.59297,
                putting_10_to_15: 0.63779,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.74071,
                putting_outside_30: 0.35291,
                fairway_around_green_15: -0.06608,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.01569,
                rough_around_green_30: 0.0,
                total: 2.81637,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -4,
                green_in_regulation_percentage: 0.7222,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 305.07143,
                eagles: 0,
                birdies: 5,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 796,
            round_date: '2023-11-06T15:02:52.450251-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 796,
            strokes_gained_round: {
                tee: 3.96676,
                sand: 0.0,
                approach: -3.90809,
                putting: -1.79544,
                around_green: 0.56169,
                recovery: 0.0,
                rough_inside_150: 0.93247,
                rough_outside_150: -0.32088,
                fairway_50_to_100: -0.55531,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -1.61762,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.75592,
                putting_5_to_10: -0.88148,
                putting_10_to_15: -1.90763,
                putting_15_to_20: -1.44719,
                putting_20_to_30: 0.73977,
                putting_outside_30: 0.94518,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.40821,
                rough_around_green_30: 0.15348,
                total: -1.17509,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -1,
                green_in_regulation_percentage: 0.8889,
                total_putts: 33,
                three_putt_percentage: 0.0,
                average_driving_distance: 330.92857,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.8,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 847,
            round_date: '2023-11-05T23:28:49.175679-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 847,
            strokes_gained_round: {
                tee: 2.96094,
                sand: 0.0,
                approach: 2.80281,
                putting: -0.63422,
                around_green: -0.94494,
                recovery: 0.0,
                rough_inside_150: 1.43618,
                rough_outside_150: -0.10857,
                fairway_50_to_100: 0.35737,
                fairway_100_to_150: 0.48895,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.2023,
                putting_inside_5: 0.92099,
                putting_5_to_10: -1.24699,
                putting_10_to_15: -0.89,
                putting_15_to_20: 0.54217,
                putting_20_to_30: -0.41698,
                putting_outside_30: 0.45658,
                fairway_around_green_15: 0.02,
                fairway_around_green_30: -0.53837,
                rough_around_green_15: -0.42657,
                rough_around_green_30: 0.0,
                total: 4.18459,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -6,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 337.85714,
                eagles: 0,
                birdies: 7,
                pars: 10,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 795,
            round_date: '2023-11-05T15:02:52.450251-06:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 795,
            strokes_gained_round: {
                tee: 1.50392,
                sand: 0.0,
                approach: -0.68491,
                putting: -3.88743,
                around_green: 1.60772,
                recovery: 0.0,
                rough_inside_150: 2.35866,
                rough_outside_150: 0.33274,
                fairway_50_to_100: -1.55515,
                fairway_100_to_150: -0.4535,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 0.44956,
                putting_5_to_10: -3.27058,
                putting_10_to_15: -0.92519,
                putting_15_to_20: -0.34169,
                putting_20_to_30: -0.32613,
                putting_outside_30: 0.52658,
                fairway_around_green_15: 0.03063,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.57708,
                rough_around_green_30: 0.0,
                total: -1.4607,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 4,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.7778,
                total_putts: 32,
                three_putt_percentage: 0.0556,
                average_driving_distance: 291.21429,
                eagles: 0,
                birdies: 3,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 4.1,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 846,
            round_date: '2023-11-04T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 846,
            strokes_gained_round: {
                tee: 4.29826,
                sand: 0.0,
                approach: 1.28451,
                putting: 1.70442,
                around_green: 0.01983,
                recovery: 0.0,
                rough_inside_150: 1.21754,
                rough_outside_150: 0.0,
                fairway_50_to_100: -0.10492,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.28603,
                fairway_outside_200: -0.11396,
                putting_inside_5: 1.55511,
                putting_5_to_10: -0.88435,
                putting_10_to_15: 0.09387,
                putting_15_to_20: -0.78843,
                putting_20_to_30: 1.44924,
                putting_outside_30: 0.27898,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.36221,
                rough_around_green_15: 0.38204,
                rough_around_green_30: 0.0,
                total: 7.30702,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7857,
                score_to_par: -9,
                green_in_regulation_percentage: 0.9444,
                total_putts: 28,
                three_putt_percentage: 0.0556,
                average_driving_distance: 329.14286,
                eagles: 1,
                birdies: 8,
                pars: 8,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.4,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 63,
        },
        {
            id: 794,
            round_date: '2023-11-04T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 794,
            strokes_gained_round: {
                tee: 1.82818,
                sand: 0.0,
                approach: -4.67952,
                putting: -0.21441,
                around_green: 1.96456,
                recovery: 0.0,
                rough_inside_150: 1.1048,
                rough_outside_150: -0.40059,
                fairway_50_to_100: -0.97752,
                fairway_100_to_150: -0.4836,
                fairway_150_to_200: -0.49068,
                fairway_outside_200: -0.55069,
                putting_inside_5: 1.09824,
                putting_5_to_10: -0.89583,
                putting_10_to_15: -0.51408,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.26645,
                putting_outside_30: 0.36371,
                fairway_around_green_15: -0.20675,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.90578,
                rough_around_green_30: 0.26554,
                total: -1.10119,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -1,
                green_in_regulation_percentage: 0.5556,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 306.78571,
                eagles: 0,
                birdies: 3,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.9,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 845,
            round_date: '2023-11-03T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 845,
            strokes_gained_round: {
                tee: 1.93845,
                sand: 0.0,
                approach: -1.08608,
                putting: 2.08702,
                around_green: 0.26456,
                recovery: 0.0,
                rough_inside_150: 0.83129,
                rough_outside_150: 0.06022,
                fairway_50_to_100: -0.6383,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.85991,
                fairway_outside_200: 0.15109,
                putting_inside_5: 1.30425,
                putting_5_to_10: -1.18594,
                putting_10_to_15: 0.51505,
                putting_15_to_20: 1.24509,
                putting_20_to_30: -0.15053,
                putting_outside_30: 0.35909,
                fairway_around_green_15: 0.02939,
                fairway_around_green_30: -0.39138,
                rough_around_green_15: 0.62655,
                rough_around_green_30: 0.0,
                total: 3.20394,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -5,
                green_in_regulation_percentage: 0.7222,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 325.28571,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.6,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 793,
            round_date: '2023-11-03T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 793,
            strokes_gained_round: {
                tee: 1.94247,
                sand: 0.0,
                approach: 1.84471,
                putting: -1.75513,
                around_green: 1.27281,
                recovery: 0.0,
                rough_inside_150: 4.19002,
                rough_outside_150: -0.49434,
                fairway_50_to_100: -0.16691,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.14963,
                fairway_outside_200: 0.10593,
                putting_inside_5: 1.37643,
                putting_5_to_10: -3.77602,
                putting_10_to_15: 0.0,
                putting_15_to_20: 0.67183,
                putting_20_to_30: -0.30152,
                putting_outside_30: 0.27415,
                fairway_around_green_15: -0.36755,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 1.28462,
                rough_around_green_30: 0.35574,
                total: 3.30486,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 30,
                three_putt_percentage: 0.0556,
                average_driving_distance: 311.57143,
                eagles: 0,
                birdies: 5,
                pars: 13,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.8,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 844,
            round_date: '2023-11-02T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 844,
            strokes_gained_round: {
                tee: 2.25492,
                sand: 0.0,
                approach: -4.11862,
                putting: 2.21194,
                around_green: 0.45016,
                recovery: 0.0,
                rough_inside_150: 0.90145,
                rough_outside_150: 0.0,
                fairway_50_to_100: -1.20313,
                fairway_100_to_150: -1.01255,
                fairway_150_to_200: -0.76415,
                fairway_outside_200: -0.51806,
                putting_inside_5: 0.74171,
                putting_5_to_10: 0.44344,
                putting_10_to_15: -0.29893,
                putting_15_to_20: 0.65229,
                putting_20_to_30: -0.70566,
                putting_outside_30: 1.37909,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -1.07202,
                rough_around_green_15: 1.2293,
                rough_around_green_30: 0.29288,
                total: 0.7984,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -2,
                green_in_regulation_percentage: 0.6111,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 320.42857,
                eagles: 0,
                birdies: 4,
                pars: 12,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 4.1,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 792,
            round_date: '2023-11-02T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 792,
            strokes_gained_round: {
                tee: 1.95614,
                sand: 0.0,
                approach: 1.51388,
                putting: 1.62251,
                around_green: 1.11817,
                recovery: 0.0,
                rough_inside_150: 1.54054,
                rough_outside_150: 0.39202,
                fairway_50_to_100: 0.02636,
                fairway_100_to_150: 0.60776,
                fairway_150_to_200: -0.57796,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.66042,
                putting_5_to_10: -0.19718,
                putting_10_to_15: -0.53381,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.93335,
                putting_outside_30: 0.12745,
                fairway_around_green_15: 0.35215,
                fairway_around_green_30: 0.29118,
                rough_around_green_15: 0.47484,
                rough_around_green_30: 0.0,
                total: 6.2107,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -8,
                green_in_regulation_percentage: 0.7778,
                total_putts: 24,
                three_putt_percentage: 0.0,
                average_driving_distance: 304.92857,
                eagles: 0,
                birdies: 8,
                pars: 10,
                bogeys: 0,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 3.6,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 64,
        },
        {
            id: 843,
            round_date: '2023-11-01T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 1,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 843,
            strokes_gained_round: {
                tee: 2.43934,
                sand: 0.0,
                approach: -1.43859,
                putting: -0.61037,
                around_green: 0.26024,
                recovery: 0.0,
                rough_inside_150: -0.57137,
                rough_outside_150: 0.95481,
                fairway_50_to_100: -1.25067,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.22987,
                putting_inside_5: 0.5182,
                putting_5_to_10: -1.19981,
                putting_10_to_15: -0.9815,
                putting_15_to_20: -0.63227,
                putting_20_to_30: -0.39244,
                putting_outside_30: 2.07746,
                fairway_around_green_15: -0.08125,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.34149,
                rough_around_green_30: 0.0,
                total: 0.65062,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 3,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.2857,
                score_to_par: -2,
                green_in_regulation_percentage: 0.7778,
                total_putts: 31,
                three_putt_percentage: 0.0,
                average_driving_distance: 311.57143,
                eagles: 1,
                birdies: 2,
                pars: 13,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.2,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 70,
        },
        {
            id: 791,
            round_date: '2023-11-01T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 791,
            strokes_gained_round: {
                tee: 1.08509,
                sand: 0.0,
                approach: -0.77831,
                putting: 2.42069,
                around_green: 0.77844,
                recovery: 0.0,
                rough_inside_150: 0.63834,
                rough_outside_150: 0.55242,
                fairway_50_to_100: -1.07273,
                fairway_100_to_150: 0.35407,
                fairway_150_to_200: -0.4772,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.05824,
                putting_5_to_10: -0.52906,
                putting_10_to_15: 0.065,
                putting_15_to_20: 0.93544,
                putting_20_to_30: 0.78038,
                putting_outside_30: 0.11069,
                fairway_around_green_15: 0.04784,
                fairway_around_green_30: -0.14862,
                rough_around_green_15: 0.65584,
                rough_around_green_30: 0.22339,
                total: 3.50591,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.3571,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 307.85714,
                eagles: 1,
                birdies: 4,
                pars: 12,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 842,
            round_date: '2023-10-31T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 842,
            strokes_gained_round: {
                tee: 2.72996,
                sand: 0.0,
                approach: -1.95435,
                putting: 0.45569,
                around_green: 0.6304,
                recovery: 0.0,
                rough_inside_150: 0.31619,
                rough_outside_150: -0.50303,
                fairway_50_to_100: 0.33004,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: -0.71257,
                fairway_outside_200: 0.0,
                putting_inside_5: -0.32693,
                putting_5_to_10: -0.35051,
                putting_10_to_15: 0.065,
                putting_15_to_20: 0.62579,
                putting_20_to_30: -0.30152,
                putting_outside_30: 0.74386,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.08193,
                rough_around_green_15: 0.23892,
                rough_around_green_30: 0.47341,
                total: 1.86171,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 1,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.4286,
                score_to_par: -4,
                green_in_regulation_percentage: 0.8333,
                total_putts: 31,
                three_putt_percentage: 0.1111,
                average_driving_distance: 334.92857,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 0,
                double_bogeys: 1,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.5,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 790,
            round_date: '2023-10-31T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 790,
            strokes_gained_round: {
                tee: 2.04876,
                sand: 0.0,
                approach: 0.59479,
                putting: -4.2665,
                around_green: 0.78545,
                recovery: 0.0,
                rough_inside_150: 0.99942,
                rough_outside_150: 1.22768,
                fairway_50_to_100: -0.49996,
                fairway_100_to_150: 0.74057,
                fairway_150_to_200: 0.03368,
                fairway_outside_200: -0.60329,
                putting_inside_5: -1.84082,
                putting_5_to_10: -2.12942,
                putting_10_to_15: -0.04763,
                putting_15_to_20: 0.0,
                putting_20_to_30: -0.39095,
                putting_outside_30: 0.14231,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: 0.0,
                rough_around_green_15: 0.58952,
                rough_around_green_30: 0.19593,
                total: -0.8375,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 1,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 0,
                three_putts: 2,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -1,
                green_in_regulation_percentage: 0.7778,
                total_putts: 34,
                three_putt_percentage: 0.1111,
                average_driving_distance: 318.0,
                eagles: 1,
                birdies: 2,
                pars: 12,
                bogeys: 3,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 3.9,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 71,
        },
        {
            id: 841,
            round_date: '2023-10-30T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 841,
            strokes_gained_round: {
                tee: 3.24224,
                sand: 0.0,
                approach: -3.09111,
                putting: 1.8678,
                around_green: 0.53117,
                recovery: 0.0,
                rough_inside_150: 1.46314,
                rough_outside_150: 0.98838,
                fairway_50_to_100: -2.17875,
                fairway_100_to_150: -0.27424,
                fairway_150_to_200: 0.0,
                fairway_outside_200: 0.0,
                putting_inside_5: 1.12653,
                putting_5_to_10: -1.18641,
                putting_10_to_15: 0.17763,
                putting_15_to_20: 0.0,
                putting_20_to_30: 0.62479,
                putting_outside_30: 1.12526,
                fairway_around_green_15: -0.93733,
                fairway_around_green_30: -0.26125,
                rough_around_green_15: 1.09098,
                rough_around_green_30: 0.63878,
                total: 2.5501,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: -4,
                green_in_regulation_percentage: 0.6111,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 337.07143,
                eagles: 1,
                birdies: 6,
                pars: 7,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.75,
                par_4_score: 3.8,
                par_5_score: 3.75,
            },
            par: 72,
            strokes_total: 68,
        },
        {
            id: 789,
            round_date: '2023-10-30T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 789,
            strokes_gained_round: {
                tee: 3.71641,
                sand: 0.0,
                approach: -3.15619,
                putting: 1.88817,
                around_green: 1.44566,
                recovery: 0.0,
                rough_inside_150: 1.69428,
                rough_outside_150: -0.10782,
                fairway_50_to_100: -3.0405,
                fairway_100_to_150: 0.27576,
                fairway_150_to_200: 0.02646,
                fairway_outside_200: 0.09202,
                putting_inside_5: 1.60042,
                putting_5_to_10: -2.43341,
                putting_10_to_15: 0.55355,
                putting_15_to_20: 0.33473,
                putting_20_to_30: 1.66608,
                putting_outside_30: 0.16679,
                fairway_around_green_15: 0.0,
                fairway_around_green_30: -0.0548,
                rough_around_green_15: 0.70283,
                rough_around_green_30: 0.79763,
                total: 3.89404,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.8571,
                score_to_par: -6,
                green_in_regulation_percentage: 0.6667,
                total_putts: 26,
                three_putt_percentage: 0.0,
                average_driving_distance: 309.21429,
                eagles: 1,
                birdies: 6,
                pars: 9,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.7,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 66,
        },
        {
            id: 840,
            round_date: '2023-10-29T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 840,
            strokes_gained_round: {
                tee: 2.06834,
                sand: 0.0,
                approach: -3.06929,
                putting: 0.01658,
                around_green: -0.68292,
                recovery: 0.0,
                rough_inside_150: 0.57591,
                rough_outside_150: -0.17273,
                fairway_50_to_100: -1.45572,
                fairway_100_to_150: -0.38609,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.06257,
                putting_inside_5: 1.05114,
                putting_5_to_10: -0.81996,
                putting_10_to_15: 0.00963,
                putting_15_to_20: -0.03203,
                putting_20_to_30: -0.67687,
                putting_outside_30: 0.48467,
                fairway_around_green_15: -1.17407,
                fairway_around_green_30: -0.67392,
                rough_around_green_15: 0.84485,
                rough_around_green_30: 0.32022,
                total: -1.66728,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5,
                score_to_par: 0,
                green_in_regulation_percentage: 0.6111,
                total_putts: 30,
                three_putt_percentage: 0.0,
                average_driving_distance: 317.14286,
                eagles: 0,
                birdies: 4,
                pars: 10,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.1,
                par_5_score: 4.25,
            },
            par: 72,
            strokes_total: 72,
        },
        {
            id: 788,
            round_date: '2023-10-29T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 788,
            strokes_gained_round: {
                tee: 1.93824,
                sand: 0.0,
                approach: -1.65519,
                putting: 2.53414,
                around_green: 0.59827,
                recovery: 0.0,
                rough_inside_150: 0.01721,
                rough_outside_150: 0.4986,
                fairway_50_to_100: 0.04804,
                fairway_100_to_150: 0.02625,
                fairway_150_to_200: -0.11092,
                fairway_outside_200: 0.40618,
                putting_inside_5: -0.02104,
                putting_5_to_10: 0.47468,
                putting_10_to_15: 0.59881,
                putting_15_to_20: 0.62579,
                putting_20_to_30: 0.0,
                putting_outside_30: 0.85591,
                fairway_around_green_15: -0.08245,
                fairway_around_green_30: -0.23494,
                rough_around_green_15: 0.91566,
                rough_around_green_30: 0.0,
                total: 3.41546,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 1,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.5714,
                score_to_par: -5,
                green_in_regulation_percentage: 0.6667,
                total_putts: 27,
                three_putt_percentage: 0.0,
                average_driving_distance: 293.78571,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 2.75,
                par_4_score: 4.0,
                par_5_score: 4.0,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 839,
            round_date: '2023-10-28T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 839,
            strokes_gained_round: {
                tee: 1.82118,
                sand: 0.0,
                approach: -2.81156,
                putting: -2.63047,
                around_green: 0.53171,
                recovery: 0.0,
                rough_inside_150: -0.99623,
                rough_outside_150: 0.04858,
                fairway_50_to_100: -0.35556,
                fairway_100_to_150: -0.44158,
                fairway_150_to_200: -0.13984,
                fairway_outside_200: -0.24335,
                putting_inside_5: 0.74326,
                putting_5_to_10: -2.84497,
                putting_10_to_15: -0.86982,
                putting_15_to_20: -0.39421,
                putting_20_to_30: -0.25942,
                putting_outside_30: 0.99469,
                fairway_around_green_15: -0.09715,
                fairway_around_green_30: -0.11533,
                rough_around_green_15: 0.35065,
                rough_around_green_30: 0.39354,
                total: -3.08913,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 2,
                blown_up_and_downs: 1,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: 2,
                green_in_regulation_percentage: 0.6667,
                total_putts: 34,
                three_putt_percentage: 0.0,
                average_driving_distance: 312.5,
                eagles: 0,
                birdies: 2,
                pars: 12,
                bogeys: 4,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.5,
                par_4_score: 4.2,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 74,
        },
        {
            id: 787,
            round_date: '2023-10-28T15:02:52.450251-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 787,
            strokes_gained_round: {
                tee: 4.24327,
                sand: 0.0,
                approach: -0.26441,
                putting: -0.7583,
                around_green: 0.92326,
                recovery: 0.0,
                rough_inside_150: 1.59472,
                rough_outside_150: -0.08157,
                fairway_50_to_100: -0.52305,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.0,
                fairway_outside_200: -0.66243,
                putting_inside_5: -1.13099,
                putting_5_to_10: -0.56316,
                putting_10_to_15: 1.08689,
                putting_15_to_20: -0.36771,
                putting_20_to_30: 0.26311,
                putting_outside_30: -0.04644,
                fairway_around_green_15: -0.17741,
                fairway_around_green_30: 0.30702,
                rough_around_green_15: 0.58043,
                rough_around_green_30: 0.21323,
                total: 4.14383,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 2,
                three_putts: 0,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.6429,
                score_to_par: -5,
                green_in_regulation_percentage: 0.8333,
                total_putts: 28,
                three_putt_percentage: 0.0,
                average_driving_distance: 339.14286,
                eagles: 0,
                birdies: 6,
                pars: 11,
                bogeys: 1,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.0,
                par_4_score: 3.6,
                par_5_score: 4.75,
            },
            par: 72,
            strokes_total: 67,
        },
        {
            id: 838,
            round_date: '2023-10-27T23:28:49.175679-05:00',
            number_of_holes: 18,
            possible_error_holes: 0,
            number_of_holes_complete: 18,
            user: {
                email: 'folkerts.chandler@gmail.com',
                id: 2,
                first_name: 'Chandler',
                last_name: 'Folkerts',
                full_name: 'Chandler Folkerts',
            },
            course: {
                id: 1,
                name: 'Random Course #1',
                rating: null,
                slope: null,
                city: null,
                state: null,
            },
            wind: null,
            wind_gusts: null,
            temperature: null,
            round_type: 'practice',
            score_to_par: null,
            round_id: 838,
            strokes_gained_round: {
                tee: 4.32078,
                sand: 0.0,
                approach: -3.41207,
                putting: 0.39105,
                around_green: 0.40065,
                recovery: 0.0,
                rough_inside_150: -0.63995,
                rough_outside_150: -0.03966,
                fairway_50_to_100: -1.85667,
                fairway_100_to_150: 0.0,
                fairway_150_to_200: 0.25772,
                fairway_outside_200: -0.52761,
                putting_inside_5: 0.59416,
                putting_5_to_10: -0.3813,
                putting_10_to_15: 0.0,
                putting_15_to_20: -1.07806,
                putting_20_to_30: 0.3478,
                putting_outside_30: 0.90845,
                fairway_around_green_15: -0.12791,
                fairway_around_green_30: 0.13776,
                rough_around_green_15: 0.3908,
                rough_around_green_30: 0.0,
                total: 1.70042,
            },
            bulldog_five: {
                par_5_bogey_or_worse: 0,
                double_bogeys: 0,
                bogeys_from_150_out: 0,
                blown_up_and_downs: 1,
                three_putts: 1,
            },
            complete: true,
            traditional_stats: {
                fairway_hit_percentage: 0.7143,
                score_to_par: -3,
                green_in_regulation_percentage: 0.8333,
                total_putts: 33,
                three_putt_percentage: 0.0556,
                average_driving_distance: 332.85714,
                eagles: 0,
                birdies: 5,
                pars: 11,
                bogeys: 2,
                double_bogeys: 0,
                triple_bogeys_or_worse: 0,
                penalty_strokes: 0,
                par_3_score: 3.25,
                par_4_score: 3.8,
                par_5_score: 4.5,
            },
            par: 72,
            strokes_total: 69,
        },
    ],
};
export const DEMO_DASHBOARD_DATA = {
    historical_strokes_gained: {
        tee: 1.76022,
        sand: 0,
        approach: -1.69506,
        putting: 0.10432,
        around_green: 0.06347,
        recovery: 0,
        rough_inside_150: 0.38194,
        rough_outside_150: 0.19023,
        fairway_50_to_100: -1.01756,
        fairway_100_to_150: -0.28516,
        fairway_150_to_200: -0.16166,
        fairway_outside_200: -0.0504,
        putting_inside_5: 0.72435,
        putting_5_to_10: -0.02282,
        putting_10_to_15: -0.62051,
        putting_15_to_20: -0.36757,
        putting_20_to_30: -0.12467,
        putting_outside_30: 0.51554,
        fairway_around_green_15: -0.17698,
        fairway_around_green_30: -0.27646,
        rough_around_green_15: 0.39466,
        rough_around_green_30: 0.12225,
        total: 0.23295,
    },
    historical_bulldog_five: {
        par_5_bogey_or_worse: 0.15,
        double_bogeys: 0.15,
        bogeys_from_150_out: 0.8,
        blown_up_and_downs: 0.4,
        three_putts: 1.05,
    },
    historical_traditional_stats: {
        fairway_hit_percentage: 0.53643,
        score_to_par: -1.7,
        green_in_regulation_percentage: 0.7,
        total_putts: 29.0,
        three_putt_percentage: 0.05835,
        average_driving_distance: 298.59,
        eagles: 0.1,
        birdies: 4.55,
        pars: 9.55,
        bogeys: 2.75,
        double_bogeys: 0.15,
        triple_bogeys_or_worse: 0,
        penalty_strokes: 0,
        par_3_score: 3.3375,
        par_4_score: 3.67,
        par_5_score: 4.2125,
        feet_of_made_putts: 70.0,
    },
    recent_strokes_gained: {
        tee: 1.22097,
        sand: 0,
        approach: -1.77106,
        putting: 0.83053,
        around_green: 0.31859,
        recovery: 0,
        rough_inside_150: 0.1601,
        rough_outside_150: -0.1853,
        fairway_50_to_100: -0.88601,
        fairway_100_to_150: -0.1365,
        fairway_150_to_200: -0.21504,
        fairway_outside_200: -0.05282,
        putting_inside_5: 0.49295,
        putting_5_to_10: 0.43331,
        putting_10_to_15: 0.06508,
        putting_15_to_20: -0.85063,
        putting_20_to_30: 0.34477,
        putting_outside_30: 0.34506,
        fairway_around_green_15: -0.06304,
        fairway_around_green_30: -0.14878,
        rough_around_green_15: 0.35209,
        rough_around_green_30: 0.17832,
        total: 0.59904,
    },
    recent_bulldog_five: {
        par_5_bogey_or_worse: 0.2,
        double_bogeys: 0.4,
        bogeys_from_150_out: 0,
        blown_up_and_downs: 0,
        three_putts: 0.8,
    },
    recent_traditional_stats: {
        fairway_hit_percentage: 0.47428,
        score_to_par: -2.4,
        green_in_regulation_percentage: 0.62222,
        total_putts: 24.0,
        three_putt_percentage: 0.04446,
        average_driving_distance: 253.24571,
        eagles: 0,
        birdies: 4.6,
        pars: 8.0,
        bogeys: 1.4,
        double_bogeys: 0.4,
        triple_bogeys_or_worse: 0,
        penalty_strokes: 0,
        par_3_score: 2.8,
        par_4_score: 3.02,
        par_5_score: 3.65,
        feet_of_made_putts: 70.0,
    },
    rounds_logged: 20,
    user_id: 2,
};

export const DEMO_DISPERSION_DATA = {
    putting_make_percentage: [
        [1.0, 1.0],
        [2.0, 1.0],
        [3.0, 0.7586206896551724],
        [4.0, 0.8125],
        [5.0, 0.7368421052631579],
        [6.0, 0.8571428571428571],
        [7.0, 0.7],
        [8.0, 0.375],
        [9.0, 0.6666666666666666],
        [10.0, 0.75],
        [12.0, 0.2777777777777778],
        [14.0, 0.2],
        [16.0, 0.2777777777777778],
        [18.0, 0.05555555555555555],
        [20.0, 0.3076923076923077],
        [22.0, 0.15789473684210525],
        [24.0, 0.07692307692307693],
        [26.0, 0.09090909090909091],
        [28.0, 0.125],
        [30.0, 0.4],
        [35.0, 0.05555555555555555],
        [40.0, 0.2727272727272727],
        [45.0, 0.0],
        [50.0, 0.0],
        [55.0, 0.0],
        [60.0, 0.0],
        [65.0, 0.588339222614841],
    ],
    putting_three_putt_percentage: [
        [1.0, 0.0],
        [2.0, 0.0],
        [3.0, 0.0],
        [4.0, 0.0],
        [5.0, 0.0],
        [6.0, 0.0],
        [7.0, 0.0],
        [8.0, 0.0],
        [9.0, 0.0],
        [10.0, 0.0],
        [12.0, 0.0],
        [14.0, 0.2],
        [16.0, 0.0],
        [18.0, 0.05555555555555555],
        [20.0, 0.0],
        [22.0, 0.0],
        [24.0, 0.0],
        [26.0, 0.0],
        [28.0, 0.0],
        [30.0, 0.0],
        [35.0, 0.0],
        [40.0, 0.0],
        [45.0, 0.2222222222222222],
        [50.0, 0.0],
        [55.0, 0.5],
        [60.0, 0.0],
        [65.0, 0.044169611307420496],
    ],
    fairway_green_hit_percentage: [
        [30.0, 1.0],
        [40.0, 0.9444444444444444],
        [50.0, 0.875],
        [60.0, 0.95],
        [70.0, 0.8],
        [80.0, 0.7619047619047619],
        [90.0, 0.8333333333333334],
        [100.0, 0.8333333333333334],
        [110.0, 0.7777777777777778],
        [120.0, 0.2857142857142857],
        [130.0, 0.0],
        [140.0, 1.0],
        [150.0, 0.0],
        [160.0, 0.0],
        [170.0, 0.6],
        [180.0, 0.3333333333333333],
        [190.0, 0.25],
        [200.0, 0.5],
        [210.0, 0.3333333333333333],
        [220.0, 0.25],
        [230.0, 0.2],
        [240.0, 0.0],
        [250.0, 0.0],
        [260.0, 0.0],
        [270.0, 0.6708860759493671],
    ],
    rough_green_hit_percentage: [
        [30.0, 1.0],
        [40.0, 0.9333333333333333],
        [50.0, 0.875],
        [60.0, 0.7857142857142857],
        [70.0, 0.7],
        [80.0, 0.6363636363636364],
        [90.0, 1.0],
        [100.0, 0.6666666666666666],
        [110.0, 0.7142857142857143],
        [120.0, 1.0],
        [130.0, 0.6666666666666666],
        [140.0, 0.5],
        [150.0, 1.0],
        [160.0, 1.0],
        [170.0, 0.0],
        [180.0, 0.0],
        [190.0, 0.75],
        [200.0, 0.0],
        [210.0, 0.0],
        [220.0, 0.6666666666666666],
        [230.0, 0.0],
        [240.0, 0.6666666666666666],
        [250.0, 0.25],
        [260.0, 0.3333333333333333],
        [270.0, 0.7132352941176471],
    ],
    fairway_dispersion: [
        {
            distance: 30,
            percentile_25th: 2.75,
            percentile_50th: 5.0,
            percentile_75th: 6.25,
        },
        {
            distance: 40,
            percentile_25th: 1.0,
            percentile_50th: 3.0,
            percentile_75th: 5.0,
        },
        {
            distance: 50,
            percentile_25th: 5.5,
            percentile_50th: 9.0,
            percentile_75th: 11.0,
        },
        {
            distance: 60,
            percentile_25th: 4.0,
            percentile_50th: 7.0,
            percentile_75th: 8.5,
        },
        {
            distance: 70,
            percentile_25th: 3.5,
            percentile_50th: 5.0,
            percentile_75th: 12.5,
        },
        {
            distance: 80,
            percentile_25th: 5.5,
            percentile_50th: 9.5,
            percentile_75th: 11.75,
        },
        {
            distance: 90,
            percentile_25th: 10.0,
            percentile_50th: 11.0,
            percentile_75th: 17.0,
        },
        {
            distance: 100,
            percentile_25th: 6.5,
            percentile_50th: 11.5,
            percentile_75th: 19.25,
        },
        {
            distance: 110,
            percentile_25th: 8.0,
            percentile_50th: 11.0,
            percentile_75th: 15.0,
        },
        {
            distance: 120,
            percentile_25th: 10.75,
            percentile_50th: 13.5,
            percentile_75th: 19.5,
        },
        {
            distance: 130,
            percentile_25th: 3.0,
            percentile_50th: 3.0,
            percentile_75th: 3.0,
        },
        {
            distance: 140,
            percentile_25th: 6.0,
            percentile_50th: 6.0,
            percentile_75th: 6.0,
        },
        {
            distance: 150,
            percentile_25th: 0.0,
            percentile_50th: 0.0,
            percentile_75th: 0.0,
        },
        {
            distance: 160,
            percentile_25th: 3.25,
            percentile_50th: 4.5,
            percentile_75th: 5.75,
        },
        {
            distance: 170,
            percentile_25th: 13.75,
            percentile_50th: 22.5,
            percentile_75th: 29.0,
        },
        {
            distance: 180,
            percentile_25th: 8.0,
            percentile_50th: 8.0,
            percentile_75th: 14.0,
        },
        {
            distance: 190,
            percentile_25th: 16.0,
            percentile_50th: 21.0,
            percentile_75th: 23.75,
        },
        {
            distance: 200,
            percentile_25th: 18.0,
            percentile_50th: 23.5,
            percentile_75th: 33.0,
        },
        {
            distance: 210,
            percentile_25th: 13.0,
            percentile_50th: 18.0,
            percentile_75th: 23.0,
        },
        {
            distance: 220,
            percentile_25th: 24.5,
            percentile_50th: 30.5,
            percentile_75th: 37.5,
        },
        {
            distance: 230,
            percentile_25th: 12.5,
            percentile_50th: 22.0,
            percentile_75th: 51.0,
        },
        {
            distance: 240,
            percentile_25th: 0.0,
            percentile_50th: 0.0,
            percentile_75th: 0.0,
        },
    ],
    rough_dispersion: [
        {
            distance: 30,
            percentile_25th: 2.75,
            percentile_50th: 5.0,
            percentile_75th: 6.25,
        },
        {
            distance: 40,
            percentile_25th: 1.0,
            percentile_50th: 3.0,
            percentile_75th: 5.0,
        },
        {
            distance: 50,
            percentile_25th: 5.5,
            percentile_50th: 9.0,
            percentile_75th: 11.0,
        },
        {
            distance: 60,
            percentile_25th: 4.0,
            percentile_50th: 7.0,
            percentile_75th: 8.5,
        },
        {
            distance: 70,
            percentile_25th: 3.5,
            percentile_50th: 5.0,
            percentile_75th: 12.5,
        },
        {
            distance: 80,
            percentile_25th: 5.5,
            percentile_50th: 9.5,
            percentile_75th: 11.75,
        },
        {
            distance: 90,
            percentile_25th: 10.0,
            percentile_50th: 11.0,
            percentile_75th: 17.0,
        },
        {
            distance: 100,
            percentile_25th: 6.5,
            percentile_50th: 11.5,
            percentile_75th: 19.25,
        },
        {
            distance: 110,
            percentile_25th: 8.0,
            percentile_50th: 11.0,
            percentile_75th: 15.0,
        },
        {
            distance: 120,
            percentile_25th: 10.75,
            percentile_50th: 13.5,
            percentile_75th: 19.5,
        },
        {
            distance: 130,
            percentile_25th: 3.0,
            percentile_50th: 3.0,
            percentile_75th: 3.0,
        },
        {
            distance: 140,
            percentile_25th: 6.0,
            percentile_50th: 6.0,
            percentile_75th: 6.0,
        },
        {
            distance: 150,
            percentile_25th: 0.0,
            percentile_50th: 0.0,
            percentile_75th: 0.0,
        },
        {
            distance: 160,
            percentile_25th: 3.25,
            percentile_50th: 4.5,
            percentile_75th: 5.75,
        },
        {
            distance: 170,
            percentile_25th: 13.75,
            percentile_50th: 22.5,
            percentile_75th: 29.0,
        },
        {
            distance: 180,
            percentile_25th: 8.0,
            percentile_50th: 8.0,
            percentile_75th: 14.0,
        },
        {
            distance: 190,
            percentile_25th: 16.0,
            percentile_50th: 21.0,
            percentile_75th: 23.75,
        },
        {
            distance: 200,
            percentile_25th: 18.0,
            percentile_50th: 23.5,
            percentile_75th: 33.0,
        },
        {
            distance: 210,
            percentile_25th: 13.0,
            percentile_50th: 18.0,
            percentile_75th: 23.0,
        },
        {
            distance: 220,
            percentile_25th: 24.5,
            percentile_50th: 30.5,
            percentile_75th: 37.5,
        },
        {
            distance: 230,
            percentile_25th: 12.5,
            percentile_50th: 22.0,
            percentile_75th: 51.0,
        },
        {
            distance: 240,
            percentile_25th: 0.0,
            percentile_50th: 0.0,
            percentile_75th: 0.0,
        },
    ],
    driving_dispersion: null,
    around_green_dispersion: null,
};

export const SHOT_CHART_DEMO_DATA = [
    [7.778099999999999, -7.778099999999999],
    [-12, 0],
    [1.4142, 1.4142],
    [3.5355, -3.5355],
    [14, 0],
    [-6, 0],
    [-3, 0],
    [10, 0],
    [-3.5355, -3.5355],
    [0, -8],
    [7.778099999999999, 7.778099999999999],
    [-16.263299999999997, -16.263299999999997],
    [-4.9497, 4.9497],
    [-16, 0],
    [-3, 0],
    [-20, 0],
    [7, 0],
    [10, 0],
    [0, 0],
    [5, 0],
    [10, 0],
    [-32, 0],
    [-2.1212999999999997, -2.1212999999999997],
    [0, -29],
    [-36, 0],
    [0, 1],
    [0, 4],
    [-1, 0],
    [-14.142, -14.142],
    [-4.9497, -4.9497],
    [-10, 0],
    [4.9497, 4.9497],
    [8, 0],
    [-2.1212999999999997, 2.1212999999999997],
    [-7, 0],
    [0, 15],
    [0, 0],
    [0, 19],
    [0, -11],
    [7.778099999999999, 7.778099999999999],
    [-4.9497, 4.9497],
    [0, -16],
    [3.5355, -3.5355],
    [0, 1],
];
